import _ from 'lodash';

const localeToSettingsMap = {
  "en-US": {
    isDefault: true,
    settings: {
  "_id": "4KRGLSrqTRY6s18UzHe1II",
  "_contentTypeId": "settingsGlobal",
  "_modifiedDate": "2026-05-14T04:59:02.660Z",
  "internalTitle": "CX Learning Hub Global Settings",
  "topNavigationLogo": {
    "title": "Dropbox Logo",
    "url": "//images.ctfassets.net/zh1yxk5yn2r7/2z2Foc0s6DPlQV1aTtWO3b/b0c0e0a58102dd90281f7b1df860a370/Dropbox.svg",
    "size": 3707,
    "width": 324,
    "height": 64,
    "filename": "Dropbox.svg",
    "contentType": "image/svg+xml"
  },
  "mainNavigation": [
    {
      "internalTitle": "Footer Link - Help center",
      "linkText": "Help center",
      "destinationType": "Manual text entry",
      "trackingId": "learn-support-help-center",
      "_id": "5pPOxJP1W9PaPBCnLHhe5x",
      "_contentTypeId": "elementLink",
      "href": "https://help.dropbox.com",
      "as": null,
      "target": null,
      "isModal": false,
      "download": false
    },
    {
      "internalTitle": "Supernav - Dropbox Community",
      "linkText": "Community",
      "destinationType": "Manual text entry",
      "_id": "7aVH719lug9lYEJzIntabM",
      "_contentTypeId": "elementLink",
      "href": "https://community.dropbox.com/",
      "as": null,
      "target": "_blank",
      "isModal": false,
      "download": false
    },
    {
      "internalTitle": "Footer Link - Contact us",
      "linkText": "Contact us",
      "destinationType": "Manual text entry",
      "trackingId": "learn-support-contact-us",
      "_id": "5v3vwPdKulQu6xhA6csIT8",
      "_contentTypeId": "elementLink",
      "href": "https://www.dropbox.com/contact",
      "as": null,
      "target": null,
      "isModal": false,
      "download": false
    }
  ],
  "secondaryNavigation": [
    {
      "internalTitle": "Secondary Nav - Self-guided learning",
      "linkText": "Self-guided learning",
      "destinationType": "Content reference",
      "_id": "oMqs4whMJuBjhZsbMv0KA",
      "_contentTypeId": "elementLink",
      "href": "/[slug]",
      "as": "/self-guided-learning",
      "target": null,
      "isModal": false,
      "download": false
    },
    {
      "internalTitle": "Secondary Nav - Videos Landing Page",
      "linkText": "Video library",
      "destinationType": "Content reference",
      "_id": "5y8ArqrhCZ6DoCCGxaumhI",
      "_contentTypeId": "elementLink",
      "href": "/[slug]",
      "as": "/video-library",
      "target": null,
      "isModal": false,
      "download": false
    }
  ],
  "footerNavigation": [
    {
      "_id": "1M79uBMmyuD9Iw6fuOdVEJ",
      "_contentTypeId": "elementFooterNavColumn",
      "_modifiedDate": "2026-05-06T15:28:27.147Z",
      "internalTitle": "Dropbox",
      "links": [
        {
          "internalTitle": "Footer Link - Desktop app",
          "linkText": "Desktop app",
          "destinationType": "Manual text entry",
          "trackingId": "learn-dropbox-desktop-app",
          "_id": "3SKeLjF7MWEq2FqaRwnmiK",
          "_contentTypeId": "elementLink",
          "href": "https://www.dropbox.com/desktop",
          "as": null,
          "target": null,
          "isModal": false,
          "download": false
        },
        {
          "internalTitle": "Footer Link - Mobile app",
          "linkText": "Mobile app",
          "destinationType": "Manual text entry",
          "trackingId": "learn-dropbox-mobile-app",
          "_id": "62ymoNSBbWiYinBkFO0cGj",
          "_contentTypeId": "elementLink",
          "href": "https://www.dropbox.com/mobile",
          "as": null,
          "target": null,
          "isModal": false,
          "download": false
        },
        {
          "internalTitle": "Footer Link - Integrations",
          "linkText": "Integrations",
          "destinationType": "Manual text entry",
          "trackingId": "learn-dropbox-integrations",
          "_id": "5WEO1xpKelxpyXS50n3Dxc",
          "_contentTypeId": "elementLink",
          "href": "https://www.dropbox.com/app-integrations",
          "as": null,
          "target": null,
          "isModal": false,
          "download": false
        },
        {
          "internalTitle": "Footer Link - Features",
          "linkText": "Features",
          "destinationType": "Manual text entry",
          "trackingId": "learn-dropbox-features",
          "_id": "wUuQPtOLYz96QOSvtgLTh",
          "_contentTypeId": "elementLink",
          "href": "https://www.dropbox.com/features",
          "as": null,
          "target": null,
          "isModal": false,
          "download": false
        },
        {
          "internalTitle": "Footer Link - Solutions",
          "linkText": "Solutions",
          "destinationType": "Manual text entry",
          "trackingId": "learn-dropbox-solutions",
          "_id": "14SJorC6JrH7u2O5E8vf2E",
          "_contentTypeId": "elementLink",
          "href": "https://www.dropbox.com/business/solutions",
          "as": null,
          "target": null,
          "isModal": false,
          "download": false
        },
        {
          "internalTitle": "Footer Link - Security",
          "linkText": "Security",
          "destinationType": "Manual text entry",
          "trackingId": "learn-dropbox-security",
          "_id": "2YZlyLOZLw2lauy2OWiuB2",
          "_contentTypeId": "elementLink",
          "href": "https://www.dropbox.com/features/security",
          "as": null,
          "target": null,
          "isModal": false,
          "download": false
        },
        {
          "internalTitle": "Footer Link - Early access",
          "linkText": "Early access",
          "destinationType": "Manual text entry",
          "trackingId": "learn-dropbox-early-access",
          "_id": "6u2aXFqnr9s1KXkSjfc2cz",
          "_contentTypeId": "elementLink",
          "href": "https://www.dropbox.com/early-access",
          "as": null,
          "target": null,
          "isModal": false,
          "download": false
        },
        {
          "internalTitle": "Footer Link - Templates",
          "linkText": "Templates",
          "destinationType": "Manual text entry",
          "trackingId": "learn-dropbox-templates",
          "_id": "4yIX8tA1WW1soyk10Frgz5",
          "_contentTypeId": "elementLink",
          "href": "https://www.dropbox.com/templates",
          "as": null,
          "target": null,
          "isModal": false,
          "download": false
        },
        {
          "internalTitle": "Footer Link - Free tools",
          "linkText": "Free tools",
          "destinationType": "Manual text entry",
          "trackingId": "learn-dropbox-free-tools",
          "_id": "3Fdgsos4Pm77l2C4hKm2AC",
          "_contentTypeId": "elementLink",
          "href": "https://www.dropbox.com/tools",
          "as": null,
          "target": null,
          "isModal": false,
          "download": false
        }
      ]
    },
    {
      "_id": "6LXqBrZEH3p2eDbBpiPFlm",
      "_contentTypeId": "elementFooterNavColumn",
      "_modifiedDate": "2026-05-06T15:28:27.418Z",
      "internalTitle": "Products",
      "links": [
        {
          "internalTitle": "Footer Link - Plus",
          "linkText": "Plus",
          "destinationType": "Manual text entry",
          "trackingId": "learn-products-plus",
          "_id": "4nThAv7YjSuKC91UBK1AoR",
          "_contentTypeId": "elementLink",
          "href": "https://www.dropbox.com/plus",
          "as": null,
          "target": null,
          "isModal": false,
          "download": false
        },
        {
          "internalTitle": "Footer Link -  Professional",
          "linkText": "Professional",
          "destinationType": "Manual text entry",
          "trackingId": "learn-products-professional",
          "_id": "5YtdEKxrCJgHqmmDvwgnQI",
          "_contentTypeId": "elementLink",
          "href": "https://www.dropbox.com/pro",
          "as": null,
          "target": "_blank",
          "isModal": false,
          "download": false
        },
        {
          "internalTitle": "Footer Link - Business",
          "linkText": "Business",
          "destinationType": "Manual text entry",
          "trackingId": "learn-products-business",
          "_id": "5L4PFaY36Icmt95mUTgjOC",
          "_contentTypeId": "elementLink",
          "href": "https://www.dropbox.com/business",
          "as": null,
          "target": null,
          "isModal": false,
          "download": false
        },
        {
          "internalTitle": "Footer Link - Enterprise",
          "linkText": "Enterprise",
          "destinationType": "Manual text entry",
          "trackingId": "learn-products-enterprise",
          "_id": "4KJcgnikVfGiWIaFiuiRIM",
          "_contentTypeId": "elementLink",
          "href": "https://www.dropbox.com/enterprise",
          "as": null,
          "target": null,
          "isModal": false,
          "download": false
        },
        {
          "internalTitle": "Footer Link - Dash",
          "linkText": "Dash",
          "destinationType": "Manual text entry",
          "trackingId": "learn-products-dash",
          "_id": "4qdbH5UT1PZYVWp4vOADQa",
          "_contentTypeId": "elementLink",
          "href": "https://dash.dropbox.com",
          "as": null,
          "target": null,
          "isModal": false,
          "download": false
        },
        {
          "internalTitle": "Footer Link - DocSend",
          "linkText": "DocSend",
          "destinationType": "Manual text entry",
          "trackingId": "learn-products-docsend",
          "_id": "5hUjrT7Yza4eLKxBevHcAF",
          "_contentTypeId": "elementLink",
          "href": "https://www.docsend.com/?utm_medium=Referral&utm_source=Dropbox%20Web%20Referral&utm_campaign=dbx-footer",
          "as": null,
          "target": null,
          "isModal": false,
          "download": false
        },
        {
          "internalTitle": "Footer Link - Dropbox Sign",
          "linkText": "Dropbox Sign",
          "destinationType": "Manual text entry",
          "trackingId": "learn-products-sign",
          "_id": "4ennWEzf0rjxfCiNTEiU9w",
          "_contentTypeId": "elementLink",
          "href": "https://sign.dropbox.com",
          "as": null,
          "target": null,
          "isModal": false,
          "download": false
        },
        {
          "internalTitle": "Footer Link - Reclaim.ai",
          "linkText": "Reclaim.ai",
          "destinationType": "Manual text entry",
          "trackingId": "learn-products-reclaim-ai",
          "_id": "5XGB9J0ZeBff2lXEapKBR1",
          "_contentTypeId": "elementLink",
          "href": "https://app.reclaim.ai/signup?utm_medium=referral&utm_source=dbx-footer-referral&utm_campaign=dbx-footer-signup&utm_term=dbx-footer",
          "as": null,
          "target": null,
          "isModal": false,
          "download": false
        },
        {
          "internalTitle": "Footer Link - Plans",
          "linkText": "Plans",
          "destinationType": "Manual text entry",
          "trackingId": "learn-products-plans",
          "_id": "13TtJzOJV2eQoZ3TQbNVdd",
          "_contentTypeId": "elementLink",
          "href": "https://www.dropbox.com/plans",
          "as": null,
          "target": null,
          "isModal": false,
          "download": false
        },
        {
          "internalTitle": "Footer Link - Product updates",
          "linkText": "Product updates",
          "destinationType": "Manual text entry",
          "trackingId": "learn-products-updates",
          "_id": "45NCupQTJZJEBQ1r1pFDDf",
          "_contentTypeId": "elementLink",
          "href": "https://www.dropbox.com/product-updates",
          "as": null,
          "target": null,
          "isModal": false,
          "download": false
        }
      ]
    },
    {
      "_id": "74RyIf3Qiipq4XbcIPQQwT",
      "_contentTypeId": "elementFooterNavColumn",
      "_modifiedDate": "2026-05-06T15:28:27.829Z",
      "internalTitle": "Features",
      "links": [
        {
          "internalTitle": "Footer Link - Send large files",
          "linkText": "Send large files",
          "destinationType": "Manual text entry",
          "trackingId": "learn-features-send-large-files",
          "_id": "48eVY6niBIXx4YAPA4XKWz",
          "_contentTypeId": "elementLink",
          "href": "https://www.dropbox.com/features/share/send-large-files",
          "as": null,
          "target": null,
          "isModal": false,
          "download": false
        },
        {
          "internalTitle": "Footer Link - Send long videos",
          "linkText": "Send long videos",
          "destinationType": "Manual text entry",
          "trackingId": "learn-features-send-long-videos",
          "_id": "75e4Pf3aV5ZnB77zgoYITc",
          "_contentTypeId": "elementLink",
          "href": "https://www.dropbox.com/features/share/send-long-videos",
          "as": null,
          "target": null,
          "isModal": false,
          "download": false
        },
        {
          "internalTitle": "Footer Link - Cloud photo storage",
          "linkText": "Cloud photo storage",
          "destinationType": "Manual text entry",
          "trackingId": "learn-features-cloud-photo-storage",
          "_id": "64WyEAeXS80TWroqmR8eHy",
          "_contentTypeId": "elementLink",
          "href": "https://www.dropbox.com/features/cloud-storage/photos",
          "as": null,
          "target": null,
          "isModal": false,
          "download": false
        },
        {
          "internalTitle": "Footer Link - Secure file transfer",
          "linkText": "Secure file transfer",
          "destinationType": "Manual text entry",
          "trackingId": "learn-features-send-secure-file-transfer",
          "_id": "9bUiqp6kN7PfQDoP5dVEA",
          "_contentTypeId": "elementLink",
          "href": "https://www.dropbox.com/features/share/file-transfer",
          "as": null,
          "target": null,
          "isModal": false,
          "download": false
        },
        {
          "internalTitle": "Footer Link - Cloud backup",
          "linkText": "Cloud backup",
          "destinationType": "Manual text entry",
          "trackingId": "learn-features-cloud-backup",
          "_id": "4kYfwCJpM6hsTbLd622yzc",
          "_contentTypeId": "elementLink",
          "href": "https://www.dropbox.com/features/cloud-storage/file-backup",
          "as": null,
          "target": null,
          "isModal": false,
          "download": false
        },
        {
          "internalTitle": "Footer Link - Edit PDFs",
          "linkText": "Edit PDFs",
          "destinationType": "Manual text entry",
          "trackingId": "learn-features-edit-pdfs",
          "_id": "1Fw9zhaVelLXfOpxEQwsAy",
          "_contentTypeId": "elementLink",
          "href": "https://www.dropbox.com/features/productivity/pdf-editor",
          "as": null,
          "target": null,
          "isModal": false,
          "download": false
        },
        {
          "internalTitle": "Footer Link - Electronic signatures",
          "linkText": "Electronic signatures",
          "destinationType": "Manual text entry",
          "trackingId": "learn-features-electronic-signatures",
          "_id": "6nhjK34qVMZlkA2opn0vWj",
          "_contentTypeId": "elementLink",
          "href": "https://www.dropbox.com/features/productivity/electronic-signature",
          "as": null,
          "target": null,
          "isModal": false,
          "download": false
        },
        {
          "internalTitle": "Footer Link - Convert to PDF",
          "linkText": "Convert to PDF",
          "destinationType": "Manual text entry",
          "trackingId": "learn-features-convert-to-pdf",
          "_id": "4a7MNYwiyhj6OtmYb87co0",
          "_contentTypeId": "elementLink",
          "href": "https://www.dropbox.com/features/productivity/convert-to-pdf",
          "as": null,
          "target": null,
          "isModal": false,
          "download": false
        }
      ]
    },
    {
      "_id": "1TnZWWGdwo9BEkEKgcIGpA",
      "_contentTypeId": "elementFooterNavColumn",
      "_modifiedDate": "2026-05-06T15:28:27.248Z",
      "internalTitle": "Support",
      "links": [
        {
          "internalTitle": "Footer Link - Help center",
          "linkText": "Help center",
          "destinationType": "Manual text entry",
          "trackingId": "learn-support-help-center",
          "_id": "5pPOxJP1W9PaPBCnLHhe5x",
          "_contentTypeId": "elementLink",
          "href": "https://help.dropbox.com",
          "as": null,
          "target": null,
          "isModal": false,
          "download": false
        },
        {
          "internalTitle": "Footer Link - Contact us",
          "linkText": "Contact us",
          "destinationType": "Manual text entry",
          "trackingId": "learn-support-contact-us",
          "_id": "5v3vwPdKulQu6xhA6csIT8",
          "_contentTypeId": "elementLink",
          "href": "https://www.dropbox.com/contact",
          "as": null,
          "target": null,
          "isModal": false,
          "download": false
        },
        {
          "internalTitle": "Footer Link - Privacy & terms",
          "linkText": "Privacy & terms",
          "destinationType": "Manual text entry",
          "trackingId": "learn-support-privacy-terms",
          "_id": "30MJJnJ2DIcvhYL2wsg0FB",
          "_contentTypeId": "elementLink",
          "href": "https://www.dropbox.com/terms",
          "as": null,
          "target": null,
          "isModal": false,
          "download": false
        },
        {
          "internalTitle": "Footer Link - Cookie policy",
          "linkText": "Cookie policy",
          "destinationType": "Manual text entry",
          "trackingId": "learn-support-cookie-policy",
          "_id": "3akG8gNhd73ZlRaEYSCvUD",
          "_contentTypeId": "elementLink",
          "href": "https://help.dropbox.com/security/cookies",
          "as": null,
          "target": null,
          "isModal": false,
          "download": false
        },
        {
          "internalTitle": "Footer Link - Cookies & CCPA preferences",
          "linkText": "Cookies & CCPA preferences",
          "destinationType": "Manual text entry",
          "trackingId": "learn-support-cookies-CCPA",
          "_id": "65mwIIQg9xKeyKiICuy9DJ",
          "_contentTypeId": "elementLink",
          "href": "https://www.dropbox.com/app-integrations#manage-cookies",
          "as": null,
          "target": null,
          "isModal": false,
          "download": false
        },
        {
          "internalTitle": "Footer Link - AI principles",
          "linkText": "AI principles",
          "destinationType": "Manual text entry",
          "trackingId": "learn-support-ai-principles",
          "_id": "5mTsyPahdNgokTvducSB9i",
          "_contentTypeId": "elementLink",
          "href": "https://www.dropbox.com/ai-principles",
          "as": null,
          "target": null,
          "isModal": false,
          "download": false
        },
        {
          "internalTitle": "Footer Link - Sitemap",
          "linkText": "Sitemap",
          "destinationType": "Manual text entry",
          "trackingId": "learn-support-sitemap",
          "_id": "37byNy2Pux5TAcdSJm6g4f",
          "_contentTypeId": "elementLink",
          "href": "https://experience.dropbox.com/sitemap",
          "as": null,
          "target": null,
          "isModal": false,
          "download": false
        },
        {
          "internalTitle": "Footer Link - Learning resources",
          "linkText": "Learning resources",
          "destinationType": "Manual text entry",
          "trackingId": "learn-support-learning-resources",
          "_id": "Gj2OgkkQcCs8BXTBr5Irc",
          "_contentTypeId": "elementLink",
          "href": "https://learn.dropbox.com",
          "as": null,
          "target": null,
          "isModal": false,
          "download": false
        }
      ]
    },
    {
      "_id": "28o2jcc5DrafqCYZ9icYU7",
      "_contentTypeId": "elementFooterNavColumn",
      "_modifiedDate": "2026-05-06T15:28:26.982Z",
      "internalTitle": "Resources",
      "links": [
        {
          "internalTitle": "Footer Link - Blog",
          "linkText": "Blog",
          "destinationType": "Manual text entry",
          "trackingId": "learn-resources-blog",
          "_id": "4vYa3RKqQLWA8bNHcaPX69",
          "_contentTypeId": "elementLink",
          "href": "https://blog.dropbox.com",
          "as": null,
          "target": null,
          "isModal": false,
          "download": false
        },
        {
          "internalTitle": "Footer Link - Events",
          "linkText": "Events",
          "destinationType": "Manual text entry",
          "trackingId": "learn-resources-events",
          "_id": "2D8JKIOdP8zjqZCfsqIG5l",
          "_contentTypeId": "elementLink",
          "href": "https://events.dropbox.com/",
          "as": null,
          "target": null,
          "isModal": false,
          "download": false
        },
        {
          "internalTitle": "Footer Link - Customer stories",
          "linkText": "Customer stories",
          "destinationType": "Manual text entry",
          "trackingId": "learn-resources-customer-stories",
          "_id": "49GkLGyFuV1GvXf1DozTPZ",
          "_contentTypeId": "elementLink",
          "href": "https://www.dropbox.com/customers",
          "as": null,
          "target": null,
          "isModal": false,
          "download": false
        },
        {
          "internalTitle": "Footer Link - Resources library",
          "linkText": "Resources library",
          "destinationType": "Manual text entry",
          "trackingId": "learn-resources-resources-library",
          "_id": "3l98eLMkEyPoj0jzqgBvj7",
          "_contentTypeId": "elementLink",
          "href": "https://www.dropbox.com/resources",
          "as": null,
          "target": null,
          "isModal": false,
          "download": false
        },
        {
          "internalTitle": "Footer Link - Developers",
          "linkText": "Developers",
          "destinationType": "Manual text entry",
          "trackingId": "learn-resources-developers",
          "_id": "2aFb3GcSJS0YIEU3aKbLzj",
          "_contentTypeId": "elementLink",
          "href": "https://www.dropbox.com/developers",
          "as": null,
          "target": null,
          "isModal": false,
          "download": false
        },
        {
          "internalTitle": "Footer Link - Community forums",
          "linkText": "Community forums",
          "destinationType": "Manual text entry",
          "trackingId": "learn-resources-community-forums",
          "_id": "4IGtm6twVWzfoE07kHlucc",
          "_contentTypeId": "elementLink",
          "href": "https://community.dropbox.com",
          "as": null,
          "target": null,
          "isModal": false,
          "download": false
        },
        {
          "internalTitle": "Footer Link - Referrals",
          "linkText": "Referrals",
          "destinationType": "Manual text entry",
          "trackingId": "learn-resources-referrals",
          "_id": "4YsKqwQfAG4Ds0a0yeo9wp",
          "_contentTypeId": "elementLink",
          "href": "https://www.dropbox.com/refer",
          "as": null,
          "target": null,
          "isModal": false,
          "download": false
        },
        {
          "internalTitle": "Footer Link - Reseller partners",
          "linkText": "Reseller partners",
          "destinationType": "Manual text entry",
          "trackingId": "learn-resources-reseller-partners",
          "_id": "1w7KmWfsigadpZje40tk18",
          "_contentTypeId": "elementLink",
          "href": "https://www.dropbox.com/business/partners",
          "as": null,
          "target": null,
          "isModal": false,
          "download": false
        },
        {
          "internalTitle": "Footer Link - Integration partners",
          "linkText": "Integration partners",
          "destinationType": "Manual text entry",
          "trackingId": "learn-resources-integration-partners",
          "_id": "6dgcNUDLbEeXQE94s71vrO",
          "_contentTypeId": "elementLink",
          "href": "https://www.dropbox.com/app-integrations",
          "as": null,
          "target": null,
          "isModal": false,
          "download": false
        },
        {
          "internalTitle": "Footer Link - Find a partner",
          "linkText": "Find a partner",
          "destinationType": "Manual text entry",
          "trackingId": "learn-resources-find-a-partner",
          "_id": "2wQU48ntbukgQSKuTKS9in",
          "_contentTypeId": "elementLink",
          "href": "https://experience.dropbox.com/partner-locator",
          "as": null,
          "target": null,
          "isModal": false,
          "download": false
        }
      ]
    },
    {
      "_id": "5xRp5jjLsl92vmGL0qJfVb",
      "_contentTypeId": "elementFooterNavColumn",
      "_modifiedDate": "2026-05-06T15:28:26.948Z",
      "internalTitle": "Company",
      "links": [
        {
          "internalTitle": "Footer Link - About us",
          "linkText": "About us",
          "destinationType": "Manual text entry",
          "trackingId": "learn-company-about-us",
          "_id": "6XnBD8OrJfQZ4u3ZSc6ysr",
          "_contentTypeId": "elementLink",
          "href": "https://www.dropbox.com/about",
          "as": null,
          "target": null,
          "isModal": false,
          "download": false
        },
        {
          "internalTitle": "Footer Link - Jobs",
          "linkText": "Jobs",
          "destinationType": "Manual text entry",
          "trackingId": "learn-company-jobs",
          "_id": "1nmf2X1QaLv7zS1PIyfqlE",
          "_contentTypeId": "elementLink",
          "href": "https://jobs.dropbox.com",
          "as": null,
          "target": null,
          "isModal": false,
          "download": false
        },
        {
          "internalTitle": "Footer Link - Investor relations",
          "linkText": "Investor relations",
          "destinationType": "Manual text entry",
          "trackingId": "learn-company-investor-relations",
          "_id": "73WTKUyXSmqc5aP1OfisZ9",
          "_contentTypeId": "elementLink",
          "href": "https://dropbox.gcs-web.com/",
          "as": null,
          "target": null,
          "isModal": false,
          "download": false
        },
        {
          "internalTitle": "Footer Link - Corporate responsibility",
          "linkText": "Corporate responsibility",
          "destinationType": "Manual text entry",
          "trackingId": "learn-company-corporate-responsibility",
          "_id": "5iMgmL64RXCXtz8iRkrIIM",
          "_contentTypeId": "elementLink",
          "href": "https://www.dropbox.com/corporate-responsibility",
          "as": null,
          "target": null,
          "isModal": false,
          "download": false
        }
      ]
    }
  ],
  "cookieBarBody": "We use cookies so that Dropbox works for you. By using our website, you agree to our use of cookies.",
  "cookieBarCta": {
    "internalTitle": "Link Text - Cookie bar",
    "linkText": "Learn more",
    "destinationType": "Manual text entry",
    "_id": "1tY3PGTzdIHKRi4pDNbmSM",
    "_contentTypeId": "elementLink",
    "href": "https://help.dropbox.com/accounts-billing/security/cookies",
    "as": null,
    "target": "_blank",
    "isModal": false,
    "download": false
  },
  "cookieBarEnabled": true,
  "virtualTrainingsEmptyState": {
    "data": {},
    "content": [
      {
        "data": {},
        "content": [
          {
            "data": {},
            "marks": [],
            "value": "Nothing to see yet—register for a ",
            "nodeType": "text"
          },
          {
            "data": {
              "target": null
            },
            "content": [
              {
                "data": {},
                "marks": [],
                "value": "virtual training session",
                "nodeType": "text"
              }
            ],
            "nodeType": "entry-hyperlink"
          },
          {
            "data": {},
            "marks": [],
            "value": ".",
            "nodeType": "text"
          }
        ],
        "nodeType": "paragraph"
      }
    ],
    "nodeType": "document"
  },
  "completedCoursesEmptyState": {
    "data": {},
    "content": [
      {
        "data": {},
        "content": [
          {
            "data": {},
            "marks": [],
            "value": "Courses you’ve completed will appear here.",
            "nodeType": "text"
          }
        ],
        "nodeType": "paragraph"
      }
    ],
    "nodeType": "document"
  },
  "inProgressCoursesEmptyState": {
    "data": {},
    "content": [
      {
        "data": {},
        "content": [
          {
            "data": {},
            "marks": [],
            "value": "Nothing to see yet—start a ",
            "nodeType": "text"
          },
          {
            "data": {
              "target": {
                "_id": "75pzFP9abHFb2hlQycUS86",
                "_contentTypeId": "pageLanding",
                "_href": "/[slug]",
                "_as": "/self-guided-learning",
                "_modifiedDate": "2026-07-14T14:56:10.933Z",
                "internalTitle": "L2 - Landing page - Self-guided learning",
                "name": "Self-guided learning",
                "slug": "self-guided-learning",
                "introHero": {
                  "_id": "6pQlpoBglvzGW38DBWvU5W",
                  "_contentTypeId": "moduleHero",
                  "_modifiedDate": "2026-05-15T16:06:56.370Z",
                  "internalTitle": "Hero - Self-guided learning",
                  "headerText": "Self-guided learning",
                  "summaryText": "Explore guided courses for Dropbox, Dash, Replay, Sign, and more. Choose the one that matches what you need to do, from getting started to managing your team.",
                  "image": {
                    "title": "Self-Guided Learning Illustration",
                    "description": "Book illustration for Dropbox's self-guided learning courses",
                    "url": "//images.ctfassets.net/zh1yxk5yn2r7/6ODZb6bllZrucIYtiLqFkU/f844e955cabc76e34e249d9c18e43d62/self-guided-learning.svg",
                    "size": 42902,
                    "width": 405,
                    "height": 310,
                    "filename": "self-guided-learning.svg",
                    "contentType": "image/svg+xml"
                  }
                },
                "contentSections": [
                  {
                    "_id": "6MGcQfM5kOFGpBqiOmSkKy",
                    "_contentTypeId": "moduleFeaturedCourse",
                    "_modifiedDate": "2026-11-05T12:58:40.480Z",
                    "internalTitle": "Featured - Self-guided learning",
                    "title": "Featured course",
                    "course": null
                  },
                  {
                    "_id": "4JIWsH681XIFek4zmBB6Ix",
                    "_contentTypeId": "moduleMultiColumnCourses",
                    "_modifiedDate": "2026-11-05T12:58:40.355Z",
                    "internalTitle": "All courses - Self-guided learning - Cards",
                    "title": "All courses",
                    "courses": []
                  }
                ],
                "seo": {
                  "title": {
                    "name": "title",
                    "value": "Dropbox self-guided training courses | Dropbox learn"
                  },
                  "robots": {
                    "name": "robots",
                    "value": "index,follow"
                  },
                  "keywords": {
                    "name": "keywords",
                    "value": ""
                  },
                  "og:image": {
                    "name": "og:image",
                    "value": {
                      "id": "33cKbUcUgjCOB3aPxkIMGq",
                      "url": "https://images.ctfassets.net/zh1yxk5yn2r7/33cKbUcUgjCOB3aPxkIMGq/14cdd574f957e960f0972f73a80a892e/hoop.png",
                      "title": "hoop"
                    }
                  },
                  "description": {
                    "name": "description",
                    "value": "Self-paced Dropbox training courses, available for free and on-demand. Learn how to use your Dropbox account at your own pace. Sign up today."
                  },
                  "twitter:title": {
                    "name": "twitter:title",
                    "value": "Dropbox"
                  }
                }
              }
            },
            "content": [
              {
                "data": {},
                "marks": [],
                "value": "self-guided learning course",
                "nodeType": "text"
              }
            ],
            "nodeType": "entry-hyperlink"
          },
          {
            "data": {},
            "marks": [],
            "value": ".",
            "nodeType": "text"
          }
        ],
        "nodeType": "paragraph"
      }
    ],
    "nodeType": "document"
  },
  "l18nLookup": {
    "see": "See",
    "noData": "No results found",
    "textHr": "hr",
    "filters": "Filters",
    "modules": "Modules",
    "results": "results",
    "textHrs": "hrs",
    "textMin": "min",
    "clearall": "Clear all filters",
    "continue": "Continue",
    "featured": "Featured",
    "textHour": "hour",
    "textLess": "Less",
    "textMins": "mins",
    "textMore": "More",
    "textRead": "Read",
    "allvidoes": "All videos",
    "labelTags": "Tags",
    "learnText": "Learn",
    "startdemo": "Start demo",
    "textClear": "Clear",
    "textHours": "hours",
    "useStacks": "How to use stacks",
    "findCourse": "Find a course",
    "textMinute": "minute",
    "transcript": "Transcript",
    "ctaTextBack": "Back",
    "ctaTextNext": "Next",
    "filterstext": "Filters",
    "joinUrlText": "Join Session",
    "moreAnswers": "for more resources.",
    "noCouresYet": "No courses yet",
    "readingTime": "minute read",
    "textMinutes": "minutes",
    "textSeeMore": "View more",
    "textViewAll": "View All",
    "alltutorials": "all tutorials",
    "ctaTextLogIn": "Log in",
    "noresultText": "Try different keywords or browse",
    "searchHeader": "Search",
    "textComplete": "Complete",
    "textError404": "Error (404)",
    "textFilterBy": "Filter",
    "videolibrary": "Video library",
    "browseKeyword": "try different keywords, or browse",
    "ctaTextLogout": "Sign out",
    "ctaTextSignIn": "Sign in",
    "labelSubjects": "Subjects",
    "moreTutorials": "More tutorials",
    "popUpBodyText": "You just completed the Dropbox business admin course!",
    "textNextTopic": "Next module",
    "trackProgress": "Start a course to track your progress here.",
    "ctaTextProfile": "My profile",
    "ctaTextVirtual": "View session",
    "headerDuration": "Duration",
    "languageNameDe": "Deutsch",
    "languageNameEs": "Español",
    "languageNameFr": "Français",
    "languageNameIt": "Italiano",
    "languageNameJa": "日本語",
    "matchingsearch": "We couldn’t find anything that matches your search.",
    "viewAllCourses": "View all courses",
    "ctaTextRegister": "Register now",
    "labelCategories": "Categories",
    "searchNoResults": "No results for {{search}}",
    "textStartCourse": "Start course",
    "textWebinarFull": "This webinar is full, please try a different time or day.",
    "accountLabelLast": "Last",
    "accountLabelName": "Name",
    "ctaCreateAccount": "Create account",
    "languageNameEnUs": "English",
    "languageNamePtBr": "Português",
    "searchBreadcrumb": "Search results",
    "searchFilterRole": "Role",
    "textErrorUnknown": "Something went wrong",
    "textResumeCourse": "Resume course",
    "accountLabelEmail": "Email",
    "ctaTextReschedule": "Reschedule",
    "ctaTextSelfGuided": "View modules",
    "ctaTextViewCourse": "View course",
    "formLabelAttended": "Attended",
    "headerAccountInfo": "Account info",
    "textErrorPageHome": "Home",
    "textPreviousTopic": "Previous",
    "ctaTextCancelClass": "Cancel this class",
    "formInputLabelDate": "Date",
    "headerPersonalInfo": "Personal info",
    "labelSubcategories": "Subcategories",
    "searchResultStatus": "results found",
    "selfguidedLearning": "Self-guided learning",
    "textBreadcrumbRoot": "Dropbox learn",
    "textCourseProgress": "Course progress",
    "formInputLabelEmail": "Email",
    "globalTextCopyright": "Copyright text",
    "signInpopUpBodyText": "Keep track of the modules you complete",
    "textDropdownDefault": "Times are set to your time zone",
    "textErrorPageSignIn": "Sign in",
    "textTableOfContents": "modules",
    "canceledRegistration": "Registration canceled successfully",
    "formInputLabelCourse": "Course",
    "formInputLabelStatus": "Status",
    "searchFilterLanguage": "Language",
    "searchResultsPerPage": "Results per page",
    "textSigninModalIntro": "Sign in to save your progress",
    "topicCountTextPlural": "Topics",
    "topicCountTextSingle": "Topic",
    "headerSuggestedTopics": "Suggested modules",
    "searchFilterOptionSgc": "Self-paced course",
    "searchResultTypeTopic": "Module",
    "searchResultTypeVideo": "Video",
    "textAlreadyRegistered": "You have already registered for this webinar.",
    "textYouMustLogInFirst": "You must sign in first",
    "formInputLabelAttendee": "Attendee",
    "formInputLabelLastName": "Last name",
    "formInputLabelOverview": "Overview",
    "headerEventDescription": "Session description",
    "headerProfileCompleted": "Completed",
    "searchFilterOptionLive": "Live session",
    "searchFilterOptionTeam": "Team member",
    "textCourseExpectations": "What to expect:",
    "textLearningObjectives": "What you’ll learn",
    "formInputLabelFirstName": "First name",
    "headerProfileInProgress": " In progress",
    "pageVideoCategoriesSync": "Sync",
    "searchFilterContentType": "Content type",
    "searchFilterOptionAdmin": "Admin",
    "searchFilterOptionTopic": "Module",
    "searchPageTitleMetadata": "Search | Dropbox Learn",
    "textErrorPageHelpCenter": "Help center",
    "formInputLabelSelectDate": "Select a date",
    "formInputLabelSelectTime": "Select a time",
    "headerProfileLiveCourses": "Upcoming courses",
    "pageVideoCategoriesShare": "Share",
    "formInputLabelSessionLink": "Session link",
    "textErrorPageHelpfulLinks": "Here are some helpful links:",
    "textErrorPagePageNotFound": "We can't find the page you're looking for",
    "textRegistrationCompleted": "You’re registered",
    "breadcrumbTextRegistration": "Registration",
    "formInputLabelPickLanguage": "Select your language",
    "pageVideoCategoriesWebinar": "Webinar",
    "searchPageKeywordsMetadata": "search",
    "searchResultTypeSelfGuided": "Course",
    "ctaTextCompleteRegistration": "Complete your registration",
    "headerEnterRegistrationInfo": "Enter your registration info",
    "headerRegisteredLiveCourses": "Registered virtual trainings",
    "pageVideoCategoriesInstalls": "Installs",
    "pageVideoCategoriesOrganize": "Organize",
    "pageVideoCategoriesProducts": "Products",
    "pageVideoCategoriesSecurity": "Security",
    "searchFilterOptionRoleAdmin": "Admin",
    "searchResultTypeLiveSession": "Live session",
    "headerRegistrationSuccessful": "You’ve successfully registered",
    "headerSearchInputPlaceholder": "Search",
    "pageVideoSubcategoriesDelete": "Delete",
    "pageVideoSubcategoriesReplay": "Replay",
    "pageVideoSubcategoriesRewind": "Rewind",
    "pageVideoSubcategoriesSignIn": "Sign in",
    "searchFilterOptionIndividual": "Individual",
    "formInputLabelCourseCompleted": "Course completed",
    "pageVideoSubcategoriesCapture": "Capture",
    "pageVideoSubcategoriesRestore": "Restore",
    "searchPageDescriptionMetadata": "You can search for modules or information to find out more about our courses. Find the right Dropbox training or self-guided learning for your needs.",
    "pageVideoCategoriesViewAndEdit": "View and edit",
    "pageVideoSubcategoriesTransfer": "Transfer",
    "searchFilterOptionRoleHelpDesk": "Help Desk",
    "textCalendarShortWeekdayFriday": "Fri",
    "textCalendarShortWeekdayMonday": "Mon",
    "textCalendarShortWeekdaySunday": "Sun",
    "pageVideoSubcategoriesMobileApp": "Mobile app",
    "textCalendarShortWeekdayTuesday": "Tue",
    "textEmailConfirmationWillBeSent": "Check your inbox for an email confirmation.",
    "headerLiveCourseHighlightsHeader": "You’ll learn how to:",
    "pageVideoCategoriesAccountAccess": "Account access",
    "pageVideoSubcategoriesTeamAccess": "Team access",
    "searchFilterOptionRoleTeamMember": "Team Member",
    "textCalendarShortWeekdaySaturday": "Sat",
    "textCalendarShortWeekdayThursday": "Thu",
    "formInputLabelGeneralRegistration": "General registration",
    "pageVideoSubcategoriesDropboxDash": "Dropbox Dash",
    "pageVideoSubcategoriesTeamFolders": "Team folders",
    "textCalendarShortWeekdayWednesday": "Wed",
    "formInputLabelGlobalSelectLanguage": "Select a language",
    "formInputLabelSelectDateBreadcrumb": "Select date",
    "pageVideoCategoriesAccountSettings": "Account settings",
    "pageVideoCategoriesCreateAndUpload": "Create and upload",
    "pageVideoSubcategoriesTeamSecurity": "Team security",
    "searchFilterOptionRoleFundamentals": "Fundamentals",
    "pageVideoCategoriesDeleteAndRestore": "Delete and restore",
    "pageCourseTopicTableOfContentsHeading": "Sections in this article",
    "pageVideoSubcategoriesDropboxPolicies": "Dropbox policies",
    "pageVideoSubcategoriesOnDemandTraining": "On-demand training",
    "pageVideoSubcategoriesCommentingOnFiles": "Commenting on files",
    "pageVideoSubcategoriesSharingPermissions": "Sharing permissions",
    "pageVideoSubcategoriesDropboxApplications": "Dropbox applications",
    "pageVideoSubcategoriesSearchingYourAccount": "Searching your account",
    "pageVideoSubcategoriesManagingAccountAccess": "Managing account access",
    "pageVideoSubcategoriesSharingFilesAndFolders": "Sharing files and folders",
    "pageVideoSubcategoriesCreatingFilesAndFolders": "Creating files and folders"
  },
  "copyrightText": "Dropbox 2021",
  "seo": {
    "title": {
      "name": "title",
      "value": "Dropbox learn"
    },
    "keywords": {
      "name": "keywords",
      "value": ""
    },
    "og:image": {
      "name": "og:image",
      "value": {
        "id": "2z2Foc0s6DPlQV1aTtWO3b",
        "url": "https://images.ctfassets.net/zh1yxk5yn2r7/2z2Foc0s6DPlQV1aTtWO3b/b0c0e0a58102dd90281f7b1df860a370/Dropbox.svg",
        "title": "Dropbox Logo"
      }
    },
    "og:title": {
      "name": "og:title",
      "value": "Dropbox learn"
    },
    "canonical": {
      "name": "canonical",
      "value": ""
    },
    "description": {
      "name": "description",
      "value": "Learn how to use Dropbox. Browse our catalog of free self-guided courses and virtual instructor led training sessions. Start a Dropbox training course today."
    },
    "twitter:image": {
      "name": "twitter:image",
      "value": {
        "id": "2z2Foc0s6DPlQV1aTtWO3b",
        "url": "https://images.ctfassets.net/zh1yxk5yn2r7/2z2Foc0s6DPlQV1aTtWO3b/b0c0e0a58102dd90281f7b1df860a370/Dropbox.svg",
        "title": "Dropbox Logo"
      }
    },
    "twitter:title": {
      "name": "twitter:title",
      "value": "Dropbox learn"
    },
    "og:description": {
      "name": "og:description",
      "value": "Learn how to use Dropbox. Browse our catalog of free self-guided courses and virtual instructor led training sessions. Start a Dropbox training course today."
    },
    "twitter:description": {
      "name": "twitter:description",
      "value": "Learn how to use Dropbox. Browse our catalog of free self-guided courses and virtual instructor led training sessions. Start a Dropbox training course today."
    }
  },
  "seoOrganizationsSchema": {
    "url": "http://www.dropbox.com",
    "@type": "Organization",
    "@context": "http://schema.org",
    "contactPoint": [
      {
        "@type": "ContactPoint",
        "telephone": "+1-888-888-8888",
        "areaServed": "US",
        "contactType": "customer service",
        "contactOption": "TollFree"
      },
      {
        "@type": "ContactPoint",
        "telephone": "+1-888-888-8888",
        "contactType": "customer service"
      },
      {
        "@type": "ContactPoint",
        "telephone": "+1-888-888-8888",
        "areaServed": "US",
        "contactType": "customer service",
        "contactOption": [
          "HearingImpairedSupported",
          "TollFree"
        ]
      },
      {
        "@type": "ContactPoint",
        "telephone": "+1-888-888-8888",
        "areaServed": [
          "US",
          "CA"
        ],
        "contactType": "technical support",
        "contactOption": "TollFree",
        "availableLanguage": [
          "English",
          "French"
        ]
      },
      {
        "@type": "ContactPoint",
        "telephone": "+1-888-888-8888",
        "areaServed": [
          "US",
          "CA"
        ],
        "contactType": "bill payment",
        "contactOption": "TollFree"
      }
    ]
  }
}
  },
  "fr": {
    isDefault: false,
    settings: {
  "_id": "4KRGLSrqTRY6s18UzHe1II",
  "_contentTypeId": "settingsGlobal",
  "_modifiedDate": "2026-05-14T04:59:02.660Z",
  "internalTitle": "CX Learning Hub Global Settings",
  "topNavigationLogo": {
    "title": "Dropbox Logo",
    "url": "//images.ctfassets.net/zh1yxk5yn2r7/2z2Foc0s6DPlQV1aTtWO3b/b0c0e0a58102dd90281f7b1df860a370/Dropbox.svg",
    "size": 3707,
    "width": 324,
    "height": 64,
    "filename": "Dropbox.svg",
    "contentType": "image/svg+xml"
  },
  "mainNavigation": [
    {
      "internalTitle": "Footer Link - Help center",
      "linkText": "Centre d’assistance",
      "destinationType": "Manual text entry",
      "trackingId": "learn-support-help-center",
      "_id": "5pPOxJP1W9PaPBCnLHhe5x",
      "_contentTypeId": "elementLink",
      "href": "https://help.dropbox.com",
      "as": null,
      "target": null,
      "isModal": false,
      "download": false
    },
    {
      "internalTitle": "Supernav - Dropbox Community",
      "linkText": "Communauté",
      "destinationType": "Manual text entry",
      "_id": "7aVH719lug9lYEJzIntabM",
      "_contentTypeId": "elementLink",
      "href": "https://community.dropbox.com/",
      "as": null,
      "target": "_blank",
      "isModal": false,
      "download": false
    },
    {
      "internalTitle": "Footer Link - Contact us",
      "linkText": "Nous contacter",
      "destinationType": "Manual text entry",
      "trackingId": "learn-support-contact-us",
      "_id": "5v3vwPdKulQu6xhA6csIT8",
      "_contentTypeId": "elementLink",
      "href": "https://www.dropbox.com/contact",
      "as": null,
      "target": null,
      "isModal": false,
      "download": false
    }
  ],
  "secondaryNavigation": [
    {
      "internalTitle": "Secondary Nav - Self-guided learning",
      "linkText": "Autoformation",
      "destinationType": "Content reference",
      "_id": "oMqs4whMJuBjhZsbMv0KA",
      "_contentTypeId": "elementLink",
      "href": "/[slug]",
      "as": "/self-guided-learning",
      "target": null,
      "isModal": false,
      "download": false
    },
    {
      "internalTitle": "Secondary Nav - Videos Landing Page",
      "linkText": "Vidéos",
      "destinationType": "Content reference",
      "_id": "5y8ArqrhCZ6DoCCGxaumhI",
      "_contentTypeId": "elementLink",
      "href": "/[slug]",
      "as": "/video-library",
      "target": null,
      "isModal": false,
      "download": false
    }
  ],
  "footerNavigation": [
    {
      "_id": "1M79uBMmyuD9Iw6fuOdVEJ",
      "_contentTypeId": "elementFooterNavColumn",
      "_modifiedDate": "2026-05-06T15:28:27.147Z",
      "internalTitle": "Dropbox",
      "links": [
        {
          "internalTitle": "Footer Link - Desktop app",
          "linkText": "Application de bureau",
          "destinationType": "Manual text entry",
          "trackingId": "learn-dropbox-desktop-app",
          "_id": "3SKeLjF7MWEq2FqaRwnmiK",
          "_contentTypeId": "elementLink",
          "href": "https://www.dropbox.com/desktop",
          "as": null,
          "target": null,
          "isModal": false,
          "download": false
        },
        {
          "internalTitle": "Footer Link - Mobile app",
          "linkText": "Application mobile",
          "destinationType": "Manual text entry",
          "trackingId": "learn-dropbox-mobile-app",
          "_id": "62ymoNSBbWiYinBkFO0cGj",
          "_contentTypeId": "elementLink",
          "href": "https://www.dropbox.com/mobile",
          "as": null,
          "target": null,
          "isModal": false,
          "download": false
        },
        {
          "internalTitle": "Footer Link - Integrations",
          "linkText": "Integrations",
          "destinationType": "Manual text entry",
          "trackingId": "learn-dropbox-integrations",
          "_id": "5WEO1xpKelxpyXS50n3Dxc",
          "_contentTypeId": "elementLink",
          "href": "https://www.dropbox.com/app-integrations",
          "as": null,
          "target": null,
          "isModal": false,
          "download": false
        },
        {
          "internalTitle": "Footer Link - Features",
          "linkText": "Fonctionnalités",
          "destinationType": "Manual text entry",
          "trackingId": "learn-dropbox-features",
          "_id": "wUuQPtOLYz96QOSvtgLTh",
          "_contentTypeId": "elementLink",
          "href": "https://www.dropbox.com/features",
          "as": null,
          "target": null,
          "isModal": false,
          "download": false
        },
        {
          "internalTitle": "Footer Link - Solutions",
          "linkText": "Solutions",
          "destinationType": "Manual text entry",
          "trackingId": "learn-dropbox-solutions",
          "_id": "14SJorC6JrH7u2O5E8vf2E",
          "_contentTypeId": "elementLink",
          "href": "https://www.dropbox.com/business/solutions",
          "as": null,
          "target": null,
          "isModal": false,
          "download": false
        },
        {
          "internalTitle": "Footer Link - Security",
          "linkText": "Sécurité",
          "destinationType": "Manual text entry",
          "trackingId": "learn-dropbox-security",
          "_id": "2YZlyLOZLw2lauy2OWiuB2",
          "_contentTypeId": "elementLink",
          "href": "https://www.dropbox.com/features/security",
          "as": null,
          "target": null,
          "isModal": false,
          "download": false
        },
        {
          "internalTitle": "Footer Link - Early access",
          "linkText": "Accès en avant-première",
          "destinationType": "Manual text entry",
          "trackingId": "learn-dropbox-early-access",
          "_id": "6u2aXFqnr9s1KXkSjfc2cz",
          "_contentTypeId": "elementLink",
          "href": "https://www.dropbox.com/early-access",
          "as": null,
          "target": null,
          "isModal": false,
          "download": false
        },
        {
          "internalTitle": "Footer Link - Templates",
          "linkText": "Templates",
          "destinationType": "Manual text entry",
          "trackingId": "learn-dropbox-templates",
          "_id": "4yIX8tA1WW1soyk10Frgz5",
          "_contentTypeId": "elementLink",
          "href": "https://www.dropbox.com/templates",
          "as": null,
          "target": null,
          "isModal": false,
          "download": false
        },
        {
          "internalTitle": "Footer Link - Free tools",
          "linkText": "Outils gratuits",
          "destinationType": "Manual text entry",
          "trackingId": "learn-dropbox-free-tools",
          "_id": "3Fdgsos4Pm77l2C4hKm2AC",
          "_contentTypeId": "elementLink",
          "href": "https://www.dropbox.com/tools",
          "as": null,
          "target": null,
          "isModal": false,
          "download": false
        }
      ]
    },
    {
      "_id": "6LXqBrZEH3p2eDbBpiPFlm",
      "_contentTypeId": "elementFooterNavColumn",
      "_modifiedDate": "2026-05-06T15:28:27.418Z",
      "internalTitle": "Produits",
      "links": [
        {
          "internalTitle": "Footer Link - Plus",
          "linkText": "Plus",
          "destinationType": "Manual text entry",
          "trackingId": "learn-products-plus",
          "_id": "4nThAv7YjSuKC91UBK1AoR",
          "_contentTypeId": "elementLink",
          "href": "https://www.dropbox.com/plus",
          "as": null,
          "target": null,
          "isModal": false,
          "download": false
        },
        {
          "internalTitle": "Footer Link -  Professional",
          "linkText": "Professional",
          "destinationType": "Manual text entry",
          "trackingId": "learn-products-professional",
          "_id": "5YtdEKxrCJgHqmmDvwgnQI",
          "_contentTypeId": "elementLink",
          "href": "https://www.dropbox.com/pro",
          "as": null,
          "target": "_blank",
          "isModal": false,
          "download": false
        },
        {
          "internalTitle": "Footer Link - Business",
          "linkText": "Business",
          "destinationType": "Manual text entry",
          "trackingId": "learn-products-business",
          "_id": "5L4PFaY36Icmt95mUTgjOC",
          "_contentTypeId": "elementLink",
          "href": "https://www.dropbox.com/business",
          "as": null,
          "target": null,
          "isModal": false,
          "download": false
        },
        {
          "internalTitle": "Footer Link - Enterprise",
          "linkText": "Enterprise",
          "destinationType": "Manual text entry",
          "trackingId": "learn-products-enterprise",
          "_id": "4KJcgnikVfGiWIaFiuiRIM",
          "_contentTypeId": "elementLink",
          "href": "https://www.dropbox.com/enterprise",
          "as": null,
          "target": null,
          "isModal": false,
          "download": false
        },
        {
          "internalTitle": "Footer Link - Dash",
          "linkText": "Dash",
          "destinationType": "Manual text entry",
          "trackingId": "learn-products-dash",
          "_id": "4qdbH5UT1PZYVWp4vOADQa",
          "_contentTypeId": "elementLink",
          "href": "https://dash.dropbox.com",
          "as": null,
          "target": null,
          "isModal": false,
          "download": false
        },
        {
          "internalTitle": "Footer Link - DocSend",
          "linkText": "DocSend",
          "destinationType": "Manual text entry",
          "trackingId": "learn-products-docsend",
          "_id": "5hUjrT7Yza4eLKxBevHcAF",
          "_contentTypeId": "elementLink",
          "href": "https://www.docsend.com/?utm_medium=Referral&utm_source=Dropbox%20Web%20Referral&utm_campaign=dbx-footer",
          "as": null,
          "target": null,
          "isModal": false,
          "download": false
        },
        {
          "internalTitle": "Footer Link - Dropbox Sign",
          "linkText": "Signe Dropbox",
          "destinationType": "Manual text entry",
          "trackingId": "learn-products-sign",
          "_id": "4ennWEzf0rjxfCiNTEiU9w",
          "_contentTypeId": "elementLink",
          "href": "https://sign.dropbox.com",
          "as": null,
          "target": null,
          "isModal": false,
          "download": false
        },
        {
          "internalTitle": "Footer Link - Reclaim.ai",
          "linkText": "Reclaim.ai",
          "destinationType": "Manual text entry",
          "trackingId": "learn-products-reclaim-ai",
          "_id": "5XGB9J0ZeBff2lXEapKBR1",
          "_contentTypeId": "elementLink",
          "href": "https://app.reclaim.ai/signup?utm_medium=referral&utm_source=dbx-footer-referral&utm_campaign=dbx-footer-signup&utm_term=dbx-footer",
          "as": null,
          "target": null,
          "isModal": false,
          "download": false
        },
        {
          "internalTitle": "Footer Link - Plans",
          "linkText": "Forfaits",
          "destinationType": "Manual text entry",
          "trackingId": "learn-products-plans",
          "_id": "13TtJzOJV2eQoZ3TQbNVdd",
          "_contentTypeId": "elementLink",
          "href": "https://www.dropbox.com/plans",
          "as": null,
          "target": null,
          "isModal": false,
          "download": false
        },
        {
          "internalTitle": "Footer Link - Product updates",
          "linkText": "Product updates",
          "destinationType": "Manual text entry",
          "trackingId": "learn-products-updates",
          "_id": "45NCupQTJZJEBQ1r1pFDDf",
          "_contentTypeId": "elementLink",
          "href": "https://www.dropbox.com/product-updates",
          "as": null,
          "target": null,
          "isModal": false,
          "download": false
        }
      ]
    },
    {
      "_id": "74RyIf3Qiipq4XbcIPQQwT",
      "_contentTypeId": "elementFooterNavColumn",
      "_modifiedDate": "2026-05-06T15:28:27.829Z",
      "internalTitle": "Features",
      "links": [
        {
          "internalTitle": "Footer Link - Send large files",
          "linkText": "Envoi de fichiers volumineux",
          "destinationType": "Manual text entry",
          "trackingId": "learn-features-send-large-files",
          "_id": "48eVY6niBIXx4YAPA4XKWz",
          "_contentTypeId": "elementLink",
          "href": "https://www.dropbox.com/features/share/send-large-files",
          "as": null,
          "target": null,
          "isModal": false,
          "download": false
        },
        {
          "internalTitle": "Footer Link - Send long videos",
          "linkText": "Envoyer de longues vidéos",
          "destinationType": "Manual text entry",
          "trackingId": "learn-features-send-long-videos",
          "_id": "75e4Pf3aV5ZnB77zgoYITc",
          "_contentTypeId": "elementLink",
          "href": "https://www.dropbox.com/features/share/send-long-videos",
          "as": null,
          "target": null,
          "isModal": false,
          "download": false
        },
        {
          "internalTitle": "Footer Link - Cloud photo storage",
          "linkText": "Stockage de photos dans le cloud",
          "destinationType": "Manual text entry",
          "trackingId": "learn-features-cloud-photo-storage",
          "_id": "64WyEAeXS80TWroqmR8eHy",
          "_contentTypeId": "elementLink",
          "href": "https://www.dropbox.com/features/cloud-storage/photos",
          "as": null,
          "target": null,
          "isModal": false,
          "download": false
        },
        {
          "internalTitle": "Footer Link - Secure file transfer",
          "linkText": "Transfert de fichiers sécurisé",
          "destinationType": "Manual text entry",
          "trackingId": "learn-features-send-secure-file-transfer",
          "_id": "9bUiqp6kN7PfQDoP5dVEA",
          "_contentTypeId": "elementLink",
          "href": "https://www.dropbox.com/features/share/file-transfer",
          "as": null,
          "target": null,
          "isModal": false,
          "download": false
        },
        {
          "internalTitle": "Footer Link - Cloud backup",
          "linkText": "Cloud backup",
          "destinationType": "Manual text entry",
          "trackingId": "learn-features-cloud-backup",
          "_id": "4kYfwCJpM6hsTbLd622yzc",
          "_contentTypeId": "elementLink",
          "href": "https://www.dropbox.com/features/cloud-storage/file-backup",
          "as": null,
          "target": null,
          "isModal": false,
          "download": false
        },
        {
          "internalTitle": "Footer Link - Edit PDFs",
          "linkText": "Edit PDFs",
          "destinationType": "Manual text entry",
          "trackingId": "learn-features-edit-pdfs",
          "_id": "1Fw9zhaVelLXfOpxEQwsAy",
          "_contentTypeId": "elementLink",
          "href": "https://www.dropbox.com/features/productivity/pdf-editor",
          "as": null,
          "target": null,
          "isModal": false,
          "download": false
        },
        {
          "internalTitle": "Footer Link - Electronic signatures",
          "linkText": "Electronic signatures",
          "destinationType": "Manual text entry",
          "trackingId": "learn-features-electronic-signatures",
          "_id": "6nhjK34qVMZlkA2opn0vWj",
          "_contentTypeId": "elementLink",
          "href": "https://www.dropbox.com/features/productivity/electronic-signature",
          "as": null,
          "target": null,
          "isModal": false,
          "download": false
        },
        {
          "internalTitle": "Footer Link - Convert to PDF",
          "linkText": "Convert to PDF",
          "destinationType": "Manual text entry",
          "trackingId": "learn-features-convert-to-pdf",
          "_id": "4a7MNYwiyhj6OtmYb87co0",
          "_contentTypeId": "elementLink",
          "href": "https://www.dropbox.com/features/productivity/convert-to-pdf",
          "as": null,
          "target": null,
          "isModal": false,
          "download": false
        }
      ]
    },
    {
      "_id": "1TnZWWGdwo9BEkEKgcIGpA",
      "_contentTypeId": "elementFooterNavColumn",
      "_modifiedDate": "2026-05-06T15:28:27.248Z",
      "internalTitle": "Assistance",
      "links": [
        {
          "internalTitle": "Footer Link - Help center",
          "linkText": "Centre d’assistance",
          "destinationType": "Manual text entry",
          "trackingId": "learn-support-help-center",
          "_id": "5pPOxJP1W9PaPBCnLHhe5x",
          "_contentTypeId": "elementLink",
          "href": "https://help.dropbox.com",
          "as": null,
          "target": null,
          "isModal": false,
          "download": false
        },
        {
          "internalTitle": "Footer Link - Contact us",
          "linkText": "Nous contacter",
          "destinationType": "Manual text entry",
          "trackingId": "learn-support-contact-us",
          "_id": "5v3vwPdKulQu6xhA6csIT8",
          "_contentTypeId": "elementLink",
          "href": "https://www.dropbox.com/contact",
          "as": null,
          "target": null,
          "isModal": false,
          "download": false
        },
        {
          "internalTitle": "Footer Link - Privacy & terms",
          "linkText": "Confidentialité et conditions",
          "destinationType": "Manual text entry",
          "trackingId": "learn-support-privacy-terms",
          "_id": "30MJJnJ2DIcvhYL2wsg0FB",
          "_contentTypeId": "elementLink",
          "href": "https://www.dropbox.com/terms",
          "as": null,
          "target": null,
          "isModal": false,
          "download": false
        },
        {
          "internalTitle": "Footer Link - Cookie policy",
          "linkText": "Politique en matière de cookies",
          "destinationType": "Manual text entry",
          "trackingId": "learn-support-cookie-policy",
          "_id": "3akG8gNhd73ZlRaEYSCvUD",
          "_contentTypeId": "elementLink",
          "href": "https://help.dropbox.com/security/cookies",
          "as": null,
          "target": null,
          "isModal": false,
          "download": false
        },
        {
          "internalTitle": "Footer Link - Cookies & CCPA preferences",
          "linkText": "Préférences concernant les cookies et CCPA",
          "destinationType": "Manual text entry",
          "trackingId": "learn-support-cookies-CCPA",
          "_id": "65mwIIQg9xKeyKiICuy9DJ",
          "_contentTypeId": "elementLink",
          "href": "https://www.dropbox.com/app-integrations#manage-cookies",
          "as": null,
          "target": null,
          "isModal": false,
          "download": false
        },
        {
          "internalTitle": "Footer Link - AI principles",
          "linkText": "AI principles",
          "destinationType": "Manual text entry",
          "trackingId": "learn-support-ai-principles",
          "_id": "5mTsyPahdNgokTvducSB9i",
          "_contentTypeId": "elementLink",
          "href": "https://www.dropbox.com/ai-principles",
          "as": null,
          "target": null,
          "isModal": false,
          "download": false
        },
        {
          "internalTitle": "Footer Link - Sitemap",
          "linkText": "Plan du site",
          "destinationType": "Manual text entry",
          "trackingId": "learn-support-sitemap",
          "_id": "37byNy2Pux5TAcdSJm6g4f",
          "_contentTypeId": "elementLink",
          "href": "https://experience.dropbox.com/sitemap",
          "as": null,
          "target": null,
          "isModal": false,
          "download": false
        },
        {
          "internalTitle": "Footer Link - Learning resources",
          "linkText": "Ressources d’apprentissage",
          "destinationType": "Manual text entry",
          "trackingId": "learn-support-learning-resources",
          "_id": "Gj2OgkkQcCs8BXTBr5Irc",
          "_contentTypeId": "elementLink",
          "href": "https://learn.dropbox.com",
          "as": null,
          "target": null,
          "isModal": false,
          "download": false
        }
      ]
    },
    {
      "_id": "28o2jcc5DrafqCYZ9icYU7",
      "_contentTypeId": "elementFooterNavColumn",
      "_modifiedDate": "2026-05-06T15:28:26.982Z",
      "internalTitle": "Ressources",
      "links": [
        {
          "internalTitle": "Footer Link - Blog",
          "linkText": "Blog",
          "destinationType": "Manual text entry",
          "trackingId": "learn-resources-blog",
          "_id": "4vYa3RKqQLWA8bNHcaPX69",
          "_contentTypeId": "elementLink",
          "href": "https://blog.dropbox.com",
          "as": null,
          "target": null,
          "isModal": false,
          "download": false
        },
        {
          "internalTitle": "Footer Link - Events",
          "linkText": "Events",
          "destinationType": "Manual text entry",
          "trackingId": "learn-resources-events",
          "_id": "2D8JKIOdP8zjqZCfsqIG5l",
          "_contentTypeId": "elementLink",
          "href": "https://events.dropbox.com/",
          "as": null,
          "target": null,
          "isModal": false,
          "download": false
        },
        {
          "internalTitle": "Footer Link - Customer stories",
          "linkText": "Customer stories",
          "destinationType": "Manual text entry",
          "trackingId": "learn-resources-customer-stories",
          "_id": "49GkLGyFuV1GvXf1DozTPZ",
          "_contentTypeId": "elementLink",
          "href": "https://www.dropbox.com/customers",
          "as": null,
          "target": null,
          "isModal": false,
          "download": false
        },
        {
          "internalTitle": "Footer Link - Resources library",
          "linkText": "Resources library",
          "destinationType": "Manual text entry",
          "trackingId": "learn-resources-resources-library",
          "_id": "3l98eLMkEyPoj0jzqgBvj7",
          "_contentTypeId": "elementLink",
          "href": "https://www.dropbox.com/resources",
          "as": null,
          "target": null,
          "isModal": false,
          "download": false
        },
        {
          "internalTitle": "Footer Link - Developers",
          "linkText": "développeurs",
          "destinationType": "Manual text entry",
          "trackingId": "learn-resources-developers",
          "_id": "2aFb3GcSJS0YIEU3aKbLzj",
          "_contentTypeId": "elementLink",
          "href": "https://www.dropbox.com/developers",
          "as": null,
          "target": null,
          "isModal": false,
          "download": false
        },
        {
          "internalTitle": "Footer Link - Community forums",
          "linkText": "Forums de la communauté",
          "destinationType": "Manual text entry",
          "trackingId": "learn-resources-community-forums",
          "_id": "4IGtm6twVWzfoE07kHlucc",
          "_contentTypeId": "elementLink",
          "href": "https://community.dropbox.com",
          "as": null,
          "target": null,
          "isModal": false,
          "download": false
        },
        {
          "internalTitle": "Footer Link - Referrals",
          "linkText": "Parrainages",
          "destinationType": "Manual text entry",
          "trackingId": "learn-resources-referrals",
          "_id": "4YsKqwQfAG4Ds0a0yeo9wp",
          "_contentTypeId": "elementLink",
          "href": "https://www.dropbox.com/refer",
          "as": null,
          "target": null,
          "isModal": false,
          "download": false
        },
        {
          "internalTitle": "Footer Link - Reseller partners",
          "linkText": "Revendeurs",
          "destinationType": "Manual text entry",
          "trackingId": "learn-resources-reseller-partners",
          "_id": "1w7KmWfsigadpZje40tk18",
          "_contentTypeId": "elementLink",
          "href": "https://www.dropbox.com/business/partners",
          "as": null,
          "target": null,
          "isModal": false,
          "download": false
        },
        {
          "internalTitle": "Footer Link - Integration partners",
          "linkText": "Integration partners",
          "destinationType": "Manual text entry",
          "trackingId": "learn-resources-integration-partners",
          "_id": "6dgcNUDLbEeXQE94s71vrO",
          "_contentTypeId": "elementLink",
          "href": "https://www.dropbox.com/app-integrations",
          "as": null,
          "target": null,
          "isModal": false,
          "download": false
        },
        {
          "internalTitle": "Footer Link - Find a partner",
          "linkText": "Trouver un partenaire",
          "destinationType": "Manual text entry",
          "trackingId": "learn-resources-find-a-partner",
          "_id": "2wQU48ntbukgQSKuTKS9in",
          "_contentTypeId": "elementLink",
          "href": "https://experience.dropbox.com/partner-locator",
          "as": null,
          "target": null,
          "isModal": false,
          "download": false
        }
      ]
    },
    {
      "_id": "5xRp5jjLsl92vmGL0qJfVb",
      "_contentTypeId": "elementFooterNavColumn",
      "_modifiedDate": "2026-05-06T15:28:26.948Z",
      "internalTitle": "Entreprise :",
      "links": [
        {
          "internalTitle": "Footer Link - About us",
          "linkText": "À propos de Dropbox",
          "destinationType": "Manual text entry",
          "trackingId": "learn-company-about-us",
          "_id": "6XnBD8OrJfQZ4u3ZSc6ysr",
          "_contentTypeId": "elementLink",
          "href": "https://www.dropbox.com/about",
          "as": null,
          "target": null,
          "isModal": false,
          "download": false
        },
        {
          "internalTitle": "Footer Link - Jobs",
          "linkText": "Recrutement",
          "destinationType": "Manual text entry",
          "trackingId": "learn-company-jobs",
          "_id": "1nmf2X1QaLv7zS1PIyfqlE",
          "_contentTypeId": "elementLink",
          "href": "https://jobs.dropbox.com",
          "as": null,
          "target": null,
          "isModal": false,
          "download": false
        },
        {
          "internalTitle": "Footer Link - Investor relations",
          "linkText": "Relations avec les investisseurs",
          "destinationType": "Manual text entry",
          "trackingId": "learn-company-investor-relations",
          "_id": "73WTKUyXSmqc5aP1OfisZ9",
          "_contentTypeId": "elementLink",
          "href": "https://dropbox.gcs-web.com/",
          "as": null,
          "target": null,
          "isModal": false,
          "download": false
        },
        {
          "internalTitle": "Footer Link - Corporate responsibility",
          "linkText": "Responsabilité d’entreprise",
          "destinationType": "Manual text entry",
          "trackingId": "learn-company-corporate-responsibility",
          "_id": "5iMgmL64RXCXtz8iRkrIIM",
          "_contentTypeId": "elementLink",
          "href": "https://www.dropbox.com/corporate-responsibility",
          "as": null,
          "target": null,
          "isModal": false,
          "download": false
        }
      ]
    }
  ],
  "cookieBarBody": "Nous utilisons des cookies afin de vous permettre d’utiliser Dropbox. En utilisant notre site, vous acceptez notre utilisation des cookies.",
  "cookieBarCta": {
    "internalTitle": "Link Text - Cookie bar",
    "linkText": "En savoir plus",
    "destinationType": "Manual text entry",
    "_id": "1tY3PGTzdIHKRi4pDNbmSM",
    "_contentTypeId": "elementLink",
    "href": "https://help.dropbox.com/accounts-billing/security/cookies",
    "as": null,
    "target": "_blank",
    "isModal": false,
    "download": false
  },
  "cookieBarEnabled": true,
  "virtualTrainingsEmptyState": {
    "data": {},
    "content": [
      {
        "data": {},
        "content": [
          {
            "data": {},
            "marks": [],
            "value": "Rien à afficher pour l’instant. Inscrivez-vous à une ",
            "nodeType": "text"
          },
          {
            "data": {
              "target": null
            },
            "content": [
              {
                "data": {},
                "marks": [],
                "value": "session de formation virtuelle",
                "nodeType": "text"
              }
            ],
            "nodeType": "entry-hyperlink"
          },
          {
            "data": {},
            "marks": [],
            "value": ".",
            "nodeType": "text"
          }
        ],
        "nodeType": "paragraph"
      }
    ],
    "nodeType": "document"
  },
  "completedCoursesEmptyState": {
    "data": {},
    "content": [
      {
        "data": {},
        "content": [
          {
            "data": {},
            "marks": [],
            "value": "Les cours que vous avez terminés apparaîtront ici.",
            "nodeType": "text"
          }
        ],
        "nodeType": "paragraph"
      }
    ],
    "nodeType": "document"
  },
  "inProgressCoursesEmptyState": {
    "data": {},
    "content": [
      {
        "data": {},
        "content": [
          {
            "data": {},
            "marks": [],
            "value": "Rien à afficher pour l’instant. Commencez un ",
            "nodeType": "text"
          },
          {
            "data": {
              "target": {
                "_id": "75pzFP9abHFb2hlQycUS86",
                "_contentTypeId": "pageLanding",
                "_href": "/[slug]",
                "_as": "/self-guided-learning",
                "_modifiedDate": "2026-07-14T14:56:10.933Z",
                "internalTitle": "L2 - Landing page - Self-guided learning",
                "name": "Autoformation",
                "slug": "self-guided-learning",
                "introHero": {
                  "_id": "6pQlpoBglvzGW38DBWvU5W",
                  "_contentTypeId": "moduleHero",
                  "_modifiedDate": "2026-05-15T16:06:56.370Z",
                  "internalTitle": "Hero - Self-guided learning",
                  "headerText": "Autoformation",
                  "summaryText": "Découvrez les cours guidés pour Dropbox, Dash, Replay, Sign et plus encore. Choisissez le plus adapté à vos besoins, de la prise en main à la gestion d’équipe.\n",
                  "image": {
                    "title": "Self-Guided Learning Illustration",
                    "description": "Book illustration for Dropbox's self-guided learning courses",
                    "url": "//images.ctfassets.net/zh1yxk5yn2r7/6ODZb6bllZrucIYtiLqFkU/f844e955cabc76e34e249d9c18e43d62/self-guided-learning.svg",
                    "size": 42902,
                    "width": 405,
                    "height": 310,
                    "filename": "self-guided-learning.svg",
                    "contentType": "image/svg+xml"
                  }
                },
                "contentSections": [
                  {
                    "_id": "6MGcQfM5kOFGpBqiOmSkKy",
                    "_contentTypeId": "moduleFeaturedCourse",
                    "_modifiedDate": "2026-11-05T12:58:40.480Z",
                    "internalTitle": "Featured - Self-guided learning",
                    "title": "Cours à la une",
                    "course": null
                  },
                  {
                    "_id": "4JIWsH681XIFek4zmBB6Ix",
                    "_contentTypeId": "moduleMultiColumnCourses",
                    "_modifiedDate": "2026-11-05T12:58:40.355Z",
                    "internalTitle": "All courses - Self-guided learning - Cards",
                    "title": "Tous les cours",
                    "courses": []
                  }
                ],
                "seo": {
                  "title": {
                    "name": "title",
                    "value": "Cours d’autoformation Dropbox | Découvrir Dropbox"
                  },
                  "keywords": {
                    "name": "keywords",
                    "value": ""
                  },
                  "og:image": {
                    "name": "og:image",
                    "value": {
                      "id": "33cKbUcUgjCOB3aPxkIMGq",
                      "url": "https://images.ctfassets.net/zh1yxk5yn2r7/33cKbUcUgjCOB3aPxkIMGq/14cdd574f957e960f0972f73a80a892e/hoop.png",
                      "title": "hoop"
                    }
                  },
                  "description": {
                    "name": "description",
                    "value": "Des formations Dropbox à votre propre rythme, disponibles gratuitement et à la demande. Découvrez comment utiliser votre compte Dropbox à votre propre rythme. Inscrivez-vous dès aujourd’hui."
                  },
                  "twitter:title": {
                    "name": "twitter:title",
                    "value": "Dropbox"
                  }
                }
              }
            },
            "content": [
              {
                "data": {},
                "marks": [],
                "value": "cours d’autoformation",
                "nodeType": "text"
              }
            ],
            "nodeType": "entry-hyperlink"
          },
          {
            "data": {},
            "marks": [],
            "value": ".",
            "nodeType": "text"
          }
        ],
        "nodeType": "paragraph"
      }
    ],
    "nodeType": "document"
  },
  "l18nLookup": {
    "see": "Consultez ce",
    "noData": "Aucun résultat trouvé.",
    "textHr": "h",
    "filters": "Filtres",
    "modules": "Modules",
    "results": "Résultats",
    "textHrs": "h",
    "textMin": "min",
    "clearall": "Réinitialiser tous les filtres",
    "continue": "Continuer",
    "featured": "Mis en avant",
    "textHour": "heure",
    "textLess": "Moins",
    "textMins": "min",
    "textMore": "Plus",
    "textRead": "Lues",
    "allvidoes": "Toutes les vidéos",
    "labelTags": "Mentions",
    "learnText": "Découvrir",
    "startdemo": "Lancer la démonstration",
    "textClear": "Effacer",
    "textHours": "Heures",
    "useStacks": "Comment utiliser les piles",
    "findCourse": "Trouver un cours",
    "textMinute": "minute",
    "transcript": "Transcription",
    "ctaTextBack": "Retour",
    "ctaTextNext": "Suivant",
    "filterstext": "Filtres",
    "joinUrlText": "Rejoindre la session",
    "moreAnswers": "pour consulter d’autres ressources.",
    "noCouresYet": "Aucun cours pour l’instant",
    "readingTime": "minutes de lecture",
    "textMinutes": "minutes",
    "textSeeMore": "Voir plus",
    "textViewAll": "Tout afficher",
    "alltutorials": "tous les tutoriels",
    "ctaTextLogIn": "Connexion",
    "noresultText": "Essayez d’autres mots-clés ou parcourez les résultats",
    "searchHeader": "Rechercher",
    "textComplete": "Terminé",
    "textError404": "Erreur (404)",
    "textFilterBy": "Filtrer",
    "videolibrary": "Bibliothèque de vidéos",
    "browseKeyword": "essayez d’autres mots-clés ou parcourez les résultats",
    "ctaTextLogout": "Se déconnecter",
    "ctaTextSignIn": "Se connecter",
    "labelSubjects": "Objet",
    "moreTutorials": "Plus de tutoriels",
    "popUpBodyText": "Vous venez de terminer le cours destiné aux administrateurs Dropbox Business !",
    "textNextTopic": "Module suivant",
    "trackProgress": "Suivez votre progression ici après avoir démarré un cours.",
    "ctaTextProfile": "Mon profil",
    "ctaTextVirtual": "Afficher la session",
    "headerDuration": "Durée",
    "languageNameDe": "Deutsch",
    "languageNameEs": "Español",
    "languageNameFr": "Français",
    "languageNameIt": "Italiano",
    "languageNameJa": "日本語",
    "matchingsearch": "Nous n’avons trouvé aucun résultat correspondant à votre recherche.",
    "viewAllCourses": "Afficher toutes les formations",
    "ctaTextRegister": "S’inscrire maintenant",
    "labelCategories": "Rubriques",
    "searchNoResults": "Aucun résultat pour {{search}}",
    "textStartCourse": "Commencer le cours",
    "textWebinarFull": "Ce webinaire est complet. Veuillez sélectionner un autre jour ou une autre heure.",
    "accountLabelLast": "Nom",
    "accountLabelName": "Nom",
    "ctaCreateAccount": "Créer un compte",
    "languageNameEnUs": "Anglais",
    "languageNamePtBr": "Português",
    "searchBreadcrumb": "Résultats de la recherche",
    "searchFilterRole": "Fonction",
    "textErrorUnknown": "Un problème est survenu.",
    "textResumeCourse": "Reprendre le cours",
    "accountLabelEmail": "E‑mail",
    "ctaTextReschedule": "Changer la date",
    "ctaTextSelfGuided": "Afficher les modules",
    "ctaTextViewCourse": "Afficher le cours",
    "formLabelAttended": "A participé",
    "headerAccountInfo": "Infos sur le compte",
    "textErrorPageHome": "Accueil",
    "textPreviousTopic": "Précédent",
    "ctaTextCancelClass": "Annuler ce cours",
    "formInputLabelDate": "Date",
    "headerPersonalInfo": "Informations personnelles",
    "labelSubcategories": "Sous-catégories",
    "searchResultStatus": "résultats trouvés",
    "selfguidedLearning": "Autoformation",
    "textBreadcrumbRoot": "Découvrir Dropbox",
    "textCourseProgress": "Progression dans le cours",
    "formInputLabelEmail": "E‑mail",
    "globalTextCopyright": "Texte sur le copyright",
    "signInpopUpBodyText": "Conservez un historique des modules que vous avez suivis",
    "textDropdownDefault": "Les heures sont définies en fonction de votre fuseau horaire",
    "textErrorPageSignIn": "Se connecter",
    "textTableOfContents": "Modules",
    "canceledRegistration": "L’inscription a bien été annulée.",
    "formInputLabelCourse": "Cours",
    "formInputLabelStatus": "État",
    "searchFilterLanguage": "Langue",
    "searchResultsPerPage": "Résultats par page",
    "textSigninModalIntro": "Connectez-vous pour enregistrer votre progression",
    "topicCountTextPlural": "Thèmes",
    "topicCountTextSingle": "sujet",
    "headerSuggestedTopics": "Modules proposés",
    "searchFilterOptionSgc": "Un cours à votre propre rythme",
    "searchResultTypeTopic": "Module",
    "searchResultTypeVideo": "Vidéo",
    "textAlreadyRegistered": "Vous êtes déjà inscrit à ce webinaire.",
    "textYouMustLogInFirst": "Vous devez d’abord vous connecter",
    "formInputLabelAttendee": "Participant",
    "formInputLabelLastName": "Nom",
    "formInputLabelOverview": "Présentation",
    "headerEventDescription": "Description de la session",
    "headerProfileCompleted": "Terminé",
    "searchFilterOptionLive": "Session en direct",
    "searchFilterOptionTeam": "Membres de l’équipe",
    "textCourseExpectations": "Nouveautés :",
    "textLearningObjectives": "Dans cette formation, vous découvrirez :",
    "formInputLabelFirstName": "Prénom",
    "headerProfileInProgress": " En cours",
    "pageVideoCategoriesSync": "Synchronisation",
    "searchFilterContentType": "Type de contenu",
    "searchFilterOptionAdmin": "Administrateur",
    "searchFilterOptionTopic": "Module",
    "searchPageTitleMetadata": "Recherche | Découvrir Dropbox",
    "textErrorPageHelpCenter": "Centre d’assistance",
    "formInputLabelSelectDate": "Sélectionnez une date",
    "formInputLabelSelectTime": "Sélectionner une heure",
    "headerProfileLiveCourses": "Prochains cours",
    "pageVideoCategoriesShare": "Partager",
    "formInputLabelSessionLink": "Lien vers la session",
    "textErrorPageHelpfulLinks": "Voici quelques liens utiles :",
    "textErrorPagePageNotFound": "Nous ne trouvons pas la page que vous cherchez",
    "textRegistrationCompleted": "Votre inscription a été réalisée",
    "breadcrumbTextRegistration": "Inscription",
    "formInputLabelPickLanguage": "Sélectionnez votre langue",
    "pageVideoCategoriesWebinar": "Webinaire",
    "searchPageKeywordsMetadata": "rechercher",
    "searchResultTypeSelfGuided": "Cours",
    "ctaTextCompleteRegistration": "Terminez votre inscription",
    "headerEnterRegistrationInfo": "Saisissez vos informations d’inscription",
    "headerRegisteredLiveCourses": "Formations virtuelles enregistrées",
    "pageVideoCategoriesInstalls": "Installation",
    "pageVideoCategoriesOrganize": "Organiser",
    "pageVideoCategoriesProducts": "Produits",
    "pageVideoCategoriesSecurity": "Sécurité",
    "searchFilterOptionRoleAdmin": "Administrateur",
    "searchResultTypeLiveSession": "Session en direct",
    "headerRegistrationSuccessful": "Votre inscription a été réalisée correctement",
    "headerSearchInputPlaceholder": "Rechercher",
    "pageVideoSubcategoriesDelete": "Supprimer",
    "pageVideoSubcategoriesReplay": "Replay",
    "pageVideoSubcategoriesRewind": "Reculer",
    "pageVideoSubcategoriesSignIn": "Se connecter",
    "searchFilterOptionIndividual": "Particulier",
    "formInputLabelCourseCompleted": "Cours achevé",
    "pageVideoSubcategoriesCapture": "Capture",
    "pageVideoSubcategoriesRestore": "Restaurer",
    "searchPageDescriptionMetadata": "Vous pouvez rechercher des modules ou des informations pour en savoir plus sur nos cours. Trouvez la formation ou l’autoformation Dropbox adaptée à vos besoins.",
    "pageVideoCategoriesViewAndEdit": "Consulter et modifier",
    "pageVideoSubcategoriesTransfer": "Transfer",
    "searchFilterOptionRoleHelpDesk": "Service d’assistance",
    "textCalendarShortWeekdayFriday": "Ven",
    "textCalendarShortWeekdayMonday": "Lun",
    "textCalendarShortWeekdaySunday": "Dim",
    "pageVideoSubcategoriesMobileApp": "Application mobile",
    "textCalendarShortWeekdayTuesday": "Mar",
    "textEmailConfirmationWillBeSent": "Un e-mail de confirmation vous a été envoyé. Veuillez consulter votre boîte de réception.",
    "headerLiveCourseHighlightsHeader": "Vous découvrirez comment :",
    "pageVideoCategoriesAccountAccess": "Accès au compte",
    "pageVideoSubcategoriesTeamAccess": "Accès accordés à l’équipe",
    "searchFilterOptionRoleTeamMember": "Membres de l’équipe",
    "textCalendarShortWeekdaySaturday": "Sam",
    "textCalendarShortWeekdayThursday": "Jeu",
    "formInputLabelGeneralRegistration": "Inscription générale",
    "pageVideoSubcategoriesDropboxDash": "Dropbox Dash",
    "pageVideoSubcategoriesTeamFolders": "Dossiers d’équipe",
    "textCalendarShortWeekdayWednesday": "Mer",
    "formInputLabelGlobalSelectLanguage": "Sélectionner une langue",
    "formInputLabelSelectDateBreadcrumb": "Sélectionner une date",
    "pageVideoCategoriesAccountSettings": "Paramètres du compte",
    "pageVideoCategoriesCreateAndUpload": "Créer et importer",
    "pageVideoSubcategoriesTeamSecurity": "Sécurité de l’équipe",
    "searchFilterOptionRoleFundamentals": "Principes fondamentaux",
    "pageVideoCategoriesDeleteAndRestore": "Supprimer et restaurer",
    "pageCourseTopicTableOfContentsHeading": "Sections de cet article",
    "pageVideoSubcategoriesDropboxPolicies": "Politiques Dropbox",
    "pageVideoSubcategoriesOnDemandTraining": "Formation à la demande",
    "pageVideoSubcategoriesCommentingOnFiles": "l’ajout de commentaires dans les fichiers",
    "pageVideoSubcategoriesSharingPermissions": "Autorisations de partage",
    "pageVideoSubcategoriesDropboxApplications": "Applications Dropbox",
    "pageVideoSubcategoriesSearchingYourAccount": "Recherche dans votre compte",
    "pageVideoSubcategoriesManagingAccountAccess": "Gestion de l’accès au compte",
    "pageVideoSubcategoriesSharingFilesAndFolders": "Partage de fichiers et de dossiers",
    "pageVideoSubcategoriesCreatingFilesAndFolders": "Création de fichiers et dossiers"
  },
  "copyrightText": "Dropbox 2021",
  "seo": {
    "title": {
      "name": "title",
      "value": "Dropbox learn"
    },
    "keywords": {
      "name": "keywords",
      "value": ""
    },
    "og:image": {
      "name": "og:image",
      "value": {
        "id": "2z2Foc0s6DPlQV1aTtWO3b",
        "url": "https://images.ctfassets.net/zh1yxk5yn2r7/2z2Foc0s6DPlQV1aTtWO3b/b0c0e0a58102dd90281f7b1df860a370/Dropbox.svg",
        "title": "Dropbox Logo"
      }
    },
    "og:title": {
      "name": "og:title",
      "value": "Dropbox learn"
    },
    "canonical": {
      "name": "canonical",
      "value": ""
    },
    "description": {
      "name": "description",
      "value": "Learn how to use Dropbox. Browse our catalog of free self-guided courses and virtual instructor led training sessions. Start a Dropbox training course today."
    },
    "twitter:image": {
      "name": "twitter:image",
      "value": {
        "id": "2z2Foc0s6DPlQV1aTtWO3b",
        "url": "https://images.ctfassets.net/zh1yxk5yn2r7/2z2Foc0s6DPlQV1aTtWO3b/b0c0e0a58102dd90281f7b1df860a370/Dropbox.svg",
        "title": "Dropbox Logo"
      }
    },
    "twitter:title": {
      "name": "twitter:title",
      "value": "Dropbox learn"
    },
    "og:description": {
      "name": "og:description",
      "value": "Learn how to use Dropbox. Browse our catalog of free self-guided courses and virtual instructor led training sessions. Start a Dropbox training course today."
    },
    "twitter:description": {
      "name": "twitter:description",
      "value": "Learn how to use Dropbox. Browse our catalog of free self-guided courses and virtual instructor led training sessions. Start a Dropbox training course today."
    }
  },
  "seoOrganizationsSchema": {
    "url": "http://www.dropbox.com",
    "@type": "Organization",
    "@context": "http://schema.org",
    "contactPoint": [
      {
        "@type": "ContactPoint",
        "telephone": "+1-888-888-8888",
        "areaServed": "US",
        "contactType": "customer service",
        "contactOption": "TollFree"
      },
      {
        "@type": "ContactPoint",
        "telephone": "+1-888-888-8888",
        "contactType": "customer service"
      },
      {
        "@type": "ContactPoint",
        "telephone": "+1-888-888-8888",
        "areaServed": "US",
        "contactType": "customer service",
        "contactOption": [
          "HearingImpairedSupported",
          "TollFree"
        ]
      },
      {
        "@type": "ContactPoint",
        "telephone": "+1-888-888-8888",
        "areaServed": [
          "US",
          "CA"
        ],
        "contactType": "technical support",
        "contactOption": "TollFree",
        "availableLanguage": [
          "English",
          "French"
        ]
      },
      {
        "@type": "ContactPoint",
        "telephone": "+1-888-888-8888",
        "areaServed": [
          "US",
          "CA"
        ],
        "contactType": "bill payment",
        "contactOption": "TollFree"
      }
    ]
  }
}
  },
  "de": {
    isDefault: false,
    settings: {
  "_id": "4KRGLSrqTRY6s18UzHe1II",
  "_contentTypeId": "settingsGlobal",
  "_modifiedDate": "2026-05-14T04:59:02.660Z",
  "internalTitle": "CX Learning Hub Global Settings",
  "topNavigationLogo": {
    "title": "Dropbox Logo",
    "url": "//images.ctfassets.net/zh1yxk5yn2r7/2z2Foc0s6DPlQV1aTtWO3b/b0c0e0a58102dd90281f7b1df860a370/Dropbox.svg",
    "size": 3707,
    "width": 324,
    "height": 64,
    "filename": "Dropbox.svg",
    "contentType": "image/svg+xml"
  },
  "mainNavigation": [
    {
      "internalTitle": "Footer Link - Help center",
      "linkText": "Hilfecenter",
      "destinationType": "Manual text entry",
      "trackingId": "learn-support-help-center",
      "_id": "5pPOxJP1W9PaPBCnLHhe5x",
      "_contentTypeId": "elementLink",
      "href": "https://help.dropbox.com",
      "as": null,
      "target": null,
      "isModal": false,
      "download": false
    },
    {
      "internalTitle": "Supernav - Dropbox Community",
      "linkText": "Community",
      "destinationType": "Manual text entry",
      "_id": "7aVH719lug9lYEJzIntabM",
      "_contentTypeId": "elementLink",
      "href": "https://community.dropbox.com/",
      "as": null,
      "target": "_blank",
      "isModal": false,
      "download": false
    },
    {
      "internalTitle": "Footer Link - Contact us",
      "linkText": "Kontakt",
      "destinationType": "Manual text entry",
      "trackingId": "learn-support-contact-us",
      "_id": "5v3vwPdKulQu6xhA6csIT8",
      "_contentTypeId": "elementLink",
      "href": "https://www.dropbox.com/contact",
      "as": null,
      "target": null,
      "isModal": false,
      "download": false
    }
  ],
  "secondaryNavigation": [
    {
      "internalTitle": "Secondary Nav - Self-guided learning",
      "linkText": "Selbstständiges Lernen",
      "destinationType": "Content reference",
      "_id": "oMqs4whMJuBjhZsbMv0KA",
      "_contentTypeId": "elementLink",
      "href": "/[slug]",
      "as": "/self-guided-learning",
      "target": null,
      "isModal": false,
      "download": false
    },
    {
      "internalTitle": "Secondary Nav - Videos Landing Page",
      "linkText": "Videos",
      "destinationType": "Content reference",
      "_id": "5y8ArqrhCZ6DoCCGxaumhI",
      "_contentTypeId": "elementLink",
      "href": "/[slug]",
      "as": "/video-library",
      "target": null,
      "isModal": false,
      "download": false
    }
  ],
  "footerNavigation": [
    {
      "_id": "1M79uBMmyuD9Iw6fuOdVEJ",
      "_contentTypeId": "elementFooterNavColumn",
      "_modifiedDate": "2026-05-06T15:28:27.147Z",
      "internalTitle": "Dropbox",
      "links": [
        {
          "internalTitle": "Footer Link - Desktop app",
          "linkText": "Desktop-App",
          "destinationType": "Manual text entry",
          "trackingId": "learn-dropbox-desktop-app",
          "_id": "3SKeLjF7MWEq2FqaRwnmiK",
          "_contentTypeId": "elementLink",
          "href": "https://www.dropbox.com/desktop",
          "as": null,
          "target": null,
          "isModal": false,
          "download": false
        },
        {
          "internalTitle": "Footer Link - Mobile app",
          "linkText": "Mobile App",
          "destinationType": "Manual text entry",
          "trackingId": "learn-dropbox-mobile-app",
          "_id": "62ymoNSBbWiYinBkFO0cGj",
          "_contentTypeId": "elementLink",
          "href": "https://www.dropbox.com/mobile",
          "as": null,
          "target": null,
          "isModal": false,
          "download": false
        },
        {
          "internalTitle": "Footer Link - Integrations",
          "linkText": "Integrations",
          "destinationType": "Manual text entry",
          "trackingId": "learn-dropbox-integrations",
          "_id": "5WEO1xpKelxpyXS50n3Dxc",
          "_contentTypeId": "elementLink",
          "href": "https://www.dropbox.com/app-integrations",
          "as": null,
          "target": null,
          "isModal": false,
          "download": false
        },
        {
          "internalTitle": "Footer Link - Features",
          "linkText": "Features",
          "destinationType": "Manual text entry",
          "trackingId": "learn-dropbox-features",
          "_id": "wUuQPtOLYz96QOSvtgLTh",
          "_contentTypeId": "elementLink",
          "href": "https://www.dropbox.com/features",
          "as": null,
          "target": null,
          "isModal": false,
          "download": false
        },
        {
          "internalTitle": "Footer Link - Solutions",
          "linkText": "Solutions",
          "destinationType": "Manual text entry",
          "trackingId": "learn-dropbox-solutions",
          "_id": "14SJorC6JrH7u2O5E8vf2E",
          "_contentTypeId": "elementLink",
          "href": "https://www.dropbox.com/business/solutions",
          "as": null,
          "target": null,
          "isModal": false,
          "download": false
        },
        {
          "internalTitle": "Footer Link - Security",
          "linkText": "Sicherheit",
          "destinationType": "Manual text entry",
          "trackingId": "learn-dropbox-security",
          "_id": "2YZlyLOZLw2lauy2OWiuB2",
          "_contentTypeId": "elementLink",
          "href": "https://www.dropbox.com/features/security",
          "as": null,
          "target": null,
          "isModal": false,
          "download": false
        },
        {
          "internalTitle": "Footer Link - Early access",
          "linkText": "Early access",
          "destinationType": "Manual text entry",
          "trackingId": "learn-dropbox-early-access",
          "_id": "6u2aXFqnr9s1KXkSjfc2cz",
          "_contentTypeId": "elementLink",
          "href": "https://www.dropbox.com/early-access",
          "as": null,
          "target": null,
          "isModal": false,
          "download": false
        },
        {
          "internalTitle": "Footer Link - Templates",
          "linkText": "Templates",
          "destinationType": "Manual text entry",
          "trackingId": "learn-dropbox-templates",
          "_id": "4yIX8tA1WW1soyk10Frgz5",
          "_contentTypeId": "elementLink",
          "href": "https://www.dropbox.com/templates",
          "as": null,
          "target": null,
          "isModal": false,
          "download": false
        },
        {
          "internalTitle": "Footer Link - Free tools",
          "linkText": "Kostenlose Tools",
          "destinationType": "Manual text entry",
          "trackingId": "learn-dropbox-free-tools",
          "_id": "3Fdgsos4Pm77l2C4hKm2AC",
          "_contentTypeId": "elementLink",
          "href": "https://www.dropbox.com/tools",
          "as": null,
          "target": null,
          "isModal": false,
          "download": false
        }
      ]
    },
    {
      "_id": "6LXqBrZEH3p2eDbBpiPFlm",
      "_contentTypeId": "elementFooterNavColumn",
      "_modifiedDate": "2026-05-06T15:28:27.418Z",
      "internalTitle": "Produkte",
      "links": [
        {
          "internalTitle": "Footer Link - Plus",
          "linkText": "Plus",
          "destinationType": "Manual text entry",
          "trackingId": "learn-products-plus",
          "_id": "4nThAv7YjSuKC91UBK1AoR",
          "_contentTypeId": "elementLink",
          "href": "https://www.dropbox.com/plus",
          "as": null,
          "target": null,
          "isModal": false,
          "download": false
        },
        {
          "internalTitle": "Footer Link -  Professional",
          "linkText": "Professional",
          "destinationType": "Manual text entry",
          "trackingId": "learn-products-professional",
          "_id": "5YtdEKxrCJgHqmmDvwgnQI",
          "_contentTypeId": "elementLink",
          "href": "https://www.dropbox.com/pro",
          "as": null,
          "target": "_blank",
          "isModal": false,
          "download": false
        },
        {
          "internalTitle": "Footer Link - Business",
          "linkText": "Business",
          "destinationType": "Manual text entry",
          "trackingId": "learn-products-business",
          "_id": "5L4PFaY36Icmt95mUTgjOC",
          "_contentTypeId": "elementLink",
          "href": "https://www.dropbox.com/business",
          "as": null,
          "target": null,
          "isModal": false,
          "download": false
        },
        {
          "internalTitle": "Footer Link - Enterprise",
          "linkText": "Enterprise",
          "destinationType": "Manual text entry",
          "trackingId": "learn-products-enterprise",
          "_id": "4KJcgnikVfGiWIaFiuiRIM",
          "_contentTypeId": "elementLink",
          "href": "https://www.dropbox.com/enterprise",
          "as": null,
          "target": null,
          "isModal": false,
          "download": false
        },
        {
          "internalTitle": "Footer Link - Dash",
          "linkText": "Dash",
          "destinationType": "Manual text entry",
          "trackingId": "learn-products-dash",
          "_id": "4qdbH5UT1PZYVWp4vOADQa",
          "_contentTypeId": "elementLink",
          "href": "https://dash.dropbox.com",
          "as": null,
          "target": null,
          "isModal": false,
          "download": false
        },
        {
          "internalTitle": "Footer Link - DocSend",
          "linkText": "DocSend",
          "destinationType": "Manual text entry",
          "trackingId": "learn-products-docsend",
          "_id": "5hUjrT7Yza4eLKxBevHcAF",
          "_contentTypeId": "elementLink",
          "href": "https://www.docsend.com/?utm_medium=Referral&utm_source=Dropbox%20Web%20Referral&utm_campaign=dbx-footer",
          "as": null,
          "target": null,
          "isModal": false,
          "download": false
        },
        {
          "internalTitle": "Footer Link - Dropbox Sign",
          "linkText": "Dropbox Sign",
          "destinationType": "Manual text entry",
          "trackingId": "learn-products-sign",
          "_id": "4ennWEzf0rjxfCiNTEiU9w",
          "_contentTypeId": "elementLink",
          "href": "https://sign.dropbox.com",
          "as": null,
          "target": null,
          "isModal": false,
          "download": false
        },
        {
          "internalTitle": "Footer Link - Reclaim.ai",
          "linkText": "Reclaim.ai",
          "destinationType": "Manual text entry",
          "trackingId": "learn-products-reclaim-ai",
          "_id": "5XGB9J0ZeBff2lXEapKBR1",
          "_contentTypeId": "elementLink",
          "href": "https://app.reclaim.ai/signup?utm_medium=referral&utm_source=dbx-footer-referral&utm_campaign=dbx-footer-signup&utm_term=dbx-footer",
          "as": null,
          "target": null,
          "isModal": false,
          "download": false
        },
        {
          "internalTitle": "Footer Link - Plans",
          "linkText": "Plans",
          "destinationType": "Manual text entry",
          "trackingId": "learn-products-plans",
          "_id": "13TtJzOJV2eQoZ3TQbNVdd",
          "_contentTypeId": "elementLink",
          "href": "https://www.dropbox.com/plans",
          "as": null,
          "target": null,
          "isModal": false,
          "download": false
        },
        {
          "internalTitle": "Footer Link - Product updates",
          "linkText": "Product updates",
          "destinationType": "Manual text entry",
          "trackingId": "learn-products-updates",
          "_id": "45NCupQTJZJEBQ1r1pFDDf",
          "_contentTypeId": "elementLink",
          "href": "https://www.dropbox.com/product-updates",
          "as": null,
          "target": null,
          "isModal": false,
          "download": false
        }
      ]
    },
    {
      "_id": "74RyIf3Qiipq4XbcIPQQwT",
      "_contentTypeId": "elementFooterNavColumn",
      "_modifiedDate": "2026-05-06T15:28:27.829Z",
      "internalTitle": "Features",
      "links": [
        {
          "internalTitle": "Footer Link - Send large files",
          "linkText": "Send large files",
          "destinationType": "Manual text entry",
          "trackingId": "learn-features-send-large-files",
          "_id": "48eVY6niBIXx4YAPA4XKWz",
          "_contentTypeId": "elementLink",
          "href": "https://www.dropbox.com/features/share/send-large-files",
          "as": null,
          "target": null,
          "isModal": false,
          "download": false
        },
        {
          "internalTitle": "Footer Link - Send long videos",
          "linkText": "Send long videos",
          "destinationType": "Manual text entry",
          "trackingId": "learn-features-send-long-videos",
          "_id": "75e4Pf3aV5ZnB77zgoYITc",
          "_contentTypeId": "elementLink",
          "href": "https://www.dropbox.com/features/share/send-long-videos",
          "as": null,
          "target": null,
          "isModal": false,
          "download": false
        },
        {
          "internalTitle": "Footer Link - Cloud photo storage",
          "linkText": "Cloud photo storage",
          "destinationType": "Manual text entry",
          "trackingId": "learn-features-cloud-photo-storage",
          "_id": "64WyEAeXS80TWroqmR8eHy",
          "_contentTypeId": "elementLink",
          "href": "https://www.dropbox.com/features/cloud-storage/photos",
          "as": null,
          "target": null,
          "isModal": false,
          "download": false
        },
        {
          "internalTitle": "Footer Link - Secure file transfer",
          "linkText": "Secure file transfer",
          "destinationType": "Manual text entry",
          "trackingId": "learn-features-send-secure-file-transfer",
          "_id": "9bUiqp6kN7PfQDoP5dVEA",
          "_contentTypeId": "elementLink",
          "href": "https://www.dropbox.com/features/share/file-transfer",
          "as": null,
          "target": null,
          "isModal": false,
          "download": false
        },
        {
          "internalTitle": "Footer Link - Cloud backup",
          "linkText": "Cloud backup",
          "destinationType": "Manual text entry",
          "trackingId": "learn-features-cloud-backup",
          "_id": "4kYfwCJpM6hsTbLd622yzc",
          "_contentTypeId": "elementLink",
          "href": "https://www.dropbox.com/features/cloud-storage/file-backup",
          "as": null,
          "target": null,
          "isModal": false,
          "download": false
        },
        {
          "internalTitle": "Footer Link - Edit PDFs",
          "linkText": "Edit PDFs",
          "destinationType": "Manual text entry",
          "trackingId": "learn-features-edit-pdfs",
          "_id": "1Fw9zhaVelLXfOpxEQwsAy",
          "_contentTypeId": "elementLink",
          "href": "https://www.dropbox.com/features/productivity/pdf-editor",
          "as": null,
          "target": null,
          "isModal": false,
          "download": false
        },
        {
          "internalTitle": "Footer Link - Electronic signatures",
          "linkText": "Electronic signatures",
          "destinationType": "Manual text entry",
          "trackingId": "learn-features-electronic-signatures",
          "_id": "6nhjK34qVMZlkA2opn0vWj",
          "_contentTypeId": "elementLink",
          "href": "https://www.dropbox.com/features/productivity/electronic-signature",
          "as": null,
          "target": null,
          "isModal": false,
          "download": false
        },
        {
          "internalTitle": "Footer Link - Convert to PDF",
          "linkText": "Convert to PDF",
          "destinationType": "Manual text entry",
          "trackingId": "learn-features-convert-to-pdf",
          "_id": "4a7MNYwiyhj6OtmYb87co0",
          "_contentTypeId": "elementLink",
          "href": "https://www.dropbox.com/features/productivity/convert-to-pdf",
          "as": null,
          "target": null,
          "isModal": false,
          "download": false
        }
      ]
    },
    {
      "_id": "1TnZWWGdwo9BEkEKgcIGpA",
      "_contentTypeId": "elementFooterNavColumn",
      "_modifiedDate": "2026-05-06T15:28:27.248Z",
      "internalTitle": "Support",
      "links": [
        {
          "internalTitle": "Footer Link - Help center",
          "linkText": "Hilfecenter",
          "destinationType": "Manual text entry",
          "trackingId": "learn-support-help-center",
          "_id": "5pPOxJP1W9PaPBCnLHhe5x",
          "_contentTypeId": "elementLink",
          "href": "https://help.dropbox.com",
          "as": null,
          "target": null,
          "isModal": false,
          "download": false
        },
        {
          "internalTitle": "Footer Link - Contact us",
          "linkText": "Kontakt",
          "destinationType": "Manual text entry",
          "trackingId": "learn-support-contact-us",
          "_id": "5v3vwPdKulQu6xhA6csIT8",
          "_contentTypeId": "elementLink",
          "href": "https://www.dropbox.com/contact",
          "as": null,
          "target": null,
          "isModal": false,
          "download": false
        },
        {
          "internalTitle": "Footer Link - Privacy & terms",
          "linkText": "Datenschutz & AGB",
          "destinationType": "Manual text entry",
          "trackingId": "learn-support-privacy-terms",
          "_id": "30MJJnJ2DIcvhYL2wsg0FB",
          "_contentTypeId": "elementLink",
          "href": "https://www.dropbox.com/terms",
          "as": null,
          "target": null,
          "isModal": false,
          "download": false
        },
        {
          "internalTitle": "Footer Link - Cookie policy",
          "linkText": "Cookies-Richtlinie",
          "destinationType": "Manual text entry",
          "trackingId": "learn-support-cookie-policy",
          "_id": "3akG8gNhd73ZlRaEYSCvUD",
          "_contentTypeId": "elementLink",
          "href": "https://help.dropbox.com/security/cookies",
          "as": null,
          "target": null,
          "isModal": false,
          "download": false
        },
        {
          "internalTitle": "Footer Link - Cookies & CCPA preferences",
          "linkText": "Cookie- und CCPA-Einstellungen",
          "destinationType": "Manual text entry",
          "trackingId": "learn-support-cookies-CCPA",
          "_id": "65mwIIQg9xKeyKiICuy9DJ",
          "_contentTypeId": "elementLink",
          "href": "https://www.dropbox.com/app-integrations#manage-cookies",
          "as": null,
          "target": null,
          "isModal": false,
          "download": false
        },
        {
          "internalTitle": "Footer Link - AI principles",
          "linkText": "AI principles",
          "destinationType": "Manual text entry",
          "trackingId": "learn-support-ai-principles",
          "_id": "5mTsyPahdNgokTvducSB9i",
          "_contentTypeId": "elementLink",
          "href": "https://www.dropbox.com/ai-principles",
          "as": null,
          "target": null,
          "isModal": false,
          "download": false
        },
        {
          "internalTitle": "Footer Link - Sitemap",
          "linkText": "Sitemap",
          "destinationType": "Manual text entry",
          "trackingId": "learn-support-sitemap",
          "_id": "37byNy2Pux5TAcdSJm6g4f",
          "_contentTypeId": "elementLink",
          "href": "https://experience.dropbox.com/sitemap",
          "as": null,
          "target": null,
          "isModal": false,
          "download": false
        },
        {
          "internalTitle": "Footer Link - Learning resources",
          "linkText": "Learning resources",
          "destinationType": "Manual text entry",
          "trackingId": "learn-support-learning-resources",
          "_id": "Gj2OgkkQcCs8BXTBr5Irc",
          "_contentTypeId": "elementLink",
          "href": "https://learn.dropbox.com",
          "as": null,
          "target": null,
          "isModal": false,
          "download": false
        }
      ]
    },
    {
      "_id": "28o2jcc5DrafqCYZ9icYU7",
      "_contentTypeId": "elementFooterNavColumn",
      "_modifiedDate": "2026-05-06T15:28:26.982Z",
      "internalTitle": "Ressourcen",
      "links": [
        {
          "internalTitle": "Footer Link - Blog",
          "linkText": "Blog",
          "destinationType": "Manual text entry",
          "trackingId": "learn-resources-blog",
          "_id": "4vYa3RKqQLWA8bNHcaPX69",
          "_contentTypeId": "elementLink",
          "href": "https://blog.dropbox.com",
          "as": null,
          "target": null,
          "isModal": false,
          "download": false
        },
        {
          "internalTitle": "Footer Link - Events",
          "linkText": "Events",
          "destinationType": "Manual text entry",
          "trackingId": "learn-resources-events",
          "_id": "2D8JKIOdP8zjqZCfsqIG5l",
          "_contentTypeId": "elementLink",
          "href": "https://events.dropbox.com/",
          "as": null,
          "target": null,
          "isModal": false,
          "download": false
        },
        {
          "internalTitle": "Footer Link - Customer stories",
          "linkText": "Customer stories",
          "destinationType": "Manual text entry",
          "trackingId": "learn-resources-customer-stories",
          "_id": "49GkLGyFuV1GvXf1DozTPZ",
          "_contentTypeId": "elementLink",
          "href": "https://www.dropbox.com/customers",
          "as": null,
          "target": null,
          "isModal": false,
          "download": false
        },
        {
          "internalTitle": "Footer Link - Resources library",
          "linkText": "Resources library",
          "destinationType": "Manual text entry",
          "trackingId": "learn-resources-resources-library",
          "_id": "3l98eLMkEyPoj0jzqgBvj7",
          "_contentTypeId": "elementLink",
          "href": "https://www.dropbox.com/resources",
          "as": null,
          "target": null,
          "isModal": false,
          "download": false
        },
        {
          "internalTitle": "Footer Link - Developers",
          "linkText": "Entwickler",
          "destinationType": "Manual text entry",
          "trackingId": "learn-resources-developers",
          "_id": "2aFb3GcSJS0YIEU3aKbLzj",
          "_contentTypeId": "elementLink",
          "href": "https://www.dropbox.com/developers",
          "as": null,
          "target": null,
          "isModal": false,
          "download": false
        },
        {
          "internalTitle": "Footer Link - Community forums",
          "linkText": "Communityforen",
          "destinationType": "Manual text entry",
          "trackingId": "learn-resources-community-forums",
          "_id": "4IGtm6twVWzfoE07kHlucc",
          "_contentTypeId": "elementLink",
          "href": "https://community.dropbox.com",
          "as": null,
          "target": null,
          "isModal": false,
          "download": false
        },
        {
          "internalTitle": "Footer Link - Referrals",
          "linkText": "Weiterempfehlungen",
          "destinationType": "Manual text entry",
          "trackingId": "learn-resources-referrals",
          "_id": "4YsKqwQfAG4Ds0a0yeo9wp",
          "_contentTypeId": "elementLink",
          "href": "https://www.dropbox.com/refer",
          "as": null,
          "target": null,
          "isModal": false,
          "download": false
        },
        {
          "internalTitle": "Footer Link - Reseller partners",
          "linkText": "Reseller partners",
          "destinationType": "Manual text entry",
          "trackingId": "learn-resources-reseller-partners",
          "_id": "1w7KmWfsigadpZje40tk18",
          "_contentTypeId": "elementLink",
          "href": "https://www.dropbox.com/business/partners",
          "as": null,
          "target": null,
          "isModal": false,
          "download": false
        },
        {
          "internalTitle": "Footer Link - Integration partners",
          "linkText": "Integration partners",
          "destinationType": "Manual text entry",
          "trackingId": "learn-resources-integration-partners",
          "_id": "6dgcNUDLbEeXQE94s71vrO",
          "_contentTypeId": "elementLink",
          "href": "https://www.dropbox.com/app-integrations",
          "as": null,
          "target": null,
          "isModal": false,
          "download": false
        },
        {
          "internalTitle": "Footer Link - Find a partner",
          "linkText": "Find a partner",
          "destinationType": "Manual text entry",
          "trackingId": "learn-resources-find-a-partner",
          "_id": "2wQU48ntbukgQSKuTKS9in",
          "_contentTypeId": "elementLink",
          "href": "https://experience.dropbox.com/partner-locator",
          "as": null,
          "target": null,
          "isModal": false,
          "download": false
        }
      ]
    },
    {
      "_id": "5xRp5jjLsl92vmGL0qJfVb",
      "_contentTypeId": "elementFooterNavColumn",
      "_modifiedDate": "2026-05-06T15:28:26.948Z",
      "internalTitle": "Firma:",
      "links": [
        {
          "internalTitle": "Footer Link - About us",
          "linkText": "Über uns",
          "destinationType": "Manual text entry",
          "trackingId": "learn-company-about-us",
          "_id": "6XnBD8OrJfQZ4u3ZSc6ysr",
          "_contentTypeId": "elementLink",
          "href": "https://www.dropbox.com/about",
          "as": null,
          "target": null,
          "isModal": false,
          "download": false
        },
        {
          "internalTitle": "Footer Link - Jobs",
          "linkText": "Jobs",
          "destinationType": "Manual text entry",
          "trackingId": "learn-company-jobs",
          "_id": "1nmf2X1QaLv7zS1PIyfqlE",
          "_contentTypeId": "elementLink",
          "href": "https://jobs.dropbox.com",
          "as": null,
          "target": null,
          "isModal": false,
          "download": false
        },
        {
          "internalTitle": "Footer Link - Investor relations",
          "linkText": "Investor Relations",
          "destinationType": "Manual text entry",
          "trackingId": "learn-company-investor-relations",
          "_id": "73WTKUyXSmqc5aP1OfisZ9",
          "_contentTypeId": "elementLink",
          "href": "https://dropbox.gcs-web.com/",
          "as": null,
          "target": null,
          "isModal": false,
          "download": false
        },
        {
          "internalTitle": "Footer Link - Corporate responsibility",
          "linkText": "Verantwortung des Unternehmens",
          "destinationType": "Manual text entry",
          "trackingId": "learn-company-corporate-responsibility",
          "_id": "5iMgmL64RXCXtz8iRkrIIM",
          "_contentTypeId": "elementLink",
          "href": "https://www.dropbox.com/corporate-responsibility",
          "as": null,
          "target": null,
          "isModal": false,
          "download": false
        }
      ]
    }
  ],
  "cookieBarBody": "Wir verwenden Cookies, damit Dropbox optimal für Sie funktioniert. Mit der Nutzung unserer Website stimmen Sie unserer Verwendung von Cookies zu.",
  "cookieBarCta": {
    "internalTitle": "Link Text - Cookie bar",
    "linkText": "Mehr erfahren",
    "destinationType": "Manual text entry",
    "_id": "1tY3PGTzdIHKRi4pDNbmSM",
    "_contentTypeId": "elementLink",
    "href": "https://help.dropbox.com/accounts-billing/security/cookies",
    "as": null,
    "target": "_blank",
    "isModal": false,
    "download": false
  },
  "cookieBarEnabled": true,
  "virtualTrainingsEmptyState": {
    "data": {},
    "content": [
      {
        "data": {},
        "content": [
          {
            "data": {},
            "marks": [],
            "value": "Hier gibt es noch nichts zu sehen – registrieren Sie sich für eine ",
            "nodeType": "text"
          },
          {
            "data": {
              "target": null
            },
            "content": [
              {
                "data": {},
                "marks": [],
                "value": "virtuelle Schulung",
                "nodeType": "text"
              }
            ],
            "nodeType": "entry-hyperlink"
          },
          {
            "data": {},
            "marks": [],
            "value": ".",
            "nodeType": "text"
          }
        ],
        "nodeType": "paragraph"
      }
    ],
    "nodeType": "document"
  },
  "completedCoursesEmptyState": {
    "data": {},
    "content": [
      {
        "data": {},
        "content": [
          {
            "data": {},
            "marks": [],
            "value": "Kurse, die Sie besucht haben, werden hier angezeigt.",
            "nodeType": "text"
          }
        ],
        "nodeType": "paragraph"
      }
    ],
    "nodeType": "document"
  },
  "inProgressCoursesEmptyState": {
    "data": {},
    "content": [
      {
        "data": {},
        "content": [
          {
            "data": {},
            "marks": [],
            "value": "Hier gibt es noch nichts zu sehen – starten Sie einen ",
            "nodeType": "text"
          },
          {
            "data": {
              "target": {
                "_id": "75pzFP9abHFb2hlQycUS86",
                "_contentTypeId": "pageLanding",
                "_href": "/[slug]",
                "_as": "/self-guided-learning",
                "_modifiedDate": "2026-07-14T14:56:10.933Z",
                "internalTitle": "L2 - Landing page - Self-guided learning",
                "name": "Selbstständiges Lernen",
                "slug": "self-guided-learning",
                "introHero": {
                  "_id": "6pQlpoBglvzGW38DBWvU5W",
                  "_contentTypeId": "moduleHero",
                  "_modifiedDate": "2026-05-15T16:06:56.370Z",
                  "internalTitle": "Hero - Self-guided learning",
                  "headerText": "Selbstständiges Lernen",
                  "summaryText": "Entdecken Sie geführte Kurse für Dropbox, Dash, Replay, Sign und mehr. Wählen Sie den Kurs aus, der Ihren Anforderungen entspricht&nbsp;– von den ersten Schritten bis hin zur Verwaltung Ihres Teams.\n",
                  "image": {
                    "title": "Self-Guided Learning Illustration",
                    "description": "Book illustration for Dropbox's self-guided learning courses",
                    "url": "//images.ctfassets.net/zh1yxk5yn2r7/6ODZb6bllZrucIYtiLqFkU/f844e955cabc76e34e249d9c18e43d62/self-guided-learning.svg",
                    "size": 42902,
                    "width": 405,
                    "height": 310,
                    "filename": "self-guided-learning.svg",
                    "contentType": "image/svg+xml"
                  }
                },
                "contentSections": [
                  {
                    "_id": "6MGcQfM5kOFGpBqiOmSkKy",
                    "_contentTypeId": "moduleFeaturedCourse",
                    "_modifiedDate": "2026-11-05T12:58:40.480Z",
                    "internalTitle": "Featured - Self-guided learning",
                    "title": "Angebotener Kurs",
                    "course": null
                  },
                  {
                    "_id": "4JIWsH681XIFek4zmBB6Ix",
                    "_contentTypeId": "moduleMultiColumnCourses",
                    "_modifiedDate": "2026-11-05T12:58:40.355Z",
                    "internalTitle": "All courses - Self-guided learning - Cards",
                    "title": "Alle Kurse",
                    "courses": []
                  }
                ],
                "seo": {
                  "title": {
                    "name": "title",
                    "value": "Selbstgeführte Dropbox-Trainingskurse | Dropbox-Schulungen"
                  },
                  "keywords": {
                    "name": "keywords",
                    "value": ""
                  },
                  "og:image": {
                    "name": "og:image",
                    "value": {
                      "id": "33cKbUcUgjCOB3aPxkIMGq",
                      "url": "https://images.ctfassets.net/zh1yxk5yn2r7/33cKbUcUgjCOB3aPxkIMGq/14cdd574f957e960f0972f73a80a892e/hoop.png",
                      "title": "hoop"
                    }
                  },
                  "description": {
                    "name": "description",
                    "value": "Dropbox-Trainingskurse für das Selbststudium, kostenlos und auf Abruf verfügbar. Erfahren Sie in Ihrem eigenen Tempo, wie Sie Ihr Dropbox-Konto verwenden. Registrieren Sie sich jetzt."
                  },
                  "twitter:title": {
                    "name": "twitter:title",
                    "value": "Dropbox"
                  }
                }
              }
            },
            "content": [
              {
                "data": {},
                "marks": [],
                "value": "Kurs zum selbstständigen Lernen",
                "nodeType": "text"
              }
            ],
            "nodeType": "entry-hyperlink"
          },
          {
            "data": {},
            "marks": [],
            "value": ".",
            "nodeType": "text"
          }
        ],
        "nodeType": "paragraph"
      }
    ],
    "nodeType": "document"
  },
  "l18nLookup": {
    "see": " Lesen Sie, ",
    "noData": "Keine Ergebnisse",
    "textHr": "Std.",
    "filters": "Filter",
    "modules": "Module",
    "results": "Ergebnisse",
    "textHrs": "Std.",
    "textMin": "min",
    "clearall": "Alle Filter zurücksetzen",
    "continue": "Weiter",
    "featured": "Vorteile",
    "textHour": "Stunde",
    "textLess": "Weniger",
    "textMins": "Min.",
    "textMore": "Mehr",
    "textRead": "Gelesen",
    "allvidoes": "Alle Videos",
    "labelTags": "Markierungen",
    "learnText": "Informationen",
    "startdemo": "Demo starten",
    "textClear": "Löschen",
    "textHours": "Verfügbarkeit",
    "useStacks": "So verwenden Sie Stacks",
    "findCourse": "Einen Kurs finden",
    "textMinute": "Minute",
    "transcript": "Transkript",
    "ctaTextBack": "Zurück",
    "ctaTextNext": "Weiter",
    "filterstext": "Filter",
    "joinUrlText": "Der Sitzung beitreten",
    "moreAnswers": "nach weiteren Ressourcen.",
    "noCouresYet": "Noch keine Kurse",
    "readingTime": "Minute(n) Lesezeit",
    "textMinutes": "Minuten",
    "textSeeMore": "Mehr ansehen",
    "textViewAll": "Alle ansehen",
    "alltutorials": "alle Tutorials",
    "ctaTextLogIn": "Anmelden",
    "noresultText": "Versuchen Sie es mit anderen Suchbegriffen oder durchsuchen Sie",
    "searchHeader": "Suchen",
    "textComplete": "Abgeschlossen",
    "textError404": "Fehler (404)",
    "textFilterBy": "Filter",
    "videolibrary": "Videobibliothek",
    "browseKeyword": "Versuchen Sie es mit anderen Suchbegriffen oder durchsuchen Sie",
    "ctaTextLogout": "Abmelden",
    "ctaTextSignIn": "Anmelden",
    "labelSubjects": "Betreff",
    "moreTutorials": "Weitere Tutorials",
    "popUpBodyText": "Sie haben gerade den Kurs „Dropbox Business-Admins“ abgeschlossen!",
    "textNextTopic": "Nächstes Modul",
    "trackProgress": "Beginnen Sie hier einen Kurs, um Ihren Fortschritt zu verfolgen.",
    "ctaTextProfile": "Mein Profil",
    "ctaTextVirtual": "Sitzung anzeigen",
    "headerDuration": "Zeitraum",
    "languageNameDe": "Deutsch",
    "languageNameEs": "Español",
    "languageNameFr": "Français",
    "languageNameIt": "Italiano",
    "languageNameJa": "日本語",
    "matchingsearch": "Es konnten keine Treffer für Ihre Suche gefunden werden.",
    "viewAllCourses": "Alle Kurse sehen",
    "ctaTextRegister": "Jetzt anmelden",
    "labelCategories": "Kategorien",
    "searchNoResults": "Keine Ergebnisse für {{search}}",
    "textStartCourse": "Jetzt Kurs starten",
    "textWebinarFull": "Dieses Webinar ist ausgebucht. Bitte versuchen Sie es mit einer anderen Uhrzeit oder einem anderen Tag.",
    "accountLabelLast": "Nachname",
    "accountLabelName": "Name",
    "ctaCreateAccount": "Konto erstellen",
    "languageNameEnUs": "Englisch",
    "languageNamePtBr": "Português",
    "searchBreadcrumb": "Suchergebnisse",
    "searchFilterRole": "Nutzerrolle",
    "textErrorUnknown": "Ein Fehler ist aufgetreten",
    "textResumeCourse": "Kurs fortsetzen",
    "accountLabelEmail": "E-Mail",
    "ctaTextReschedule": "Verschieben",
    "ctaTextSelfGuided": "Module ansehen",
    "ctaTextViewCourse": "Zum Kurs",
    "formLabelAttended": "Besucht",
    "headerAccountInfo": "Kontoinformationen",
    "textErrorPageHome": "Start",
    "textPreviousTopic": "Zurück",
    "ctaTextCancelClass": "Diesen Kurs abbrechen",
    "formInputLabelDate": "Datum",
    "headerPersonalInfo": "Persönliche Informationen",
    "labelSubcategories": "Unterkategorien",
    "searchResultStatus": "Ergebnisse gefunden",
    "selfguidedLearning": "Selbstständiges Lernen",
    "textBreadcrumbRoot": "Dropbox-Schulungen",
    "textCourseProgress": "Fortschritt",
    "formInputLabelEmail": "E-Mail",
    "globalTextCopyright": "Copyright-Text",
    "signInpopUpBodyText": "Behalten Sie den Überblick über die von Ihnen absolvierten Module",
    "textDropdownDefault": "Die Zeiten richten sich nach Ihrer Zeitzone",
    "textErrorPageSignIn": "Anmelden",
    "textTableOfContents": "Module",
    "canceledRegistration": "Registrierung erfolgreich abgebrochen",
    "formInputLabelCourse": "Kurs",
    "formInputLabelStatus": "Status",
    "searchFilterLanguage": "Sprache",
    "searchResultsPerPage": "Ergebnisse pro Seite",
    "textSigninModalIntro": "Melden Sie sich an, um Ihren Fortschritt zu speichern",
    "topicCountTextPlural": "Themen",
    "topicCountTextSingle": "Thema",
    "headerSuggestedTopics": "Empfohlene Module",
    "searchFilterOptionSgc": "Kurse für das Selbststudium",
    "searchResultTypeTopic": "Modul",
    "searchResultTypeVideo": "Video",
    "textAlreadyRegistered": "Sie haben sich bereits für dieses Webinar registriert.",
    "textYouMustLogInFirst": "Sie müssen sich zuerst anmelden",
    "formInputLabelAttendee": "Teilnehmer",
    "formInputLabelLastName": "Nachname",
    "formInputLabelOverview": "Überblick",
    "headerEventDescription": "Beschreibung der Schulung",
    "headerProfileCompleted": "Abgeschlossen",
    "searchFilterOptionLive": "Live-Schulung",
    "searchFilterOptionTeam": "Teammitglied",
    "textCourseExpectations": "Was ändert sich?",
    "textLearningObjectives": "Welche Themen werden behandelt?",
    "formInputLabelFirstName": "Vorname",
    "headerProfileInProgress": " In Arbeit",
    "pageVideoCategoriesSync": "Synchronisierung",
    "searchFilterContentType": "Inhaltstyp",
    "searchFilterOptionAdmin": "Administrator",
    "searchFilterOptionTopic": "Modul",
    "searchPageTitleMetadata": "Suche | Dropbox-Schulungen",
    "textErrorPageHelpCenter": "Hilfecenter",
    "formInputLabelSelectDate": "Datum auswählen",
    "formInputLabelSelectTime": "Zeit auswählen",
    "headerProfileLiveCourses": "Künftige Kurse",
    "pageVideoCategoriesShare": "Freigeben",
    "formInputLabelSessionLink": "Link für die Sitzung",
    "textErrorPageHelpfulLinks": "Hier sind einige nützliche Links:",
    "textErrorPagePageNotFound": "Die gesuchte Seite wurde nicht gefunden.",
    "textRegistrationCompleted": "Sie sind registriert",
    "breadcrumbTextRegistration": "Registrierung",
    "formInputLabelPickLanguage": "Sprache auswählen",
    "pageVideoCategoriesWebinar": "Webinar",
    "searchPageKeywordsMetadata": "Suche",
    "searchResultTypeSelfGuided": "Kurs",
    "ctaTextCompleteRegistration": "Vervollständigen Sie Ihre Registrierung",
    "headerEnterRegistrationInfo": "Registrierungsdaten eingeben",
    "headerRegisteredLiveCourses": "Registrierte virtuelle Schulungen",
    "pageVideoCategoriesInstalls": "Installieren",
    "pageVideoCategoriesOrganize": "Organisieren",
    "pageVideoCategoriesProducts": "Produkte",
    "pageVideoCategoriesSecurity": "Sicherheit",
    "searchFilterOptionRoleAdmin": "Administrator",
    "searchResultTypeLiveSession": "Live-Schulung",
    "headerRegistrationSuccessful": "Sie sind jetzt registriert",
    "headerSearchInputPlaceholder": "Suchen",
    "pageVideoSubcategoriesDelete": "Löschen",
    "pageVideoSubcategoriesReplay": "Replay",
    "pageVideoSubcategoriesRewind": "Zurücksetzen",
    "pageVideoSubcategoriesSignIn": "Anmelden",
    "searchFilterOptionIndividual": "Einzelnutzer",
    "formInputLabelCourseCompleted": "Kurs abgeschlossen",
    "pageVideoSubcategoriesCapture": "Capture",
    "pageVideoSubcategoriesRestore": "Wiederherstellen",
    "searchPageDescriptionMetadata": "Sie können weitere Module und Informationen suchen, um mehr über unsere Kurse zu erfahren. Finden Sie das für Sie richtige Dropbox-Training oder einen passenden Kurs zum Selbststudium.",
    "pageVideoCategoriesViewAndEdit": "Lesen und bearbeiten",
    "pageVideoSubcategoriesTransfer": "Transfer",
    "searchFilterOptionRoleHelpDesk": "Helpdesk",
    "textCalendarShortWeekdayFriday": "Fr.",
    "textCalendarShortWeekdayMonday": "Mo.",
    "textCalendarShortWeekdaySunday": "So.",
    "pageVideoSubcategoriesMobileApp": "Mobile App",
    "textCalendarShortWeekdayTuesday": "Di.",
    "textEmailConfirmationWillBeSent": "Prüfen Sie Ihren Posteingang auf eine Bestätigungs-E-Mail.",
    "headerLiveCourseHighlightsHeader": "Diese Themen werden behandelt:",
    "pageVideoCategoriesAccountAccess": "Kontozugriff",
    "pageVideoSubcategoriesTeamAccess": "Teamzugriff",
    "searchFilterOptionRoleTeamMember": "Teammitglied",
    "textCalendarShortWeekdaySaturday": "Sa.",
    "textCalendarShortWeekdayThursday": "Do.",
    "formInputLabelGeneralRegistration": "Allgemeine Registrierung",
    "pageVideoSubcategoriesDropboxDash": "Dropbox Dash",
    "pageVideoSubcategoriesTeamFolders": "Team-Ordner",
    "textCalendarShortWeekdayWednesday": "Mi.",
    "formInputLabelGlobalSelectLanguage": "Sprache auswählen",
    "formInputLabelSelectDateBreadcrumb": "Datum auswählen",
    "pageVideoCategoriesAccountSettings": "Kontoeinstellungen",
    "pageVideoCategoriesCreateAndUpload": "Erstellen und hochladen",
    "pageVideoSubcategoriesTeamSecurity": "Team-Sicherheit",
    "searchFilterOptionRoleFundamentals": "Grundlagen",
    "pageVideoCategoriesDeleteAndRestore": "Löschen und wiederherstellen",
    "pageCourseTopicTableOfContentsHeading": "Inhalt",
    "pageVideoSubcategoriesDropboxPolicies": "Dropbox-Richtlinien",
    "pageVideoSubcategoriesOnDemandTraining": "Auf Abruf verfügbare Schulungen",
    "pageVideoSubcategoriesCommentingOnFiles": "Das Kommentieren von Dateien",
    "pageVideoSubcategoriesSharingPermissions": "Freigabeberechtigungen",
    "pageVideoSubcategoriesDropboxApplications": "Dropbox-Apps",
    "pageVideoSubcategoriesSearchingYourAccount": "Ihr Konto durchsuchen",
    "pageVideoSubcategoriesManagingAccountAccess": "Kontozugriff verwalten",
    "pageVideoSubcategoriesSharingFilesAndFolders": "Dateien und Ordner freigeben",
    "pageVideoSubcategoriesCreatingFilesAndFolders": "Dateien und Ordner erstellen"
  },
  "copyrightText": "Dropbox 2021",
  "seo": {
    "title": {
      "name": "title",
      "value": "Dropbox learn"
    },
    "keywords": {
      "name": "keywords",
      "value": ""
    },
    "og:image": {
      "name": "og:image",
      "value": {
        "id": "2z2Foc0s6DPlQV1aTtWO3b",
        "url": "https://images.ctfassets.net/zh1yxk5yn2r7/2z2Foc0s6DPlQV1aTtWO3b/b0c0e0a58102dd90281f7b1df860a370/Dropbox.svg",
        "title": "Dropbox Logo"
      }
    },
    "og:title": {
      "name": "og:title",
      "value": "Dropbox learn"
    },
    "canonical": {
      "name": "canonical",
      "value": ""
    },
    "description": {
      "name": "description",
      "value": "Learn how to use Dropbox. Browse our catalog of free self-guided courses and virtual instructor led training sessions. Start a Dropbox training course today."
    },
    "twitter:image": {
      "name": "twitter:image",
      "value": {
        "id": "2z2Foc0s6DPlQV1aTtWO3b",
        "url": "https://images.ctfassets.net/zh1yxk5yn2r7/2z2Foc0s6DPlQV1aTtWO3b/b0c0e0a58102dd90281f7b1df860a370/Dropbox.svg",
        "title": "Dropbox Logo"
      }
    },
    "twitter:title": {
      "name": "twitter:title",
      "value": "Dropbox learn"
    },
    "og:description": {
      "name": "og:description",
      "value": "Learn how to use Dropbox. Browse our catalog of free self-guided courses and virtual instructor led training sessions. Start a Dropbox training course today."
    },
    "twitter:description": {
      "name": "twitter:description",
      "value": "Learn how to use Dropbox. Browse our catalog of free self-guided courses and virtual instructor led training sessions. Start a Dropbox training course today."
    }
  },
  "seoOrganizationsSchema": {
    "url": "http://www.dropbox.com",
    "@type": "Organization",
    "@context": "http://schema.org",
    "contactPoint": [
      {
        "@type": "ContactPoint",
        "telephone": "+1-888-888-8888",
        "areaServed": "US",
        "contactType": "customer service",
        "contactOption": "TollFree"
      },
      {
        "@type": "ContactPoint",
        "telephone": "+1-888-888-8888",
        "contactType": "customer service"
      },
      {
        "@type": "ContactPoint",
        "telephone": "+1-888-888-8888",
        "areaServed": "US",
        "contactType": "customer service",
        "contactOption": [
          "HearingImpairedSupported",
          "TollFree"
        ]
      },
      {
        "@type": "ContactPoint",
        "telephone": "+1-888-888-8888",
        "areaServed": [
          "US",
          "CA"
        ],
        "contactType": "technical support",
        "contactOption": "TollFree",
        "availableLanguage": [
          "English",
          "French"
        ]
      },
      {
        "@type": "ContactPoint",
        "telephone": "+1-888-888-8888",
        "areaServed": [
          "US",
          "CA"
        ],
        "contactType": "bill payment",
        "contactOption": "TollFree"
      }
    ]
  }
}
  },
  "it": {
    isDefault: false,
    settings: {
  "_id": "4KRGLSrqTRY6s18UzHe1II",
  "_contentTypeId": "settingsGlobal",
  "_modifiedDate": "2026-05-14T04:59:02.660Z",
  "internalTitle": "CX Learning Hub Global Settings",
  "topNavigationLogo": {
    "title": "Dropbox Logo",
    "url": "//images.ctfassets.net/zh1yxk5yn2r7/2z2Foc0s6DPlQV1aTtWO3b/b0c0e0a58102dd90281f7b1df860a370/Dropbox.svg",
    "size": 3707,
    "width": 324,
    "height": 64,
    "filename": "Dropbox.svg",
    "contentType": "image/svg+xml"
  },
  "mainNavigation": [
    {
      "internalTitle": "Footer Link - Help center",
      "linkText": "Centro assistenza",
      "destinationType": "Manual text entry",
      "trackingId": "learn-support-help-center",
      "_id": "5pPOxJP1W9PaPBCnLHhe5x",
      "_contentTypeId": "elementLink",
      "href": "https://help.dropbox.com",
      "as": null,
      "target": null,
      "isModal": false,
      "download": false
    },
    {
      "internalTitle": "Supernav - Dropbox Community",
      "linkText": "Community",
      "destinationType": "Manual text entry",
      "_id": "7aVH719lug9lYEJzIntabM",
      "_contentTypeId": "elementLink",
      "href": "https://community.dropbox.com/",
      "as": null,
      "target": "_blank",
      "isModal": false,
      "download": false
    },
    {
      "internalTitle": "Footer Link - Contact us",
      "linkText": "Contattaci",
      "destinationType": "Manual text entry",
      "trackingId": "learn-support-contact-us",
      "_id": "5v3vwPdKulQu6xhA6csIT8",
      "_contentTypeId": "elementLink",
      "href": "https://www.dropbox.com/contact",
      "as": null,
      "target": null,
      "isModal": false,
      "download": false
    }
  ],
  "secondaryNavigation": [
    {
      "internalTitle": "Secondary Nav - Self-guided learning",
      "linkText": "Formazione autoguidata",
      "destinationType": "Content reference",
      "_id": "oMqs4whMJuBjhZsbMv0KA",
      "_contentTypeId": "elementLink",
      "href": "/[slug]",
      "as": "/self-guided-learning",
      "target": null,
      "isModal": false,
      "download": false
    },
    {
      "internalTitle": "Secondary Nav - Videos Landing Page",
      "linkText": "Video",
      "destinationType": "Content reference",
      "_id": "5y8ArqrhCZ6DoCCGxaumhI",
      "_contentTypeId": "elementLink",
      "href": "/[slug]",
      "as": "/video-library",
      "target": null,
      "isModal": false,
      "download": false
    }
  ],
  "footerNavigation": [
    {
      "_id": "1M79uBMmyuD9Iw6fuOdVEJ",
      "_contentTypeId": "elementFooterNavColumn",
      "_modifiedDate": "2026-05-06T15:28:27.147Z",
      "internalTitle": "Dropbox",
      "links": [
        {
          "internalTitle": "Footer Link - Desktop app",
          "linkText": "Applicazione desktop",
          "destinationType": "Manual text entry",
          "trackingId": "learn-dropbox-desktop-app",
          "_id": "3SKeLjF7MWEq2FqaRwnmiK",
          "_contentTypeId": "elementLink",
          "href": "https://www.dropbox.com/desktop",
          "as": null,
          "target": null,
          "isModal": false,
          "download": false
        },
        {
          "internalTitle": "Footer Link - Mobile app",
          "linkText": "Applicazione per dispositivi mobili",
          "destinationType": "Manual text entry",
          "trackingId": "learn-dropbox-mobile-app",
          "_id": "62ymoNSBbWiYinBkFO0cGj",
          "_contentTypeId": "elementLink",
          "href": "https://www.dropbox.com/mobile",
          "as": null,
          "target": null,
          "isModal": false,
          "download": false
        },
        {
          "internalTitle": "Footer Link - Integrations",
          "linkText": "Integrations",
          "destinationType": "Manual text entry",
          "trackingId": "learn-dropbox-integrations",
          "_id": "5WEO1xpKelxpyXS50n3Dxc",
          "_contentTypeId": "elementLink",
          "href": "https://www.dropbox.com/app-integrations",
          "as": null,
          "target": null,
          "isModal": false,
          "download": false
        },
        {
          "internalTitle": "Footer Link - Features",
          "linkText": "Funzioni",
          "destinationType": "Manual text entry",
          "trackingId": "learn-dropbox-features",
          "_id": "wUuQPtOLYz96QOSvtgLTh",
          "_contentTypeId": "elementLink",
          "href": "https://www.dropbox.com/features",
          "as": null,
          "target": null,
          "isModal": false,
          "download": false
        },
        {
          "internalTitle": "Footer Link - Solutions",
          "linkText": "Solutions",
          "destinationType": "Manual text entry",
          "trackingId": "learn-dropbox-solutions",
          "_id": "14SJorC6JrH7u2O5E8vf2E",
          "_contentTypeId": "elementLink",
          "href": "https://www.dropbox.com/business/solutions",
          "as": null,
          "target": null,
          "isModal": false,
          "download": false
        },
        {
          "internalTitle": "Footer Link - Security",
          "linkText": "Sicurezza",
          "destinationType": "Manual text entry",
          "trackingId": "learn-dropbox-security",
          "_id": "2YZlyLOZLw2lauy2OWiuB2",
          "_contentTypeId": "elementLink",
          "href": "https://www.dropbox.com/features/security",
          "as": null,
          "target": null,
          "isModal": false,
          "download": false
        },
        {
          "internalTitle": "Footer Link - Early access",
          "linkText": "Early access",
          "destinationType": "Manual text entry",
          "trackingId": "learn-dropbox-early-access",
          "_id": "6u2aXFqnr9s1KXkSjfc2cz",
          "_contentTypeId": "elementLink",
          "href": "https://www.dropbox.com/early-access",
          "as": null,
          "target": null,
          "isModal": false,
          "download": false
        },
        {
          "internalTitle": "Footer Link - Templates",
          "linkText": "Templates",
          "destinationType": "Manual text entry",
          "trackingId": "learn-dropbox-templates",
          "_id": "4yIX8tA1WW1soyk10Frgz5",
          "_contentTypeId": "elementLink",
          "href": "https://www.dropbox.com/templates",
          "as": null,
          "target": null,
          "isModal": false,
          "download": false
        },
        {
          "internalTitle": "Footer Link - Free tools",
          "linkText": "Strumenti gratuiti",
          "destinationType": "Manual text entry",
          "trackingId": "learn-dropbox-free-tools",
          "_id": "3Fdgsos4Pm77l2C4hKm2AC",
          "_contentTypeId": "elementLink",
          "href": "https://www.dropbox.com/tools",
          "as": null,
          "target": null,
          "isModal": false,
          "download": false
        }
      ]
    },
    {
      "_id": "6LXqBrZEH3p2eDbBpiPFlm",
      "_contentTypeId": "elementFooterNavColumn",
      "_modifiedDate": "2026-05-06T15:28:27.418Z",
      "internalTitle": "Prodotti",
      "links": [
        {
          "internalTitle": "Footer Link - Plus",
          "linkText": "Plus",
          "destinationType": "Manual text entry",
          "trackingId": "learn-products-plus",
          "_id": "4nThAv7YjSuKC91UBK1AoR",
          "_contentTypeId": "elementLink",
          "href": "https://www.dropbox.com/plus",
          "as": null,
          "target": null,
          "isModal": false,
          "download": false
        },
        {
          "internalTitle": "Footer Link -  Professional",
          "linkText": "Professional",
          "destinationType": "Manual text entry",
          "trackingId": "learn-products-professional",
          "_id": "5YtdEKxrCJgHqmmDvwgnQI",
          "_contentTypeId": "elementLink",
          "href": "https://www.dropbox.com/pro",
          "as": null,
          "target": "_blank",
          "isModal": false,
          "download": false
        },
        {
          "internalTitle": "Footer Link - Business",
          "linkText": "Settore",
          "destinationType": "Manual text entry",
          "trackingId": "learn-products-business",
          "_id": "5L4PFaY36Icmt95mUTgjOC",
          "_contentTypeId": "elementLink",
          "href": "https://www.dropbox.com/business",
          "as": null,
          "target": null,
          "isModal": false,
          "download": false
        },
        {
          "internalTitle": "Footer Link - Enterprise",
          "linkText": "Enterprise",
          "destinationType": "Manual text entry",
          "trackingId": "learn-products-enterprise",
          "_id": "4KJcgnikVfGiWIaFiuiRIM",
          "_contentTypeId": "elementLink",
          "href": "https://www.dropbox.com/enterprise",
          "as": null,
          "target": null,
          "isModal": false,
          "download": false
        },
        {
          "internalTitle": "Footer Link - Dash",
          "linkText": "Dash",
          "destinationType": "Manual text entry",
          "trackingId": "learn-products-dash",
          "_id": "4qdbH5UT1PZYVWp4vOADQa",
          "_contentTypeId": "elementLink",
          "href": "https://dash.dropbox.com",
          "as": null,
          "target": null,
          "isModal": false,
          "download": false
        },
        {
          "internalTitle": "Footer Link - DocSend",
          "linkText": "DocSend",
          "destinationType": "Manual text entry",
          "trackingId": "learn-products-docsend",
          "_id": "5hUjrT7Yza4eLKxBevHcAF",
          "_contentTypeId": "elementLink",
          "href": "https://www.docsend.com/?utm_medium=Referral&utm_source=Dropbox%20Web%20Referral&utm_campaign=dbx-footer",
          "as": null,
          "target": null,
          "isModal": false,
          "download": false
        },
        {
          "internalTitle": "Footer Link - Dropbox Sign",
          "linkText": "Dropbox Sign",
          "destinationType": "Manual text entry",
          "trackingId": "learn-products-sign",
          "_id": "4ennWEzf0rjxfCiNTEiU9w",
          "_contentTypeId": "elementLink",
          "href": "https://sign.dropbox.com",
          "as": null,
          "target": null,
          "isModal": false,
          "download": false
        },
        {
          "internalTitle": "Footer Link - Reclaim.ai",
          "linkText": "Reclaim.ai",
          "destinationType": "Manual text entry",
          "trackingId": "learn-products-reclaim-ai",
          "_id": "5XGB9J0ZeBff2lXEapKBR1",
          "_contentTypeId": "elementLink",
          "href": "https://app.reclaim.ai/signup?utm_medium=referral&utm_source=dbx-footer-referral&utm_campaign=dbx-footer-signup&utm_term=dbx-footer",
          "as": null,
          "target": null,
          "isModal": false,
          "download": false
        },
        {
          "internalTitle": "Footer Link - Plans",
          "linkText": "Piani",
          "destinationType": "Manual text entry",
          "trackingId": "learn-products-plans",
          "_id": "13TtJzOJV2eQoZ3TQbNVdd",
          "_contentTypeId": "elementLink",
          "href": "https://www.dropbox.com/plans",
          "as": null,
          "target": null,
          "isModal": false,
          "download": false
        },
        {
          "internalTitle": "Footer Link - Product updates",
          "linkText": "Product updates",
          "destinationType": "Manual text entry",
          "trackingId": "learn-products-updates",
          "_id": "45NCupQTJZJEBQ1r1pFDDf",
          "_contentTypeId": "elementLink",
          "href": "https://www.dropbox.com/product-updates",
          "as": null,
          "target": null,
          "isModal": false,
          "download": false
        }
      ]
    },
    {
      "_id": "74RyIf3Qiipq4XbcIPQQwT",
      "_contentTypeId": "elementFooterNavColumn",
      "_modifiedDate": "2026-05-06T15:28:27.829Z",
      "internalTitle": "Features",
      "links": [
        {
          "internalTitle": "Footer Link - Send large files",
          "linkText": "Send large files",
          "destinationType": "Manual text entry",
          "trackingId": "learn-features-send-large-files",
          "_id": "48eVY6niBIXx4YAPA4XKWz",
          "_contentTypeId": "elementLink",
          "href": "https://www.dropbox.com/features/share/send-large-files",
          "as": null,
          "target": null,
          "isModal": false,
          "download": false
        },
        {
          "internalTitle": "Footer Link - Send long videos",
          "linkText": "Send long videos",
          "destinationType": "Manual text entry",
          "trackingId": "learn-features-send-long-videos",
          "_id": "75e4Pf3aV5ZnB77zgoYITc",
          "_contentTypeId": "elementLink",
          "href": "https://www.dropbox.com/features/share/send-long-videos",
          "as": null,
          "target": null,
          "isModal": false,
          "download": false
        },
        {
          "internalTitle": "Footer Link - Cloud photo storage",
          "linkText": "Cloud photo storage",
          "destinationType": "Manual text entry",
          "trackingId": "learn-features-cloud-photo-storage",
          "_id": "64WyEAeXS80TWroqmR8eHy",
          "_contentTypeId": "elementLink",
          "href": "https://www.dropbox.com/features/cloud-storage/photos",
          "as": null,
          "target": null,
          "isModal": false,
          "download": false
        },
        {
          "internalTitle": "Footer Link - Secure file transfer",
          "linkText": "Secure file transfer",
          "destinationType": "Manual text entry",
          "trackingId": "learn-features-send-secure-file-transfer",
          "_id": "9bUiqp6kN7PfQDoP5dVEA",
          "_contentTypeId": "elementLink",
          "href": "https://www.dropbox.com/features/share/file-transfer",
          "as": null,
          "target": null,
          "isModal": false,
          "download": false
        },
        {
          "internalTitle": "Footer Link - Cloud backup",
          "linkText": "Cloud backup",
          "destinationType": "Manual text entry",
          "trackingId": "learn-features-cloud-backup",
          "_id": "4kYfwCJpM6hsTbLd622yzc",
          "_contentTypeId": "elementLink",
          "href": "https://www.dropbox.com/features/cloud-storage/file-backup",
          "as": null,
          "target": null,
          "isModal": false,
          "download": false
        },
        {
          "internalTitle": "Footer Link - Edit PDFs",
          "linkText": "Edit PDFs",
          "destinationType": "Manual text entry",
          "trackingId": "learn-features-edit-pdfs",
          "_id": "1Fw9zhaVelLXfOpxEQwsAy",
          "_contentTypeId": "elementLink",
          "href": "https://www.dropbox.com/features/productivity/pdf-editor",
          "as": null,
          "target": null,
          "isModal": false,
          "download": false
        },
        {
          "internalTitle": "Footer Link - Electronic signatures",
          "linkText": "Electronic signatures",
          "destinationType": "Manual text entry",
          "trackingId": "learn-features-electronic-signatures",
          "_id": "6nhjK34qVMZlkA2opn0vWj",
          "_contentTypeId": "elementLink",
          "href": "https://www.dropbox.com/features/productivity/electronic-signature",
          "as": null,
          "target": null,
          "isModal": false,
          "download": false
        },
        {
          "internalTitle": "Footer Link - Convert to PDF",
          "linkText": "Convert to PDF",
          "destinationType": "Manual text entry",
          "trackingId": "learn-features-convert-to-pdf",
          "_id": "4a7MNYwiyhj6OtmYb87co0",
          "_contentTypeId": "elementLink",
          "href": "https://www.dropbox.com/features/productivity/convert-to-pdf",
          "as": null,
          "target": null,
          "isModal": false,
          "download": false
        }
      ]
    },
    {
      "_id": "1TnZWWGdwo9BEkEKgcIGpA",
      "_contentTypeId": "elementFooterNavColumn",
      "_modifiedDate": "2026-05-06T15:28:27.248Z",
      "internalTitle": "Supporto",
      "links": [
        {
          "internalTitle": "Footer Link - Help center",
          "linkText": "Centro assistenza",
          "destinationType": "Manual text entry",
          "trackingId": "learn-support-help-center",
          "_id": "5pPOxJP1W9PaPBCnLHhe5x",
          "_contentTypeId": "elementLink",
          "href": "https://help.dropbox.com",
          "as": null,
          "target": null,
          "isModal": false,
          "download": false
        },
        {
          "internalTitle": "Footer Link - Contact us",
          "linkText": "Contattaci",
          "destinationType": "Manual text entry",
          "trackingId": "learn-support-contact-us",
          "_id": "5v3vwPdKulQu6xhA6csIT8",
          "_contentTypeId": "elementLink",
          "href": "https://www.dropbox.com/contact",
          "as": null,
          "target": null,
          "isModal": false,
          "download": false
        },
        {
          "internalTitle": "Footer Link - Privacy & terms",
          "linkText": "Privacy e Termini",
          "destinationType": "Manual text entry",
          "trackingId": "learn-support-privacy-terms",
          "_id": "30MJJnJ2DIcvhYL2wsg0FB",
          "_contentTypeId": "elementLink",
          "href": "https://www.dropbox.com/terms",
          "as": null,
          "target": null,
          "isModal": false,
          "download": false
        },
        {
          "internalTitle": "Footer Link - Cookie policy",
          "linkText": "Norme sui cookie",
          "destinationType": "Manual text entry",
          "trackingId": "learn-support-cookie-policy",
          "_id": "3akG8gNhd73ZlRaEYSCvUD",
          "_contentTypeId": "elementLink",
          "href": "https://help.dropbox.com/security/cookies",
          "as": null,
          "target": null,
          "isModal": false,
          "download": false
        },
        {
          "internalTitle": "Footer Link - Cookies & CCPA preferences",
          "linkText": "Preferenze cookie e CCPA",
          "destinationType": "Manual text entry",
          "trackingId": "learn-support-cookies-CCPA",
          "_id": "65mwIIQg9xKeyKiICuy9DJ",
          "_contentTypeId": "elementLink",
          "href": "https://www.dropbox.com/app-integrations#manage-cookies",
          "as": null,
          "target": null,
          "isModal": false,
          "download": false
        },
        {
          "internalTitle": "Footer Link - AI principles",
          "linkText": "Principi sull'intelligenza artificiale",
          "destinationType": "Manual text entry",
          "trackingId": "learn-support-ai-principles",
          "_id": "5mTsyPahdNgokTvducSB9i",
          "_contentTypeId": "elementLink",
          "href": "https://www.dropbox.com/ai-principles",
          "as": null,
          "target": null,
          "isModal": false,
          "download": false
        },
        {
          "internalTitle": "Footer Link - Sitemap",
          "linkText": "Mappa del sito",
          "destinationType": "Manual text entry",
          "trackingId": "learn-support-sitemap",
          "_id": "37byNy2Pux5TAcdSJm6g4f",
          "_contentTypeId": "elementLink",
          "href": "https://experience.dropbox.com/sitemap",
          "as": null,
          "target": null,
          "isModal": false,
          "download": false
        },
        {
          "internalTitle": "Footer Link - Learning resources",
          "linkText": "Risorse di formazione",
          "destinationType": "Manual text entry",
          "trackingId": "learn-support-learning-resources",
          "_id": "Gj2OgkkQcCs8BXTBr5Irc",
          "_contentTypeId": "elementLink",
          "href": "https://learn.dropbox.com",
          "as": null,
          "target": null,
          "isModal": false,
          "download": false
        }
      ]
    },
    {
      "_id": "28o2jcc5DrafqCYZ9icYU7",
      "_contentTypeId": "elementFooterNavColumn",
      "_modifiedDate": "2026-05-06T15:28:26.982Z",
      "internalTitle": "Risorse",
      "links": [
        {
          "internalTitle": "Footer Link - Blog",
          "linkText": "Blog",
          "destinationType": "Manual text entry",
          "trackingId": "learn-resources-blog",
          "_id": "4vYa3RKqQLWA8bNHcaPX69",
          "_contentTypeId": "elementLink",
          "href": "https://blog.dropbox.com",
          "as": null,
          "target": null,
          "isModal": false,
          "download": false
        },
        {
          "internalTitle": "Footer Link - Events",
          "linkText": "Events",
          "destinationType": "Manual text entry",
          "trackingId": "learn-resources-events",
          "_id": "2D8JKIOdP8zjqZCfsqIG5l",
          "_contentTypeId": "elementLink",
          "href": "https://events.dropbox.com/",
          "as": null,
          "target": null,
          "isModal": false,
          "download": false
        },
        {
          "internalTitle": "Footer Link - Customer stories",
          "linkText": "Storie di clienti",
          "destinationType": "Manual text entry",
          "trackingId": "learn-resources-customer-stories",
          "_id": "49GkLGyFuV1GvXf1DozTPZ",
          "_contentTypeId": "elementLink",
          "href": "https://www.dropbox.com/customers",
          "as": null,
          "target": null,
          "isModal": false,
          "download": false
        },
        {
          "internalTitle": "Footer Link - Resources library",
          "linkText": "Resources library",
          "destinationType": "Manual text entry",
          "trackingId": "learn-resources-resources-library",
          "_id": "3l98eLMkEyPoj0jzqgBvj7",
          "_contentTypeId": "elementLink",
          "href": "https://www.dropbox.com/resources",
          "as": null,
          "target": null,
          "isModal": false,
          "download": false
        },
        {
          "internalTitle": "Footer Link - Developers",
          "linkText": "Developers",
          "destinationType": "Manual text entry",
          "trackingId": "learn-resources-developers",
          "_id": "2aFb3GcSJS0YIEU3aKbLzj",
          "_contentTypeId": "elementLink",
          "href": "https://www.dropbox.com/developers",
          "as": null,
          "target": null,
          "isModal": false,
          "download": false
        },
        {
          "internalTitle": "Footer Link - Community forums",
          "linkText": "Forum della community",
          "destinationType": "Manual text entry",
          "trackingId": "learn-resources-community-forums",
          "_id": "4IGtm6twVWzfoE07kHlucc",
          "_contentTypeId": "elementLink",
          "href": "https://community.dropbox.com",
          "as": null,
          "target": null,
          "isModal": false,
          "download": false
        },
        {
          "internalTitle": "Footer Link - Referrals",
          "linkText": "Referral",
          "destinationType": "Manual text entry",
          "trackingId": "learn-resources-referrals",
          "_id": "4YsKqwQfAG4Ds0a0yeo9wp",
          "_contentTypeId": "elementLink",
          "href": "https://www.dropbox.com/refer",
          "as": null,
          "target": null,
          "isModal": false,
          "download": false
        },
        {
          "internalTitle": "Footer Link - Reseller partners",
          "linkText": "Partner rivenditori",
          "destinationType": "Manual text entry",
          "trackingId": "learn-resources-reseller-partners",
          "_id": "1w7KmWfsigadpZje40tk18",
          "_contentTypeId": "elementLink",
          "href": "https://www.dropbox.com/business/partners",
          "as": null,
          "target": null,
          "isModal": false,
          "download": false
        },
        {
          "internalTitle": "Footer Link - Integration partners",
          "linkText": "Integration partners",
          "destinationType": "Manual text entry",
          "trackingId": "learn-resources-integration-partners",
          "_id": "6dgcNUDLbEeXQE94s71vrO",
          "_contentTypeId": "elementLink",
          "href": "https://www.dropbox.com/app-integrations",
          "as": null,
          "target": null,
          "isModal": false,
          "download": false
        },
        {
          "internalTitle": "Footer Link - Find a partner",
          "linkText": "Find a partner",
          "destinationType": "Manual text entry",
          "trackingId": "learn-resources-find-a-partner",
          "_id": "2wQU48ntbukgQSKuTKS9in",
          "_contentTypeId": "elementLink",
          "href": "https://experience.dropbox.com/partner-locator",
          "as": null,
          "target": null,
          "isModal": false,
          "download": false
        }
      ]
    },
    {
      "_id": "5xRp5jjLsl92vmGL0qJfVb",
      "_contentTypeId": "elementFooterNavColumn",
      "_modifiedDate": "2026-05-06T15:28:26.948Z",
      "internalTitle": "Azienda",
      "links": [
        {
          "internalTitle": "Footer Link - About us",
          "linkText": "Chi siamo",
          "destinationType": "Manual text entry",
          "trackingId": "learn-company-about-us",
          "_id": "6XnBD8OrJfQZ4u3ZSc6ysr",
          "_contentTypeId": "elementLink",
          "href": "https://www.dropbox.com/about",
          "as": null,
          "target": null,
          "isModal": false,
          "download": false
        },
        {
          "internalTitle": "Footer Link - Jobs",
          "linkText": "Jobs",
          "destinationType": "Manual text entry",
          "trackingId": "learn-company-jobs",
          "_id": "1nmf2X1QaLv7zS1PIyfqlE",
          "_contentTypeId": "elementLink",
          "href": "https://jobs.dropbox.com",
          "as": null,
          "target": null,
          "isModal": false,
          "download": false
        },
        {
          "internalTitle": "Footer Link - Investor relations",
          "linkText": "Relazioni con gli investitori",
          "destinationType": "Manual text entry",
          "trackingId": "learn-company-investor-relations",
          "_id": "73WTKUyXSmqc5aP1OfisZ9",
          "_contentTypeId": "elementLink",
          "href": "https://dropbox.gcs-web.com/",
          "as": null,
          "target": null,
          "isModal": false,
          "download": false
        },
        {
          "internalTitle": "Footer Link - Corporate responsibility",
          "linkText": "Responsabilità aziendale",
          "destinationType": "Manual text entry",
          "trackingId": "learn-company-corporate-responsibility",
          "_id": "5iMgmL64RXCXtz8iRkrIIM",
          "_contentTypeId": "elementLink",
          "href": "https://www.dropbox.com/corporate-responsibility",
          "as": null,
          "target": null,
          "isModal": false,
          "download": false
        }
      ]
    }
  ],
  "cookieBarBody": "Usiamo i cookie per rendere possibile il corretto funzionamento di Dropbox per te. Utilizzando il nostro sito, accetti le nostre modalità di utilizzo dei cookie.",
  "cookieBarCta": {
    "internalTitle": "Link Text - Cookie bar",
    "linkText": "Ulteriori informazioni",
    "destinationType": "Manual text entry",
    "_id": "1tY3PGTzdIHKRi4pDNbmSM",
    "_contentTypeId": "elementLink",
    "href": "https://help.dropbox.com/accounts-billing/security/cookies",
    "as": null,
    "target": "_blank",
    "isModal": false,
    "download": false
  },
  "cookieBarEnabled": true,
  "virtualTrainingsEmptyState": {
    "data": {},
    "content": [
      {
        "data": {},
        "content": [
          {
            "data": {},
            "marks": [],
            "value": "Ancora nessun elemento da visualizzare. Iscriviti a una ",
            "nodeType": "text"
          },
          {
            "data": {
              "target": null
            },
            "content": [
              {
                "data": {},
                "marks": [],
                "value": "sessione di formazione virtuale",
                "nodeType": "text"
              }
            ],
            "nodeType": "entry-hyperlink"
          },
          {
            "data": {},
            "marks": [],
            "value": ".",
            "nodeType": "text"
          }
        ],
        "nodeType": "paragraph"
      }
    ],
    "nodeType": "document"
  },
  "completedCoursesEmptyState": {
    "data": {},
    "content": [
      {
        "data": {},
        "content": [
          {
            "data": {},
            "marks": [],
            "value": "I corsi che hai completato compariranno qui.",
            "nodeType": "text"
          }
        ],
        "nodeType": "paragraph"
      }
    ],
    "nodeType": "document"
  },
  "inProgressCoursesEmptyState": {
    "data": {},
    "content": [
      {
        "data": {},
        "content": [
          {
            "data": {},
            "marks": [],
            "value": "Ancora nessun elemento da visualizzare. Inizia un ",
            "nodeType": "text"
          },
          {
            "data": {
              "target": {
                "_id": "75pzFP9abHFb2hlQycUS86",
                "_contentTypeId": "pageLanding",
                "_href": "/[slug]",
                "_as": "/self-guided-learning",
                "_modifiedDate": "2026-07-14T14:56:10.933Z",
                "internalTitle": "L2 - Landing page - Self-guided learning",
                "name": "Formazione autoguidata",
                "slug": "self-guided-learning",
                "introHero": {
                  "_id": "6pQlpoBglvzGW38DBWvU5W",
                  "_contentTypeId": "moduleHero",
                  "_modifiedDate": "2026-05-15T16:06:56.370Z",
                  "internalTitle": "Hero - Self-guided learning",
                  "headerText": "Formazione autoguidata",
                  "summaryText": "Scopri i corsi guidati per Dropbox, Dash, Replay, Sign e altro ancora. Scegli quello che corrisponde a ciò che devi fare, dalla guida introduttiva alla gestione del team.\n",
                  "image": {
                    "title": "Self-Guided Learning Illustration",
                    "description": "Book illustration for Dropbox's self-guided learning courses",
                    "url": "//images.ctfassets.net/zh1yxk5yn2r7/6ODZb6bllZrucIYtiLqFkU/f844e955cabc76e34e249d9c18e43d62/self-guided-learning.svg",
                    "size": 42902,
                    "width": 405,
                    "height": 310,
                    "filename": "self-guided-learning.svg",
                    "contentType": "image/svg+xml"
                  }
                },
                "contentSections": [
                  {
                    "_id": "6MGcQfM5kOFGpBqiOmSkKy",
                    "_contentTypeId": "moduleFeaturedCourse",
                    "_modifiedDate": "2026-11-05T12:58:40.480Z",
                    "internalTitle": "Featured - Self-guided learning",
                    "title": "Corso in primo piano",
                    "course": null
                  },
                  {
                    "_id": "4JIWsH681XIFek4zmBB6Ix",
                    "_contentTypeId": "moduleMultiColumnCourses",
                    "_modifiedDate": "2026-11-05T12:58:40.355Z",
                    "internalTitle": "All courses - Self-guided learning - Cards",
                    "title": "Tutti i corsi",
                    "courses": []
                  }
                ],
                "seo": {
                  "title": {
                    "name": "title",
                    "value": "Corsi di formazione autoguidata su Dropbox | Formazione su Dropbox"
                  },
                  "keywords": {
                    "name": "keywords",
                    "value": ""
                  },
                  "og:image": {
                    "name": "og:image",
                    "value": {
                      "id": "33cKbUcUgjCOB3aPxkIMGq",
                      "url": "https://images.ctfassets.net/zh1yxk5yn2r7/33cKbUcUgjCOB3aPxkIMGq/14cdd574f957e960f0972f73a80a892e/hoop.png",
                      "title": "hoop"
                    }
                  },
                  "description": {
                    "name": "description",
                    "value": "Corsi di formazione Dropbox autonomi, disponibili gratuitamente e su richiesta. Scopri come utilizzare il tuo account Dropbox nel modo che preferisci. Iscriviti oggi stesso."
                  },
                  "twitter:title": {
                    "name": "twitter:title",
                    "value": "Dropbox"
                  }
                }
              }
            },
            "content": [
              {
                "data": {},
                "marks": [],
                "value": "corso di formazione autoguidato",
                "nodeType": "text"
              }
            ],
            "nodeType": "entry-hyperlink"
          },
          {
            "data": {},
            "marks": [],
            "value": ".",
            "nodeType": "text"
          }
        ],
        "nodeType": "paragraph"
      }
    ],
    "nodeType": "document"
  },
  "l18nLookup": {
    "see": "Scopri",
    "noData": "Nessun risultato trovato",
    "textHr": "h",
    "filters": "Filtri",
    "modules": "Moduli",
    "results": "Risultati",
    "textHrs": "ore",
    "textMin": "min",
    "clearall": "Cancella tutti i filtri",
    "continue": "Continua",
    "featured": "In evidenza",
    "textHour": "ora",
    "textLess": "Meno",
    "textMins": "min",
    "textMore": "Altro",
    "textRead": "Lettura",
    "allvidoes": "Tutti i video",
    "labelTags": "Tag",
    "learnText": "Scopri",
    "startdemo": "Avvia la demo",
    "textClear": "Cancella",
    "textHours": "Orari",
    "useStacks": "Come utilizzare le raccolte",
    "findCourse": "Trova un corso",
    "textMinute": "minuto",
    "transcript": "Trascrizione",
    "ctaTextBack": "Indietro",
    "ctaTextNext": "Successivo",
    "filterstext": "Filtri",
    "joinUrlText": "Partecipa alla sessione",
    "moreAnswers": "altre risorse.",
    "noCouresYet": "Non sono ancora presenti corsi",
    "readingTime": "minuti di lettura",
    "textMinutes": "minuti",
    "textSeeMore": "Visualizza altro",
    "textViewAll": "Visualizza tutto",
    "alltutorials": "tutti i tutorial",
    "ctaTextLogIn": "Accedi",
    "noresultText": "Prova a utilizzare parole chiave diverse o sfoglia i contenuti",
    "searchHeader": "Cerca",
    "textComplete": "Completato",
    "textError404": "Errore (404)",
    "textFilterBy": "Filtro",
    "videolibrary": "Libreria video",
    "browseKeyword": "prova a utilizzare parole chiave diverse oppure cerca",
    "ctaTextLogout": "Esci",
    "ctaTextSignIn": "Accedi",
    "labelSubjects": "Argomenti",
    "moreTutorials": "Altri tutorial",
    "popUpBodyText": "Hai appena completato il corso per amministratori di Dropbox Business!",
    "textNextTopic": "Modulo successivo",
    "trackProgress": "Per poter monitorare i tuoi progressi qui, inizia un corso.",
    "ctaTextProfile": "Il mio profilo",
    "ctaTextVirtual": "Visualizza sessione",
    "headerDuration": "Durata",
    "languageNameDe": "Deutsch",
    "languageNameEs": "Español",
    "languageNameFr": "Français",
    "languageNameIt": "Italiano",
    "languageNameJa": "日本語",
    "matchingsearch": "Non abbiamo trovato alcuna corrispondenza per la tua ricerca.",
    "viewAllCourses": "Visualizza tutti i corsi",
    "ctaTextRegister": "Registrati adesso",
    "labelCategories": "Categorie",
    "searchNoResults": "Nessun risultato per {{search}}",
    "textStartCourse": "Inizia il corso",
    "textWebinarFull": "Il webinar è al completo. Scegli un altro orario o giorno.",
    "accountLabelLast": "Cognome",
    "accountLabelName": "Nome",
    "ctaCreateAccount": "Crea account",
    "languageNameEnUs": "Inglese",
    "languageNamePtBr": "Português",
    "searchBreadcrumb": "Risultati di ricerca",
    "searchFilterRole": "Ruolo",
    "textErrorUnknown": "Si è verificato un errore",
    "textResumeCourse": "Riprendi corso",
    "accountLabelEmail": "Email",
    "ctaTextReschedule": "Ripianifica",
    "ctaTextSelfGuided": "Visualizza moduli",
    "ctaTextViewCourse": "Visualizza corso",
    "formLabelAttended": "Seguito",
    "headerAccountInfo": "Info account",
    "textErrorPageHome": "Home page",
    "textPreviousTopic": "Precedente",
    "ctaTextCancelClass": "Annulla questa lezione",
    "formInputLabelDate": "Data",
    "headerPersonalInfo": "Informazioni personali",
    "labelSubcategories": "Sottocategorie",
    "searchResultStatus": "risultati trovati",
    "selfguidedLearning": "Formazione autoguidata",
    "textBreadcrumbRoot": "Formazione su Dropbox",
    "textCourseProgress": "Progresso corso",
    "formInputLabelEmail": "Email",
    "globalTextCopyright": "Testo del copyright",
    "signInpopUpBodyText": "Tieni traccia dei moduli che completi",
    "textDropdownDefault": "Gli orari mostrati si riferiscono al tuo fuso orario",
    "textErrorPageSignIn": "Accedi",
    "textTableOfContents": "Moduli",
    "canceledRegistration": "Registrazione annullata correttamente",
    "formInputLabelCourse": "Corso",
    "formInputLabelStatus": "Stato",
    "searchFilterLanguage": "Lingua",
    "searchResultsPerPage": "Risultati per pagina",
    "textSigninModalIntro": "Accedi per salvare i progressi",
    "topicCountTextPlural": "Argomenti",
    "topicCountTextSingle": "Argomento",
    "headerSuggestedTopics": "Moduli suggeriti",
    "searchFilterOptionSgc": "Corso autodidattico",
    "searchResultTypeTopic": "Modulo",
    "searchResultTypeVideo": "Video",
    "textAlreadyRegistered": "Hai già effettuato l’iscrizione a questo webinar.",
    "textYouMustLogInFirst": "Prima devi effettuare l'accesso",
    "formInputLabelAttendee": "Partecipante",
    "formInputLabelLastName": "Cognome",
    "formInputLabelOverview": "Panoramica",
    "headerEventDescription": "Descrizione della sessione",
    "headerProfileCompleted": "Completati",
    "searchFilterOptionLive": "Sessione live",
    "searchFilterOptionTeam": "Membro del team",
    "textCourseExpectations": "Che cosa aspettarsi:",
    "textLearningObjectives": "Contenuto del corso",
    "formInputLabelFirstName": "Nome",
    "headerProfileInProgress": " In corso",
    "pageVideoCategoriesSync": "Sincronizzazione",
    "searchFilterContentType": "Tipo di contenuti",
    "searchFilterOptionAdmin": "Amministratore",
    "searchFilterOptionTopic": "Modulo",
    "searchPageTitleMetadata": "Ricerca | Formazione su Dropbox",
    "textErrorPageHelpCenter": "Centro assistenza",
    "formInputLabelSelectDate": "Seleziona una data",
    "formInputLabelSelectTime": "Seleziona un orario",
    "headerProfileLiveCourses": "Corsi in programma",
    "pageVideoCategoriesShare": "Condividi",
    "formInputLabelSessionLink": "Link alla sessione",
    "textErrorPageHelpfulLinks": "Ecco alcuni utili link:",
    "textErrorPagePageNotFound": "Non riusciamo a trovare la pagina che stai cercando",
    "textRegistrationCompleted": "Hai effettuato la registrazione",
    "breadcrumbTextRegistration": "Registrazione",
    "formInputLabelPickLanguage": "Seleziona la lingua",
    "pageVideoCategoriesWebinar": "Webinar",
    "searchPageKeywordsMetadata": "ricerca",
    "searchResultTypeSelfGuided": "Corso",
    "ctaTextCompleteRegistration": "Completa la registrazione",
    "headerEnterRegistrationInfo": "Inserisci le informazioni di registrazione",
    "headerRegisteredLiveCourses": "Corsi di formazione virtuali registrati",
    "pageVideoCategoriesInstalls": "Installazione in corso",
    "pageVideoCategoriesOrganize": "Organizza",
    "pageVideoCategoriesProducts": "Prodotti",
    "pageVideoCategoriesSecurity": "Sicurezza",
    "searchFilterOptionRoleAdmin": "Amministratore",
    "searchResultTypeLiveSession": "Sessione live",
    "headerRegistrationSuccessful": "Hai effettuato la registrazione correttamente",
    "headerSearchInputPlaceholder": "Cerca",
    "pageVideoSubcategoriesDelete": "Elimina",
    "pageVideoSubcategoriesReplay": "Replay",
    "pageVideoSubcategoriesRewind": "Riavvolgimento",
    "pageVideoSubcategoriesSignIn": "Accedi",
    "searchFilterOptionIndividual": "Utente singolo",
    "formInputLabelCourseCompleted": "Corso completato",
    "pageVideoSubcategoriesCapture": "Capture",
    "pageVideoSubcategoriesRestore": "Ripristina",
    "searchPageDescriptionMetadata": "Puoi cercare moduli o informazioni per scoprire di più sulle nostre risorse di formazione. Trova il percorso o il corso autoguidato Dropbox più adatto alle tue esigenze.",
    "pageVideoCategoriesViewAndEdit": "Visualizza e modifica",
    "pageVideoSubcategoriesTransfer": "Transfer",
    "searchFilterOptionRoleHelpDesk": "Help desk",
    "textCalendarShortWeekdayFriday": "Ven",
    "textCalendarShortWeekdayMonday": "Lun",
    "textCalendarShortWeekdaySunday": "Dom",
    "pageVideoSubcategoriesMobileApp": "Applicazione per dispositivi mobili",
    "textCalendarShortWeekdayTuesday": "Mar",
    "textEmailConfirmationWillBeSent": "Controlla la posta in arrivo per vedere se hai ricevuto un'email di conferma.",
    "headerLiveCourseHighlightsHeader": "Contenuto del corso:",
    "pageVideoCategoriesAccountAccess": "Accesso all'account",
    "pageVideoSubcategoriesTeamAccess": "Accesso del team",
    "searchFilterOptionRoleTeamMember": "Membro del team",
    "textCalendarShortWeekdaySaturday": "Sab",
    "textCalendarShortWeekdayThursday": "Gio",
    "formInputLabelGeneralRegistration": "Registrazione generale",
    "pageVideoSubcategoriesDropboxDash": "Dropbox Dash",
    "pageVideoSubcategoriesTeamFolders": "Cartelle del team",
    "textCalendarShortWeekdayWednesday": "Mer",
    "formInputLabelGlobalSelectLanguage": "Seleziona una lingua",
    "formInputLabelSelectDateBreadcrumb": "Seleziona data",
    "pageVideoCategoriesAccountSettings": "Impostazioni account",
    "pageVideoCategoriesCreateAndUpload": "Crea e carica",
    "pageVideoSubcategoriesTeamSecurity": "Sicurezza del team",
    "searchFilterOptionRoleFundamentals": "Fondamenti",
    "pageVideoCategoriesDeleteAndRestore": "Eliminazione e ripristino",
    "pageCourseTopicTableOfContentsHeading": "Sezioni in questo articolo",
    "pageVideoSubcategoriesDropboxPolicies": "Norme di Dropbox",
    "pageVideoSubcategoriesOnDemandTraining": "Formazione su richiesta",
    "pageVideoSubcategoriesCommentingOnFiles": "Aggiunta di commenti ai file",
    "pageVideoSubcategoriesSharingPermissions": "Autorizzazioni di condivisione",
    "pageVideoSubcategoriesDropboxApplications": "Applicazioni Dropbox",
    "pageVideoSubcategoriesSearchingYourAccount": "Cercare nel proprio account",
    "pageVideoSubcategoriesManagingAccountAccess": "Gestire l’accesso all’account",
    "pageVideoSubcategoriesSharingFilesAndFolders": "Condividi file e cartelle",
    "pageVideoSubcategoriesCreatingFilesAndFolders": "Creare file e cartelle"
  },
  "copyrightText": "Dropbox 2021",
  "seo": {
    "title": {
      "name": "title",
      "value": "Dropbox learn"
    },
    "keywords": {
      "name": "keywords",
      "value": ""
    },
    "og:image": {
      "name": "og:image",
      "value": {
        "id": "2z2Foc0s6DPlQV1aTtWO3b",
        "url": "https://images.ctfassets.net/zh1yxk5yn2r7/2z2Foc0s6DPlQV1aTtWO3b/b0c0e0a58102dd90281f7b1df860a370/Dropbox.svg",
        "title": "Dropbox Logo"
      }
    },
    "og:title": {
      "name": "og:title",
      "value": "Dropbox learn"
    },
    "canonical": {
      "name": "canonical",
      "value": ""
    },
    "description": {
      "name": "description",
      "value": "Learn how to use Dropbox. Browse our catalog of free self-guided courses and virtual instructor led training sessions. Start a Dropbox training course today."
    },
    "twitter:image": {
      "name": "twitter:image",
      "value": {
        "id": "2z2Foc0s6DPlQV1aTtWO3b",
        "url": "https://images.ctfassets.net/zh1yxk5yn2r7/2z2Foc0s6DPlQV1aTtWO3b/b0c0e0a58102dd90281f7b1df860a370/Dropbox.svg",
        "title": "Dropbox Logo"
      }
    },
    "twitter:title": {
      "name": "twitter:title",
      "value": "Dropbox learn"
    },
    "og:description": {
      "name": "og:description",
      "value": "Learn how to use Dropbox. Browse our catalog of free self-guided courses and virtual instructor led training sessions. Start a Dropbox training course today."
    },
    "twitter:description": {
      "name": "twitter:description",
      "value": "Learn how to use Dropbox. Browse our catalog of free self-guided courses and virtual instructor led training sessions. Start a Dropbox training course today."
    }
  },
  "seoOrganizationsSchema": {
    "url": "http://www.dropbox.com",
    "@type": "Organization",
    "@context": "http://schema.org",
    "contactPoint": [
      {
        "@type": "ContactPoint",
        "telephone": "+1-888-888-8888",
        "areaServed": "US",
        "contactType": "customer service",
        "contactOption": "TollFree"
      },
      {
        "@type": "ContactPoint",
        "telephone": "+1-888-888-8888",
        "contactType": "customer service"
      },
      {
        "@type": "ContactPoint",
        "telephone": "+1-888-888-8888",
        "areaServed": "US",
        "contactType": "customer service",
        "contactOption": [
          "HearingImpairedSupported",
          "TollFree"
        ]
      },
      {
        "@type": "ContactPoint",
        "telephone": "+1-888-888-8888",
        "areaServed": [
          "US",
          "CA"
        ],
        "contactType": "technical support",
        "contactOption": "TollFree",
        "availableLanguage": [
          "English",
          "French"
        ]
      },
      {
        "@type": "ContactPoint",
        "telephone": "+1-888-888-8888",
        "areaServed": [
          "US",
          "CA"
        ],
        "contactType": "bill payment",
        "contactOption": "TollFree"
      }
    ]
  }
}
  },
  "ja": {
    isDefault: false,
    settings: {
  "_id": "4KRGLSrqTRY6s18UzHe1II",
  "_contentTypeId": "settingsGlobal",
  "_modifiedDate": "2026-05-14T04:59:02.660Z",
  "internalTitle": "CX Learning Hub Global Settings",
  "topNavigationLogo": {
    "title": "Dropbox Logo",
    "url": "//images.ctfassets.net/zh1yxk5yn2r7/2z2Foc0s6DPlQV1aTtWO3b/b0c0e0a58102dd90281f7b1df860a370/Dropbox.svg",
    "size": 3707,
    "width": 324,
    "height": 64,
    "filename": "Dropbox.svg",
    "contentType": "image/svg+xml"
  },
  "mainNavigation": [
    {
      "internalTitle": "Footer Link - Help center",
      "linkText": "ヘルプセンター",
      "destinationType": "Manual text entry",
      "trackingId": "learn-support-help-center",
      "_id": "5pPOxJP1W9PaPBCnLHhe5x",
      "_contentTypeId": "elementLink",
      "href": "https://help.dropbox.com",
      "as": null,
      "target": null,
      "isModal": false,
      "download": false
    },
    {
      "internalTitle": "Supernav - Dropbox Community",
      "linkText": "コミュニティ",
      "destinationType": "Manual text entry",
      "_id": "7aVH719lug9lYEJzIntabM",
      "_contentTypeId": "elementLink",
      "href": "https://community.dropbox.com/",
      "as": null,
      "target": "_blank",
      "isModal": false,
      "download": false
    },
    {
      "internalTitle": "Footer Link - Contact us",
      "linkText": "お問い合わせ",
      "destinationType": "Manual text entry",
      "trackingId": "learn-support-contact-us",
      "_id": "5v3vwPdKulQu6xhA6csIT8",
      "_contentTypeId": "elementLink",
      "href": "https://www.dropbox.com/contact",
      "as": null,
      "target": null,
      "isModal": false,
      "download": false
    }
  ],
  "secondaryNavigation": [
    {
      "internalTitle": "Secondary Nav - Self-guided learning",
      "linkText": "自分のペースで進められるトレーニング",
      "destinationType": "Content reference",
      "_id": "oMqs4whMJuBjhZsbMv0KA",
      "_contentTypeId": "elementLink",
      "href": "/[slug]",
      "as": "/self-guided-learning",
      "target": null,
      "isModal": false,
      "download": false
    },
    {
      "internalTitle": "Secondary Nav - Videos Landing Page",
      "linkText": "ビデオ",
      "destinationType": "Content reference",
      "_id": "5y8ArqrhCZ6DoCCGxaumhI",
      "_contentTypeId": "elementLink",
      "href": "/[slug]",
      "as": "/video-library",
      "target": null,
      "isModal": false,
      "download": false
    }
  ],
  "footerNavigation": [
    {
      "_id": "1M79uBMmyuD9Iw6fuOdVEJ",
      "_contentTypeId": "elementFooterNavColumn",
      "_modifiedDate": "2026-05-06T15:28:27.147Z",
      "internalTitle": "Dropbox",
      "links": [
        {
          "internalTitle": "Footer Link - Desktop app",
          "linkText": "デスクトップ アプリ",
          "destinationType": "Manual text entry",
          "trackingId": "learn-dropbox-desktop-app",
          "_id": "3SKeLjF7MWEq2FqaRwnmiK",
          "_contentTypeId": "elementLink",
          "href": "https://www.dropbox.com/desktop",
          "as": null,
          "target": null,
          "isModal": false,
          "download": false
        },
        {
          "internalTitle": "Footer Link - Mobile app",
          "linkText": "モバイル アプリ",
          "destinationType": "Manual text entry",
          "trackingId": "learn-dropbox-mobile-app",
          "_id": "62ymoNSBbWiYinBkFO0cGj",
          "_contentTypeId": "elementLink",
          "href": "https://www.dropbox.com/mobile",
          "as": null,
          "target": null,
          "isModal": false,
          "download": false
        },
        {
          "internalTitle": "Footer Link - Integrations",
          "linkText": "Integrations",
          "destinationType": "Manual text entry",
          "trackingId": "learn-dropbox-integrations",
          "_id": "5WEO1xpKelxpyXS50n3Dxc",
          "_contentTypeId": "elementLink",
          "href": "https://www.dropbox.com/app-integrations",
          "as": null,
          "target": null,
          "isModal": false,
          "download": false
        },
        {
          "internalTitle": "Footer Link - Features",
          "linkText": "機能",
          "destinationType": "Manual text entry",
          "trackingId": "learn-dropbox-features",
          "_id": "wUuQPtOLYz96QOSvtgLTh",
          "_contentTypeId": "elementLink",
          "href": "https://www.dropbox.com/features",
          "as": null,
          "target": null,
          "isModal": false,
          "download": false
        },
        {
          "internalTitle": "Footer Link - Solutions",
          "linkText": "Solutions",
          "destinationType": "Manual text entry",
          "trackingId": "learn-dropbox-solutions",
          "_id": "14SJorC6JrH7u2O5E8vf2E",
          "_contentTypeId": "elementLink",
          "href": "https://www.dropbox.com/business/solutions",
          "as": null,
          "target": null,
          "isModal": false,
          "download": false
        },
        {
          "internalTitle": "Footer Link - Security",
          "linkText": "セキュリティ",
          "destinationType": "Manual text entry",
          "trackingId": "learn-dropbox-security",
          "_id": "2YZlyLOZLw2lauy2OWiuB2",
          "_contentTypeId": "elementLink",
          "href": "https://www.dropbox.com/features/security",
          "as": null,
          "target": null,
          "isModal": false,
          "download": false
        },
        {
          "internalTitle": "Footer Link - Early access",
          "linkText": "Early access",
          "destinationType": "Manual text entry",
          "trackingId": "learn-dropbox-early-access",
          "_id": "6u2aXFqnr9s1KXkSjfc2cz",
          "_contentTypeId": "elementLink",
          "href": "https://www.dropbox.com/early-access",
          "as": null,
          "target": null,
          "isModal": false,
          "download": false
        },
        {
          "internalTitle": "Footer Link - Templates",
          "linkText": "Templates",
          "destinationType": "Manual text entry",
          "trackingId": "learn-dropbox-templates",
          "_id": "4yIX8tA1WW1soyk10Frgz5",
          "_contentTypeId": "elementLink",
          "href": "https://www.dropbox.com/templates",
          "as": null,
          "target": null,
          "isModal": false,
          "download": false
        },
        {
          "internalTitle": "Footer Link - Free tools",
          "linkText": "無料ツール",
          "destinationType": "Manual text entry",
          "trackingId": "learn-dropbox-free-tools",
          "_id": "3Fdgsos4Pm77l2C4hKm2AC",
          "_contentTypeId": "elementLink",
          "href": "https://www.dropbox.com/tools",
          "as": null,
          "target": null,
          "isModal": false,
          "download": false
        }
      ]
    },
    {
      "_id": "6LXqBrZEH3p2eDbBpiPFlm",
      "_contentTypeId": "elementFooterNavColumn",
      "_modifiedDate": "2026-05-06T15:28:27.418Z",
      "internalTitle": "製品",
      "links": [
        {
          "internalTitle": "Footer Link - Plus",
          "linkText": "Plus",
          "destinationType": "Manual text entry",
          "trackingId": "learn-products-plus",
          "_id": "4nThAv7YjSuKC91UBK1AoR",
          "_contentTypeId": "elementLink",
          "href": "https://www.dropbox.com/plus",
          "as": null,
          "target": null,
          "isModal": false,
          "download": false
        },
        {
          "internalTitle": "Footer Link -  Professional",
          "linkText": "Professional",
          "destinationType": "Manual text entry",
          "trackingId": "learn-products-professional",
          "_id": "5YtdEKxrCJgHqmmDvwgnQI",
          "_contentTypeId": "elementLink",
          "href": "https://www.dropbox.com/pro",
          "as": null,
          "target": "_blank",
          "isModal": false,
          "download": false
        },
        {
          "internalTitle": "Footer Link - Business",
          "linkText": "Business",
          "destinationType": "Manual text entry",
          "trackingId": "learn-products-business",
          "_id": "5L4PFaY36Icmt95mUTgjOC",
          "_contentTypeId": "elementLink",
          "href": "https://www.dropbox.com/business",
          "as": null,
          "target": null,
          "isModal": false,
          "download": false
        },
        {
          "internalTitle": "Footer Link - Enterprise",
          "linkText": "Enterprise",
          "destinationType": "Manual text entry",
          "trackingId": "learn-products-enterprise",
          "_id": "4KJcgnikVfGiWIaFiuiRIM",
          "_contentTypeId": "elementLink",
          "href": "https://www.dropbox.com/enterprise",
          "as": null,
          "target": null,
          "isModal": false,
          "download": false
        },
        {
          "internalTitle": "Footer Link - Dash",
          "linkText": "Dash",
          "destinationType": "Manual text entry",
          "trackingId": "learn-products-dash",
          "_id": "4qdbH5UT1PZYVWp4vOADQa",
          "_contentTypeId": "elementLink",
          "href": "https://dash.dropbox.com",
          "as": null,
          "target": null,
          "isModal": false,
          "download": false
        },
        {
          "internalTitle": "Footer Link - DocSend",
          "linkText": "DocSend",
          "destinationType": "Manual text entry",
          "trackingId": "learn-products-docsend",
          "_id": "5hUjrT7Yza4eLKxBevHcAF",
          "_contentTypeId": "elementLink",
          "href": "https://www.docsend.com/?utm_medium=Referral&utm_source=Dropbox%20Web%20Referral&utm_campaign=dbx-footer",
          "as": null,
          "target": null,
          "isModal": false,
          "download": false
        },
        {
          "internalTitle": "Footer Link - Dropbox Sign",
          "linkText": "Dropbox Sign",
          "destinationType": "Manual text entry",
          "trackingId": "learn-products-sign",
          "_id": "4ennWEzf0rjxfCiNTEiU9w",
          "_contentTypeId": "elementLink",
          "href": "https://sign.dropbox.com",
          "as": null,
          "target": null,
          "isModal": false,
          "download": false
        },
        {
          "internalTitle": "Footer Link - Reclaim.ai",
          "linkText": "Reclaim.ai",
          "destinationType": "Manual text entry",
          "trackingId": "learn-products-reclaim-ai",
          "_id": "5XGB9J0ZeBff2lXEapKBR1",
          "_contentTypeId": "elementLink",
          "href": "https://app.reclaim.ai/signup?utm_medium=referral&utm_source=dbx-footer-referral&utm_campaign=dbx-footer-signup&utm_term=dbx-footer",
          "as": null,
          "target": null,
          "isModal": false,
          "download": false
        },
        {
          "internalTitle": "Footer Link - Plans",
          "linkText": "Plans",
          "destinationType": "Manual text entry",
          "trackingId": "learn-products-plans",
          "_id": "13TtJzOJV2eQoZ3TQbNVdd",
          "_contentTypeId": "elementLink",
          "href": "https://www.dropbox.com/plans",
          "as": null,
          "target": null,
          "isModal": false,
          "download": false
        },
        {
          "internalTitle": "Footer Link - Product updates",
          "linkText": "Product updates",
          "destinationType": "Manual text entry",
          "trackingId": "learn-products-updates",
          "_id": "45NCupQTJZJEBQ1r1pFDDf",
          "_contentTypeId": "elementLink",
          "href": "https://www.dropbox.com/product-updates",
          "as": null,
          "target": null,
          "isModal": false,
          "download": false
        }
      ]
    },
    {
      "_id": "74RyIf3Qiipq4XbcIPQQwT",
      "_contentTypeId": "elementFooterNavColumn",
      "_modifiedDate": "2026-05-06T15:28:27.829Z",
      "internalTitle": "Features",
      "links": [
        {
          "internalTitle": "Footer Link - Send large files",
          "linkText": "Send large files",
          "destinationType": "Manual text entry",
          "trackingId": "learn-features-send-large-files",
          "_id": "48eVY6niBIXx4YAPA4XKWz",
          "_contentTypeId": "elementLink",
          "href": "https://www.dropbox.com/features/share/send-large-files",
          "as": null,
          "target": null,
          "isModal": false,
          "download": false
        },
        {
          "internalTitle": "Footer Link - Send long videos",
          "linkText": "Send long videos",
          "destinationType": "Manual text entry",
          "trackingId": "learn-features-send-long-videos",
          "_id": "75e4Pf3aV5ZnB77zgoYITc",
          "_contentTypeId": "elementLink",
          "href": "https://www.dropbox.com/features/share/send-long-videos",
          "as": null,
          "target": null,
          "isModal": false,
          "download": false
        },
        {
          "internalTitle": "Footer Link - Cloud photo storage",
          "linkText": "Cloud photo storage",
          "destinationType": "Manual text entry",
          "trackingId": "learn-features-cloud-photo-storage",
          "_id": "64WyEAeXS80TWroqmR8eHy",
          "_contentTypeId": "elementLink",
          "href": "https://www.dropbox.com/features/cloud-storage/photos",
          "as": null,
          "target": null,
          "isModal": false,
          "download": false
        },
        {
          "internalTitle": "Footer Link - Secure file transfer",
          "linkText": "Secure file transfer",
          "destinationType": "Manual text entry",
          "trackingId": "learn-features-send-secure-file-transfer",
          "_id": "9bUiqp6kN7PfQDoP5dVEA",
          "_contentTypeId": "elementLink",
          "href": "https://www.dropbox.com/features/share/file-transfer",
          "as": null,
          "target": null,
          "isModal": false,
          "download": false
        },
        {
          "internalTitle": "Footer Link - Cloud backup",
          "linkText": "Cloud backup",
          "destinationType": "Manual text entry",
          "trackingId": "learn-features-cloud-backup",
          "_id": "4kYfwCJpM6hsTbLd622yzc",
          "_contentTypeId": "elementLink",
          "href": "https://www.dropbox.com/features/cloud-storage/file-backup",
          "as": null,
          "target": null,
          "isModal": false,
          "download": false
        },
        {
          "internalTitle": "Footer Link - Edit PDFs",
          "linkText": "Edit PDFs",
          "destinationType": "Manual text entry",
          "trackingId": "learn-features-edit-pdfs",
          "_id": "1Fw9zhaVelLXfOpxEQwsAy",
          "_contentTypeId": "elementLink",
          "href": "https://www.dropbox.com/features/productivity/pdf-editor",
          "as": null,
          "target": null,
          "isModal": false,
          "download": false
        },
        {
          "internalTitle": "Footer Link - Electronic signatures",
          "linkText": "Electronic signatures",
          "destinationType": "Manual text entry",
          "trackingId": "learn-features-electronic-signatures",
          "_id": "6nhjK34qVMZlkA2opn0vWj",
          "_contentTypeId": "elementLink",
          "href": "https://www.dropbox.com/features/productivity/electronic-signature",
          "as": null,
          "target": null,
          "isModal": false,
          "download": false
        },
        {
          "internalTitle": "Footer Link - Convert to PDF",
          "linkText": "Convert to PDF",
          "destinationType": "Manual text entry",
          "trackingId": "learn-features-convert-to-pdf",
          "_id": "4a7MNYwiyhj6OtmYb87co0",
          "_contentTypeId": "elementLink",
          "href": "https://www.dropbox.com/features/productivity/convert-to-pdf",
          "as": null,
          "target": null,
          "isModal": false,
          "download": false
        }
      ]
    },
    {
      "_id": "1TnZWWGdwo9BEkEKgcIGpA",
      "_contentTypeId": "elementFooterNavColumn",
      "_modifiedDate": "2026-05-06T15:28:27.248Z",
      "internalTitle": "サポート",
      "links": [
        {
          "internalTitle": "Footer Link - Help center",
          "linkText": "ヘルプセンター",
          "destinationType": "Manual text entry",
          "trackingId": "learn-support-help-center",
          "_id": "5pPOxJP1W9PaPBCnLHhe5x",
          "_contentTypeId": "elementLink",
          "href": "https://help.dropbox.com",
          "as": null,
          "target": null,
          "isModal": false,
          "download": false
        },
        {
          "internalTitle": "Footer Link - Contact us",
          "linkText": "お問い合わせ",
          "destinationType": "Manual text entry",
          "trackingId": "learn-support-contact-us",
          "_id": "5v3vwPdKulQu6xhA6csIT8",
          "_contentTypeId": "elementLink",
          "href": "https://www.dropbox.com/contact",
          "as": null,
          "target": null,
          "isModal": false,
          "download": false
        },
        {
          "internalTitle": "Footer Link - Privacy & terms",
          "linkText": "プライバシーと利用規約",
          "destinationType": "Manual text entry",
          "trackingId": "learn-support-privacy-terms",
          "_id": "30MJJnJ2DIcvhYL2wsg0FB",
          "_contentTypeId": "elementLink",
          "href": "https://www.dropbox.com/terms",
          "as": null,
          "target": null,
          "isModal": false,
          "download": false
        },
        {
          "internalTitle": "Footer Link - Cookie policy",
          "linkText": "Cookie ポリシー",
          "destinationType": "Manual text entry",
          "trackingId": "learn-support-cookie-policy",
          "_id": "3akG8gNhd73ZlRaEYSCvUD",
          "_contentTypeId": "elementLink",
          "href": "https://help.dropbox.com/security/cookies",
          "as": null,
          "target": null,
          "isModal": false,
          "download": false
        },
        {
          "internalTitle": "Footer Link - Cookies & CCPA preferences",
          "linkText": "Cookie と CCPA の設定",
          "destinationType": "Manual text entry",
          "trackingId": "learn-support-cookies-CCPA",
          "_id": "65mwIIQg9xKeyKiICuy9DJ",
          "_contentTypeId": "elementLink",
          "href": "https://www.dropbox.com/app-integrations#manage-cookies",
          "as": null,
          "target": null,
          "isModal": false,
          "download": false
        },
        {
          "internalTitle": "Footer Link - AI principles",
          "linkText": "AI principles",
          "destinationType": "Manual text entry",
          "trackingId": "learn-support-ai-principles",
          "_id": "5mTsyPahdNgokTvducSB9i",
          "_contentTypeId": "elementLink",
          "href": "https://www.dropbox.com/ai-principles",
          "as": null,
          "target": null,
          "isModal": false,
          "download": false
        },
        {
          "internalTitle": "Footer Link - Sitemap",
          "linkText": "サイトマップ",
          "destinationType": "Manual text entry",
          "trackingId": "learn-support-sitemap",
          "_id": "37byNy2Pux5TAcdSJm6g4f",
          "_contentTypeId": "elementLink",
          "href": "https://experience.dropbox.com/sitemap",
          "as": null,
          "target": null,
          "isModal": false,
          "download": false
        },
        {
          "internalTitle": "Footer Link - Learning resources",
          "linkText": "Learning resources",
          "destinationType": "Manual text entry",
          "trackingId": "learn-support-learning-resources",
          "_id": "Gj2OgkkQcCs8BXTBr5Irc",
          "_contentTypeId": "elementLink",
          "href": "https://learn.dropbox.com",
          "as": null,
          "target": null,
          "isModal": false,
          "download": false
        }
      ]
    },
    {
      "_id": "28o2jcc5DrafqCYZ9icYU7",
      "_contentTypeId": "elementFooterNavColumn",
      "_modifiedDate": "2026-05-06T15:28:26.982Z",
      "internalTitle": "リソース",
      "links": [
        {
          "internalTitle": "Footer Link - Blog",
          "linkText": "Blog",
          "destinationType": "Manual text entry",
          "trackingId": "learn-resources-blog",
          "_id": "4vYa3RKqQLWA8bNHcaPX69",
          "_contentTypeId": "elementLink",
          "href": "https://blog.dropbox.com",
          "as": null,
          "target": null,
          "isModal": false,
          "download": false
        },
        {
          "internalTitle": "Footer Link - Events",
          "linkText": "Events",
          "destinationType": "Manual text entry",
          "trackingId": "learn-resources-events",
          "_id": "2D8JKIOdP8zjqZCfsqIG5l",
          "_contentTypeId": "elementLink",
          "href": "https://events.dropbox.com/",
          "as": null,
          "target": null,
          "isModal": false,
          "download": false
        },
        {
          "internalTitle": "Footer Link - Customer stories",
          "linkText": "Customer stories",
          "destinationType": "Manual text entry",
          "trackingId": "learn-resources-customer-stories",
          "_id": "49GkLGyFuV1GvXf1DozTPZ",
          "_contentTypeId": "elementLink",
          "href": "https://www.dropbox.com/customers",
          "as": null,
          "target": null,
          "isModal": false,
          "download": false
        },
        {
          "internalTitle": "Footer Link - Resources library",
          "linkText": "Resources library",
          "destinationType": "Manual text entry",
          "trackingId": "learn-resources-resources-library",
          "_id": "3l98eLMkEyPoj0jzqgBvj7",
          "_contentTypeId": "elementLink",
          "href": "https://www.dropbox.com/resources",
          "as": null,
          "target": null,
          "isModal": false,
          "download": false
        },
        {
          "internalTitle": "Footer Link - Developers",
          "linkText": "開発者数",
          "destinationType": "Manual text entry",
          "trackingId": "learn-resources-developers",
          "_id": "2aFb3GcSJS0YIEU3aKbLzj",
          "_contentTypeId": "elementLink",
          "href": "https://www.dropbox.com/developers",
          "as": null,
          "target": null,
          "isModal": false,
          "download": false
        },
        {
          "internalTitle": "Footer Link - Community forums",
          "linkText": "コミュニティ フォーラム",
          "destinationType": "Manual text entry",
          "trackingId": "learn-resources-community-forums",
          "_id": "4IGtm6twVWzfoE07kHlucc",
          "_contentTypeId": "elementLink",
          "href": "https://community.dropbox.com",
          "as": null,
          "target": null,
          "isModal": false,
          "download": false
        },
        {
          "internalTitle": "Footer Link - Referrals",
          "linkText": "紹介",
          "destinationType": "Manual text entry",
          "trackingId": "learn-resources-referrals",
          "_id": "4YsKqwQfAG4Ds0a0yeo9wp",
          "_contentTypeId": "elementLink",
          "href": "https://www.dropbox.com/refer",
          "as": null,
          "target": null,
          "isModal": false,
          "download": false
        },
        {
          "internalTitle": "Footer Link - Reseller partners",
          "linkText": "Reseller partners",
          "destinationType": "Manual text entry",
          "trackingId": "learn-resources-reseller-partners",
          "_id": "1w7KmWfsigadpZje40tk18",
          "_contentTypeId": "elementLink",
          "href": "https://www.dropbox.com/business/partners",
          "as": null,
          "target": null,
          "isModal": false,
          "download": false
        },
        {
          "internalTitle": "Footer Link - Integration partners",
          "linkText": "Integration partners",
          "destinationType": "Manual text entry",
          "trackingId": "learn-resources-integration-partners",
          "_id": "6dgcNUDLbEeXQE94s71vrO",
          "_contentTypeId": "elementLink",
          "href": "https://www.dropbox.com/app-integrations",
          "as": null,
          "target": null,
          "isModal": false,
          "download": false
        },
        {
          "internalTitle": "Footer Link - Find a partner",
          "linkText": "Find a partner",
          "destinationType": "Manual text entry",
          "trackingId": "learn-resources-find-a-partner",
          "_id": "2wQU48ntbukgQSKuTKS9in",
          "_contentTypeId": "elementLink",
          "href": "https://experience.dropbox.com/partner-locator",
          "as": null,
          "target": null,
          "isModal": false,
          "download": false
        }
      ]
    },
    {
      "_id": "5xRp5jjLsl92vmGL0qJfVb",
      "_contentTypeId": "elementFooterNavColumn",
      "_modifiedDate": "2026-05-06T15:28:26.948Z",
      "internalTitle": "企業",
      "links": [
        {
          "internalTitle": "Footer Link - About us",
          "linkText": "Dropbox について",
          "destinationType": "Manual text entry",
          "trackingId": "learn-company-about-us",
          "_id": "6XnBD8OrJfQZ4u3ZSc6ysr",
          "_contentTypeId": "elementLink",
          "href": "https://www.dropbox.com/about",
          "as": null,
          "target": null,
          "isModal": false,
          "download": false
        },
        {
          "internalTitle": "Footer Link - Jobs",
          "linkText": "採用情報",
          "destinationType": "Manual text entry",
          "trackingId": "learn-company-jobs",
          "_id": "1nmf2X1QaLv7zS1PIyfqlE",
          "_contentTypeId": "elementLink",
          "href": "https://jobs.dropbox.com",
          "as": null,
          "target": null,
          "isModal": false,
          "download": false
        },
        {
          "internalTitle": "Footer Link - Investor relations",
          "linkText": "IR 情報",
          "destinationType": "Manual text entry",
          "trackingId": "learn-company-investor-relations",
          "_id": "73WTKUyXSmqc5aP1OfisZ9",
          "_contentTypeId": "elementLink",
          "href": "https://dropbox.gcs-web.com/",
          "as": null,
          "target": null,
          "isModal": false,
          "download": false
        },
        {
          "internalTitle": "Footer Link - Corporate responsibility",
          "linkText": "企業責任",
          "destinationType": "Manual text entry",
          "trackingId": "learn-company-corporate-responsibility",
          "_id": "5iMgmL64RXCXtz8iRkrIIM",
          "_contentTypeId": "elementLink",
          "href": "https://www.dropbox.com/corporate-responsibility",
          "as": null,
          "target": null,
          "isModal": false,
          "download": false
        }
      ]
    }
  ],
  "cookieBarBody": "Dropbox ではパフォーマンス向上のために Cookie を使用しています。Dropbox ウェブサイトを使用することにより、Cookie の使用に同意するものとみなします。",
  "cookieBarCta": {
    "internalTitle": "Link Text - Cookie bar",
    "linkText": "詳しくはこちら",
    "destinationType": "Manual text entry",
    "_id": "1tY3PGTzdIHKRi4pDNbmSM",
    "_contentTypeId": "elementLink",
    "href": "https://help.dropbox.com/accounts-billing/security/cookies",
    "as": null,
    "target": "_blank",
    "isModal": false,
    "download": false
  },
  "cookieBarEnabled": true,
  "virtualTrainingsEmptyState": {
    "data": {},
    "content": [
      {
        "data": {},
        "content": [
          {
            "data": {},
            "marks": [],
            "value": "まだ何もありません。",
            "nodeType": "text"
          },
          {
            "data": {
              "target": null
            },
            "content": [
              {
                "data": {},
                "marks": [],
                "value": "バーチャルトレーニングセッション",
                "nodeType": "text"
              }
            ],
            "nodeType": "entry-hyperlink"
          },
          {
            "data": {},
            "marks": [],
            "value": "に登録しましょう。",
            "nodeType": "text"
          }
        ],
        "nodeType": "paragraph"
      }
    ],
    "nodeType": "document"
  },
  "completedCoursesEmptyState": {
    "data": {},
    "content": [
      {
        "data": {},
        "content": [
          {
            "data": {},
            "marks": [],
            "value": "修了したコースがここに表示されます。",
            "nodeType": "text"
          }
        ],
        "nodeType": "paragraph"
      }
    ],
    "nodeType": "document"
  },
  "inProgressCoursesEmptyState": {
    "data": {},
    "content": [
      {
        "data": {},
        "content": [
          {
            "data": {},
            "marks": [],
            "value": "まだ何もありません。",
            "nodeType": "text"
          },
          {
            "data": {
              "target": {
                "_id": "75pzFP9abHFb2hlQycUS86",
                "_contentTypeId": "pageLanding",
                "_href": "/[slug]",
                "_as": "/self-guided-learning",
                "_modifiedDate": "2026-07-14T14:56:10.933Z",
                "internalTitle": "L2 - Landing page - Self-guided learning",
                "name": "自分のペースで進められるトレーニング",
                "slug": "self-guided-learning",
                "introHero": {
                  "_id": "6pQlpoBglvzGW38DBWvU5W",
                  "_contentTypeId": "moduleHero",
                  "_modifiedDate": "2026-05-15T16:06:56.370Z",
                  "internalTitle": "Hero - Self-guided learning",
                  "headerText": "自分のペースで進められるトレーニング",
                  "summaryText": "Dropbox、Dash、Replay、Signなどのガイド付きコースをご覧ください。スタート ガイドからチームの管理方法まで、必要な作業に合ったコースを選択してください。\n",
                  "image": {
                    "title": "Self-Guided Learning Illustration",
                    "description": "Book illustration for Dropbox's self-guided learning courses",
                    "url": "//images.ctfassets.net/zh1yxk5yn2r7/6ODZb6bllZrucIYtiLqFkU/f844e955cabc76e34e249d9c18e43d62/self-guided-learning.svg",
                    "size": 42902,
                    "width": 405,
                    "height": 310,
                    "filename": "self-guided-learning.svg",
                    "contentType": "image/svg+xml"
                  }
                },
                "contentSections": [
                  {
                    "_id": "6MGcQfM5kOFGpBqiOmSkKy",
                    "_contentTypeId": "moduleFeaturedCourse",
                    "_modifiedDate": "2026-11-05T12:58:40.480Z",
                    "internalTitle": "Featured - Self-guided learning",
                    "title": "注目のコース",
                    "course": null
                  },
                  {
                    "_id": "4JIWsH681XIFek4zmBB6Ix",
                    "_contentTypeId": "moduleMultiColumnCourses",
                    "_modifiedDate": "2026-11-05T12:58:40.355Z",
                    "internalTitle": "All courses - Self-guided learning - Cards",
                    "title": "すべてのコース",
                    "courses": []
                  }
                ],
                "seo": {
                  "title": {
                    "name": "title",
                    "value": "Dropbox 自習トレーニング コース | Dropbox について学ぶ"
                  },
                  "keywords": {
                    "name": "keywords",
                    "value": ""
                  },
                  "og:image": {
                    "name": "og:image",
                    "value": {
                      "id": "33cKbUcUgjCOB3aPxkIMGq",
                      "url": "https://images.ctfassets.net/zh1yxk5yn2r7/33cKbUcUgjCOB3aPxkIMGq/14cdd574f957e960f0972f73a80a892e/hoop.png",
                      "title": "hoop"
                    }
                  },
                  "description": {
                    "name": "description",
                    "value": "自習用の Dropbox のトレーニング コースは、無料およびオンデマンドでご利用いただけます。自分のペースで Dropbox アカウントを使用する方法を学びましょう。今すぐご登録ください。"
                  },
                  "twitter:title": {
                    "name": "twitter:title",
                    "value": "Dropbox"
                  }
                }
              }
            },
            "content": [
              {
                "data": {},
                "marks": [],
                "value": "自分のペースで進められるトレーニングコース",
                "nodeType": "text"
              }
            ],
            "nodeType": "entry-hyperlink"
          },
          {
            "data": {},
            "marks": [],
            "value": "を始めましょう。",
            "nodeType": "text"
          }
        ],
        "nodeType": "paragraph"
      }
    ],
    "nodeType": "document"
  },
  "l18nLookup": {
    "see": "以下をご覧ください：",
    "noData": "一致する検索結果がありませんでした",
    "textHr": "時間",
    "filters": "フィルタ",
    "modules": "モジュール",
    "results": "結果",
    "textHrs": "時間",
    "textMin": "min",
    "clearall": "すべてのフィルタをクリア",
    "continue": "次へ",
    "featured": "特集",
    "textHour": "時間",
    "textLess": "閉じる",
    "textMins": "分",
    "textMore": "より多く",
    "textRead": "既読",
    "allvidoes": "すべての動画",
    "labelTags": "タグ",
    "learnText": "詳細",
    "startdemo": "デモを開始",
    "textClear": "クリア",
    "textHours": "受付時間",
    "useStacks": "スタックを使用する方法",
    "findCourse": "コースを検索",
    "textMinute": "分",
    "transcript": "トランスクリプト",
    "ctaTextBack": "戻る",
    "ctaTextNext": "次へ",
    "filterstext": "フィルタ",
    "joinUrlText": "セッションに参加",
    "moreAnswers": "その他のリソース。",
    "noCouresYet": "まだコースはありません",
    "readingTime": "分読むのにかかります",
    "textMinutes": "分",
    "textSeeMore": "もっと表示",
    "textViewAll": "すべて表示",
    "alltutorials": "すべてのチュートリアル",
    "ctaTextLogIn": "ログイン",
    "noresultText": "別のキーワードで検索するか、閲覧してください",
    "searchHeader": "検索",
    "textComplete": "完了",
    "textError404": "エラー（404）",
    "textFilterBy": "フィルタ",
    "videolibrary": "動画ライブラリ",
    "browseKeyword": "別のキーワードで検索するか、ウェブサイトを見て回ってください",
    "ctaTextLogout": "ログアウト",
    "ctaTextSignIn": "ログイン",
    "labelSubjects": "件名",
    "moreTutorials": "その他のチュートリアル",
    "popUpBodyText": "Dropbox Business 管理者向けコースを修了しました！",
    "textNextTopic": "次のモジュール",
    "trackProgress": "コースを開始して、こちらから進捗状況を確認しましょう。",
    "ctaTextProfile": "プロフィール",
    "ctaTextVirtual": "セッションを表示する",
    "headerDuration": "期間",
    "languageNameDe": "Deutsch",
    "languageNameEs": "Español",
    "languageNameFr": "Français",
    "languageNameIt": "Italiano",
    "languageNameJa": "日本語",
    "matchingsearch": "検索条件に一致するものは見つかりませんでした。",
    "viewAllCourses": "すべてのコースを見る",
    "ctaTextRegister": "今すぐ登録",
    "labelCategories": "カテゴリ",
    "searchNoResults": "{{search}} の検索結果はありません",
    "textStartCourse": "コースを開始する",
    "textWebinarFull": "このウェビナーは定員に達したため、別の日時をお試しください。",
    "accountLabelLast": "姓",
    "accountLabelName": "名前",
    "ctaCreateAccount": "アカウントを作成",
    "languageNameEnUs": "英語",
    "languageNamePtBr": "Português",
    "searchBreadcrumb": "検索結果",
    "searchFilterRole": "役割",
    "textErrorUnknown": "エラーが発生しました",
    "textResumeCourse": "コースを再開する",
    "accountLabelEmail": "メール",
    "ctaTextReschedule": "処理日を変更",
    "ctaTextSelfGuided": "モジュールの表示",
    "ctaTextViewCourse": "コースを表示する",
    "formLabelAttended": "出席",
    "headerAccountInfo": "アカウント情報",
    "textErrorPageHome": "ホーム",
    "textPreviousTopic": "前へ",
    "ctaTextCancelClass": "このクラスをキャンセルする",
    "formInputLabelDate": "日付",
    "headerPersonalInfo": "個人情報",
    "labelSubcategories": "サブカテゴリ",
    "searchResultStatus": "結果が見つかりました",
    "selfguidedLearning": "自分のペースで進められるトレーニング",
    "textBreadcrumbRoot": "Dropbox について学ぶ",
    "textCourseProgress": "コースの進捗",
    "formInputLabelEmail": "メール",
    "globalTextCopyright": "著作権テキスト",
    "signInpopUpBodyText": "完了したモジュールを把握できます",
    "textDropdownDefault": "時刻はご自身のタイムゾーンに設定されています",
    "textErrorPageSignIn": "ログイン",
    "textTableOfContents": "モジュール",
    "canceledRegistration": "登録がキャンセルされました",
    "formInputLabelCourse": "コース",
    "formInputLabelStatus": "役割",
    "searchFilterLanguage": "言語",
    "searchResultsPerPage": "ページあたりの結果数",
    "textSigninModalIntro": "進捗状況を保存するには、ログインしてください",
    "topicCountTextPlural": "トピック",
    "topicCountTextSingle": "トピック",
    "headerSuggestedTopics": "推奨モジュール",
    "searchFilterOptionSgc": "自習コース",
    "searchResultTypeTopic": "モジュール",
    "searchResultTypeVideo": "動画",
    "textAlreadyRegistered": "このウェビナーにはすでに登録済みです。",
    "textYouMustLogInFirst": "最初にログインしてください。",
    "formInputLabelAttendee": "参加者",
    "formInputLabelLastName": "姓",
    "formInputLabelOverview": "概要",
    "headerEventDescription": "セッションの説明",
    "headerProfileCompleted": "完了",
    "searchFilterOptionLive": "ライブ セッション",
    "searchFilterOptionTeam": "チーム メンバー",
    "textCourseExpectations": "変更内容：",
    "textLearningObjectives": "コース内容",
    "formInputLabelFirstName": "名",
    "headerProfileInProgress": " 実施中",
    "pageVideoCategoriesSync": "同期",
    "searchFilterContentType": "コンテンツタイプ",
    "searchFilterOptionAdmin": "管理者",
    "searchFilterOptionTopic": "モジュール",
    "searchPageTitleMetadata": "検索 | Dropbox について学ぶ",
    "textErrorPageHelpCenter": "ヘルプセンター",
    "formInputLabelSelectDate": "日付を選択してください",
    "formInputLabelSelectTime": "時間を選択してください",
    "headerProfileLiveCourses": "今後のコース",
    "pageVideoCategoriesShare": "共有",
    "formInputLabelSessionLink": "セッション リンク",
    "textErrorPageHelpfulLinks": "役立つリンク：",
    "textErrorPagePageNotFound": "お探しのページが見つかりません",
    "textRegistrationCompleted": "登録しました",
    "breadcrumbTextRegistration": "登録",
    "formInputLabelPickLanguage": "言語を選択してください",
    "pageVideoCategoriesWebinar": "ウェビナー",
    "searchPageKeywordsMetadata": "検索",
    "searchResultTypeSelfGuided": "コース",
    "ctaTextCompleteRegistration": "登録を完了してください",
    "headerEnterRegistrationInfo": "登録情報を入力してください",
    "headerRegisteredLiveCourses": "登録済みバーチャル トレーニング",
    "pageVideoCategoriesInstalls": "インストール",
    "pageVideoCategoriesOrganize": "整理",
    "pageVideoCategoriesProducts": "製品",
    "pageVideoCategoriesSecurity": "セキュリティ",
    "searchFilterOptionRoleAdmin": "管理者",
    "searchResultTypeLiveSession": "ライブ セッション",
    "headerRegistrationSuccessful": "正常に登録されました",
    "headerSearchInputPlaceholder": "検索",
    "pageVideoSubcategoriesDelete": "削除",
    "pageVideoSubcategoriesReplay": "Replay",
    "pageVideoSubcategoriesRewind": "巻き戻す",
    "pageVideoSubcategoriesSignIn": "ログイン",
    "searchFilterOptionIndividual": "個人用",
    "formInputLabelCourseCompleted": "コース修了",
    "pageVideoSubcategoriesCapture": "Capture",
    "pageVideoSubcategoriesRestore": "復元",
    "searchPageDescriptionMetadata": "モジュールなどの情報を検索して、Dropbox のコースに関する詳細をご覧いただけます。ご自分のニーズに最適な Dropbox トレーニングまたはセルフ ガイド コースを見つけてください。",
    "pageVideoCategoriesViewAndEdit": "閲覧と編集",
    "pageVideoSubcategoriesTransfer": "Transfer",
    "searchFilterOptionRoleHelpDesk": "ヘルプ デスク",
    "textCalendarShortWeekdayFriday": "金",
    "textCalendarShortWeekdayMonday": "月",
    "textCalendarShortWeekdaySunday": "日",
    "pageVideoSubcategoriesMobileApp": "モバイル アプリ",
    "textCalendarShortWeekdayTuesday": "火",
    "textEmailConfirmationWillBeSent": "受信トレイで確認メールをチェックしてください。",
    "headerLiveCourseHighlightsHeader": "次の方法を学習します。",
    "pageVideoCategoriesAccountAccess": "アカウントのアクセス",
    "pageVideoSubcategoriesTeamAccess": "チームのアクセス権",
    "searchFilterOptionRoleTeamMember": "チーム メンバー",
    "textCalendarShortWeekdaySaturday": "土",
    "textCalendarShortWeekdayThursday": "木",
    "formInputLabelGeneralRegistration": "一般登録",
    "pageVideoSubcategoriesDropboxDash": "Dropbox Dash",
    "pageVideoSubcategoriesTeamFolders": "チーム フォルダ",
    "textCalendarShortWeekdayWednesday": "水",
    "formInputLabelGlobalSelectLanguage": "言語を選択してください",
    "formInputLabelSelectDateBreadcrumb": "日付を選択",
    "pageVideoCategoriesAccountSettings": "アカウント設定",
    "pageVideoCategoriesCreateAndUpload": "作成とアップロード",
    "pageVideoSubcategoriesTeamSecurity": "チームのセキュリティ",
    "searchFilterOptionRoleFundamentals": "基礎",
    "pageVideoCategoriesDeleteAndRestore": "削除と復元",
    "pageCourseTopicTableOfContentsHeading": "ここからの項目：",
    "pageVideoSubcategoriesDropboxPolicies": "Dropbox のポリシー",
    "pageVideoSubcategoriesOnDemandTraining": "オンデマンド トレーニング",
    "pageVideoSubcategoriesCommentingOnFiles": "ファイルにコメントする",
    "pageVideoSubcategoriesSharingPermissions": "共有権限",
    "pageVideoSubcategoriesDropboxApplications": "Dropbox のアプリケーション",
    "pageVideoSubcategoriesSearchingYourAccount": "アカウント内の検索",
    "pageVideoSubcategoriesManagingAccountAccess": "アカウントへのアクセスを管理",
    "pageVideoSubcategoriesSharingFilesAndFolders": "ファイルやフォルダを共有する",
    "pageVideoSubcategoriesCreatingFilesAndFolders": "ファイルやフォルダの作成"
  },
  "copyrightText": "Dropbox 2021",
  "seo": {
    "title": {
      "name": "title",
      "value": "Dropbox learn"
    },
    "keywords": {
      "name": "keywords",
      "value": ""
    },
    "og:image": {
      "name": "og:image",
      "value": {
        "id": "2z2Foc0s6DPlQV1aTtWO3b",
        "url": "https://images.ctfassets.net/zh1yxk5yn2r7/2z2Foc0s6DPlQV1aTtWO3b/b0c0e0a58102dd90281f7b1df860a370/Dropbox.svg",
        "title": "Dropbox Logo"
      }
    },
    "og:title": {
      "name": "og:title",
      "value": "Dropbox learn"
    },
    "canonical": {
      "name": "canonical",
      "value": ""
    },
    "description": {
      "name": "description",
      "value": "Learn how to use Dropbox. Browse our catalog of free self-guided courses and virtual instructor led training sessions. Start a Dropbox training course today."
    },
    "twitter:image": {
      "name": "twitter:image",
      "value": {
        "id": "2z2Foc0s6DPlQV1aTtWO3b",
        "url": "https://images.ctfassets.net/zh1yxk5yn2r7/2z2Foc0s6DPlQV1aTtWO3b/b0c0e0a58102dd90281f7b1df860a370/Dropbox.svg",
        "title": "Dropbox Logo"
      }
    },
    "twitter:title": {
      "name": "twitter:title",
      "value": "Dropbox learn"
    },
    "og:description": {
      "name": "og:description",
      "value": "Learn how to use Dropbox. Browse our catalog of free self-guided courses and virtual instructor led training sessions. Start a Dropbox training course today."
    },
    "twitter:description": {
      "name": "twitter:description",
      "value": "Learn how to use Dropbox. Browse our catalog of free self-guided courses and virtual instructor led training sessions. Start a Dropbox training course today."
    }
  },
  "seoOrganizationsSchema": {
    "url": "http://www.dropbox.com",
    "@type": "Organization",
    "@context": "http://schema.org",
    "contactPoint": [
      {
        "@type": "ContactPoint",
        "telephone": "+1-888-888-8888",
        "areaServed": "US",
        "contactType": "customer service",
        "contactOption": "TollFree"
      },
      {
        "@type": "ContactPoint",
        "telephone": "+1-888-888-8888",
        "contactType": "customer service"
      },
      {
        "@type": "ContactPoint",
        "telephone": "+1-888-888-8888",
        "areaServed": "US",
        "contactType": "customer service",
        "contactOption": [
          "HearingImpairedSupported",
          "TollFree"
        ]
      },
      {
        "@type": "ContactPoint",
        "telephone": "+1-888-888-8888",
        "areaServed": [
          "US",
          "CA"
        ],
        "contactType": "technical support",
        "contactOption": "TollFree",
        "availableLanguage": [
          "English",
          "French"
        ]
      },
      {
        "@type": "ContactPoint",
        "telephone": "+1-888-888-8888",
        "areaServed": [
          "US",
          "CA"
        ],
        "contactType": "bill payment",
        "contactOption": "TollFree"
      }
    ]
  }
}
  },
  "pt-BR": {
    isDefault: false,
    settings: {
  "_id": "4KRGLSrqTRY6s18UzHe1II",
  "_contentTypeId": "settingsGlobal",
  "_modifiedDate": "2026-05-14T04:59:02.660Z",
  "internalTitle": "CX Learning Hub Global Settings",
  "topNavigationLogo": {
    "title": "Dropbox Logo",
    "url": "//images.ctfassets.net/zh1yxk5yn2r7/2z2Foc0s6DPlQV1aTtWO3b/b0c0e0a58102dd90281f7b1df860a370/Dropbox.svg",
    "size": 3707,
    "width": 324,
    "height": 64,
    "filename": "Dropbox.svg",
    "contentType": "image/svg+xml"
  },
  "mainNavigation": [
    {
      "internalTitle": "Footer Link - Help center",
      "linkText": "Central de ajuda",
      "destinationType": "Manual text entry",
      "trackingId": "learn-support-help-center",
      "_id": "5pPOxJP1W9PaPBCnLHhe5x",
      "_contentTypeId": "elementLink",
      "href": "https://help.dropbox.com",
      "as": null,
      "target": null,
      "isModal": false,
      "download": false
    },
    {
      "internalTitle": "Supernav - Dropbox Community",
      "linkText": "Comunidade",
      "destinationType": "Manual text entry",
      "_id": "7aVH719lug9lYEJzIntabM",
      "_contentTypeId": "elementLink",
      "href": "https://community.dropbox.com/",
      "as": null,
      "target": "_blank",
      "isModal": false,
      "download": false
    },
    {
      "internalTitle": "Footer Link - Contact us",
      "linkText": "Fale conosco",
      "destinationType": "Manual text entry",
      "trackingId": "learn-support-contact-us",
      "_id": "5v3vwPdKulQu6xhA6csIT8",
      "_contentTypeId": "elementLink",
      "href": "https://www.dropbox.com/contact",
      "as": null,
      "target": null,
      "isModal": false,
      "download": false
    }
  ],
  "secondaryNavigation": [
    {
      "internalTitle": "Secondary Nav - Self-guided learning",
      "linkText": "Aprendizado autoguiado",
      "destinationType": "Content reference",
      "_id": "oMqs4whMJuBjhZsbMv0KA",
      "_contentTypeId": "elementLink",
      "href": "/[slug]",
      "as": "/self-guided-learning",
      "target": null,
      "isModal": false,
      "download": false
    },
    {
      "internalTitle": "Secondary Nav - Videos Landing Page",
      "linkText": "Vídeos",
      "destinationType": "Content reference",
      "_id": "5y8ArqrhCZ6DoCCGxaumhI",
      "_contentTypeId": "elementLink",
      "href": "/[slug]",
      "as": "/video-library",
      "target": null,
      "isModal": false,
      "download": false
    }
  ],
  "footerNavigation": [
    {
      "_id": "1M79uBMmyuD9Iw6fuOdVEJ",
      "_contentTypeId": "elementFooterNavColumn",
      "_modifiedDate": "2026-05-06T15:28:27.147Z",
      "internalTitle": "Dropbox",
      "links": [
        {
          "internalTitle": "Footer Link - Desktop app",
          "linkText": "Aplicativo de desktop",
          "destinationType": "Manual text entry",
          "trackingId": "learn-dropbox-desktop-app",
          "_id": "3SKeLjF7MWEq2FqaRwnmiK",
          "_contentTypeId": "elementLink",
          "href": "https://www.dropbox.com/desktop",
          "as": null,
          "target": null,
          "isModal": false,
          "download": false
        },
        {
          "internalTitle": "Footer Link - Mobile app",
          "linkText": "Aplicativo móvel",
          "destinationType": "Manual text entry",
          "trackingId": "learn-dropbox-mobile-app",
          "_id": "62ymoNSBbWiYinBkFO0cGj",
          "_contentTypeId": "elementLink",
          "href": "https://www.dropbox.com/mobile",
          "as": null,
          "target": null,
          "isModal": false,
          "download": false
        },
        {
          "internalTitle": "Footer Link - Integrations",
          "linkText": "Integrations",
          "destinationType": "Manual text entry",
          "trackingId": "learn-dropbox-integrations",
          "_id": "5WEO1xpKelxpyXS50n3Dxc",
          "_contentTypeId": "elementLink",
          "href": "https://www.dropbox.com/app-integrations",
          "as": null,
          "target": null,
          "isModal": false,
          "download": false
        },
        {
          "internalTitle": "Footer Link - Features",
          "linkText": "Recursos",
          "destinationType": "Manual text entry",
          "trackingId": "learn-dropbox-features",
          "_id": "wUuQPtOLYz96QOSvtgLTh",
          "_contentTypeId": "elementLink",
          "href": "https://www.dropbox.com/features",
          "as": null,
          "target": null,
          "isModal": false,
          "download": false
        },
        {
          "internalTitle": "Footer Link - Solutions",
          "linkText": "Soluções",
          "destinationType": "Manual text entry",
          "trackingId": "learn-dropbox-solutions",
          "_id": "14SJorC6JrH7u2O5E8vf2E",
          "_contentTypeId": "elementLink",
          "href": "https://www.dropbox.com/business/solutions",
          "as": null,
          "target": null,
          "isModal": false,
          "download": false
        },
        {
          "internalTitle": "Footer Link - Security",
          "linkText": "Segurança",
          "destinationType": "Manual text entry",
          "trackingId": "learn-dropbox-security",
          "_id": "2YZlyLOZLw2lauy2OWiuB2",
          "_contentTypeId": "elementLink",
          "href": "https://www.dropbox.com/features/security",
          "as": null,
          "target": null,
          "isModal": false,
          "download": false
        },
        {
          "internalTitle": "Footer Link - Early access",
          "linkText": "Acesso antecipado",
          "destinationType": "Manual text entry",
          "trackingId": "learn-dropbox-early-access",
          "_id": "6u2aXFqnr9s1KXkSjfc2cz",
          "_contentTypeId": "elementLink",
          "href": "https://www.dropbox.com/early-access",
          "as": null,
          "target": null,
          "isModal": false,
          "download": false
        },
        {
          "internalTitle": "Footer Link - Templates",
          "linkText": "Templates",
          "destinationType": "Manual text entry",
          "trackingId": "learn-dropbox-templates",
          "_id": "4yIX8tA1WW1soyk10Frgz5",
          "_contentTypeId": "elementLink",
          "href": "https://www.dropbox.com/templates",
          "as": null,
          "target": null,
          "isModal": false,
          "download": false
        },
        {
          "internalTitle": "Footer Link - Free tools",
          "linkText": "Ferramentas gratuitas",
          "destinationType": "Manual text entry",
          "trackingId": "learn-dropbox-free-tools",
          "_id": "3Fdgsos4Pm77l2C4hKm2AC",
          "_contentTypeId": "elementLink",
          "href": "https://www.dropbox.com/tools",
          "as": null,
          "target": null,
          "isModal": false,
          "download": false
        }
      ]
    },
    {
      "_id": "6LXqBrZEH3p2eDbBpiPFlm",
      "_contentTypeId": "elementFooterNavColumn",
      "_modifiedDate": "2026-05-06T15:28:27.418Z",
      "internalTitle": "Produtos",
      "links": [
        {
          "internalTitle": "Footer Link - Plus",
          "linkText": "Plus",
          "destinationType": "Manual text entry",
          "trackingId": "learn-products-plus",
          "_id": "4nThAv7YjSuKC91UBK1AoR",
          "_contentTypeId": "elementLink",
          "href": "https://www.dropbox.com/plus",
          "as": null,
          "target": null,
          "isModal": false,
          "download": false
        },
        {
          "internalTitle": "Footer Link -  Professional",
          "linkText": "Professional",
          "destinationType": "Manual text entry",
          "trackingId": "learn-products-professional",
          "_id": "5YtdEKxrCJgHqmmDvwgnQI",
          "_contentTypeId": "elementLink",
          "href": "https://www.dropbox.com/pro",
          "as": null,
          "target": "_blank",
          "isModal": false,
          "download": false
        },
        {
          "internalTitle": "Footer Link - Business",
          "linkText": "Negócios",
          "destinationType": "Manual text entry",
          "trackingId": "learn-products-business",
          "_id": "5L4PFaY36Icmt95mUTgjOC",
          "_contentTypeId": "elementLink",
          "href": "https://www.dropbox.com/business",
          "as": null,
          "target": null,
          "isModal": false,
          "download": false
        },
        {
          "internalTitle": "Footer Link - Enterprise",
          "linkText": "Enterprise",
          "destinationType": "Manual text entry",
          "trackingId": "learn-products-enterprise",
          "_id": "4KJcgnikVfGiWIaFiuiRIM",
          "_contentTypeId": "elementLink",
          "href": "https://www.dropbox.com/enterprise",
          "as": null,
          "target": null,
          "isModal": false,
          "download": false
        },
        {
          "internalTitle": "Footer Link - Dash",
          "linkText": "Dash",
          "destinationType": "Manual text entry",
          "trackingId": "learn-products-dash",
          "_id": "4qdbH5UT1PZYVWp4vOADQa",
          "_contentTypeId": "elementLink",
          "href": "https://dash.dropbox.com",
          "as": null,
          "target": null,
          "isModal": false,
          "download": false
        },
        {
          "internalTitle": "Footer Link - DocSend",
          "linkText": "DocSend",
          "destinationType": "Manual text entry",
          "trackingId": "learn-products-docsend",
          "_id": "5hUjrT7Yza4eLKxBevHcAF",
          "_contentTypeId": "elementLink",
          "href": "https://www.docsend.com/?utm_medium=Referral&utm_source=Dropbox%20Web%20Referral&utm_campaign=dbx-footer",
          "as": null,
          "target": null,
          "isModal": false,
          "download": false
        },
        {
          "internalTitle": "Footer Link - Dropbox Sign",
          "linkText": "Dropbox Sign",
          "destinationType": "Manual text entry",
          "trackingId": "learn-products-sign",
          "_id": "4ennWEzf0rjxfCiNTEiU9w",
          "_contentTypeId": "elementLink",
          "href": "https://sign.dropbox.com",
          "as": null,
          "target": null,
          "isModal": false,
          "download": false
        },
        {
          "internalTitle": "Footer Link - Reclaim.ai",
          "linkText": "Reclaim.ai",
          "destinationType": "Manual text entry",
          "trackingId": "learn-products-reclaim-ai",
          "_id": "5XGB9J0ZeBff2lXEapKBR1",
          "_contentTypeId": "elementLink",
          "href": "https://app.reclaim.ai/signup?utm_medium=referral&utm_source=dbx-footer-referral&utm_campaign=dbx-footer-signup&utm_term=dbx-footer",
          "as": null,
          "target": null,
          "isModal": false,
          "download": false
        },
        {
          "internalTitle": "Footer Link - Plans",
          "linkText": "Plans",
          "destinationType": "Manual text entry",
          "trackingId": "learn-products-plans",
          "_id": "13TtJzOJV2eQoZ3TQbNVdd",
          "_contentTypeId": "elementLink",
          "href": "https://www.dropbox.com/plans",
          "as": null,
          "target": null,
          "isModal": false,
          "download": false
        },
        {
          "internalTitle": "Footer Link - Product updates",
          "linkText": "Atualizações do produto",
          "destinationType": "Manual text entry",
          "trackingId": "learn-products-updates",
          "_id": "45NCupQTJZJEBQ1r1pFDDf",
          "_contentTypeId": "elementLink",
          "href": "https://www.dropbox.com/product-updates",
          "as": null,
          "target": null,
          "isModal": false,
          "download": false
        }
      ]
    },
    {
      "_id": "74RyIf3Qiipq4XbcIPQQwT",
      "_contentTypeId": "elementFooterNavColumn",
      "_modifiedDate": "2026-05-06T15:28:27.829Z",
      "internalTitle": "Recursos",
      "links": [
        {
          "internalTitle": "Footer Link - Send large files",
          "linkText": "Envie arquivos grandes",
          "destinationType": "Manual text entry",
          "trackingId": "learn-features-send-large-files",
          "_id": "48eVY6niBIXx4YAPA4XKWz",
          "_contentTypeId": "elementLink",
          "href": "https://www.dropbox.com/features/share/send-large-files",
          "as": null,
          "target": null,
          "isModal": false,
          "download": false
        },
        {
          "internalTitle": "Footer Link - Send long videos",
          "linkText": "Send long videos",
          "destinationType": "Manual text entry",
          "trackingId": "learn-features-send-long-videos",
          "_id": "75e4Pf3aV5ZnB77zgoYITc",
          "_contentTypeId": "elementLink",
          "href": "https://www.dropbox.com/features/share/send-long-videos",
          "as": null,
          "target": null,
          "isModal": false,
          "download": false
        },
        {
          "internalTitle": "Footer Link - Cloud photo storage",
          "linkText": "Cloud photo storage",
          "destinationType": "Manual text entry",
          "trackingId": "learn-features-cloud-photo-storage",
          "_id": "64WyEAeXS80TWroqmR8eHy",
          "_contentTypeId": "elementLink",
          "href": "https://www.dropbox.com/features/cloud-storage/photos",
          "as": null,
          "target": null,
          "isModal": false,
          "download": false
        },
        {
          "internalTitle": "Footer Link - Secure file transfer",
          "linkText": "Secure file transfer",
          "destinationType": "Manual text entry",
          "trackingId": "learn-features-send-secure-file-transfer",
          "_id": "9bUiqp6kN7PfQDoP5dVEA",
          "_contentTypeId": "elementLink",
          "href": "https://www.dropbox.com/features/share/file-transfer",
          "as": null,
          "target": null,
          "isModal": false,
          "download": false
        },
        {
          "internalTitle": "Footer Link - Cloud backup",
          "linkText": "Backup em nuvem",
          "destinationType": "Manual text entry",
          "trackingId": "learn-features-cloud-backup",
          "_id": "4kYfwCJpM6hsTbLd622yzc",
          "_contentTypeId": "elementLink",
          "href": "https://www.dropbox.com/features/cloud-storage/file-backup",
          "as": null,
          "target": null,
          "isModal": false,
          "download": false
        },
        {
          "internalTitle": "Footer Link - Edit PDFs",
          "linkText": "Edit PDFs",
          "destinationType": "Manual text entry",
          "trackingId": "learn-features-edit-pdfs",
          "_id": "1Fw9zhaVelLXfOpxEQwsAy",
          "_contentTypeId": "elementLink",
          "href": "https://www.dropbox.com/features/productivity/pdf-editor",
          "as": null,
          "target": null,
          "isModal": false,
          "download": false
        },
        {
          "internalTitle": "Footer Link - Electronic signatures",
          "linkText": "Electronic signatures",
          "destinationType": "Manual text entry",
          "trackingId": "learn-features-electronic-signatures",
          "_id": "6nhjK34qVMZlkA2opn0vWj",
          "_contentTypeId": "elementLink",
          "href": "https://www.dropbox.com/features/productivity/electronic-signature",
          "as": null,
          "target": null,
          "isModal": false,
          "download": false
        },
        {
          "internalTitle": "Footer Link - Convert to PDF",
          "linkText": "Convert to PDF",
          "destinationType": "Manual text entry",
          "trackingId": "learn-features-convert-to-pdf",
          "_id": "4a7MNYwiyhj6OtmYb87co0",
          "_contentTypeId": "elementLink",
          "href": "https://www.dropbox.com/features/productivity/convert-to-pdf",
          "as": null,
          "target": null,
          "isModal": false,
          "download": false
        }
      ]
    },
    {
      "_id": "1TnZWWGdwo9BEkEKgcIGpA",
      "_contentTypeId": "elementFooterNavColumn",
      "_modifiedDate": "2026-05-06T15:28:27.248Z",
      "internalTitle": "Atendimento",
      "links": [
        {
          "internalTitle": "Footer Link - Help center",
          "linkText": "Central de ajuda",
          "destinationType": "Manual text entry",
          "trackingId": "learn-support-help-center",
          "_id": "5pPOxJP1W9PaPBCnLHhe5x",
          "_contentTypeId": "elementLink",
          "href": "https://help.dropbox.com",
          "as": null,
          "target": null,
          "isModal": false,
          "download": false
        },
        {
          "internalTitle": "Footer Link - Contact us",
          "linkText": "Fale conosco",
          "destinationType": "Manual text entry",
          "trackingId": "learn-support-contact-us",
          "_id": "5v3vwPdKulQu6xhA6csIT8",
          "_contentTypeId": "elementLink",
          "href": "https://www.dropbox.com/contact",
          "as": null,
          "target": null,
          "isModal": false,
          "download": false
        },
        {
          "internalTitle": "Footer Link - Privacy & terms",
          "linkText": "Privacidade e Termos de uso",
          "destinationType": "Manual text entry",
          "trackingId": "learn-support-privacy-terms",
          "_id": "30MJJnJ2DIcvhYL2wsg0FB",
          "_contentTypeId": "elementLink",
          "href": "https://www.dropbox.com/terms",
          "as": null,
          "target": null,
          "isModal": false,
          "download": false
        },
        {
          "internalTitle": "Footer Link - Cookie policy",
          "linkText": "Política de cookies",
          "destinationType": "Manual text entry",
          "trackingId": "learn-support-cookie-policy",
          "_id": "3akG8gNhd73ZlRaEYSCvUD",
          "_contentTypeId": "elementLink",
          "href": "https://help.dropbox.com/security/cookies",
          "as": null,
          "target": null,
          "isModal": false,
          "download": false
        },
        {
          "internalTitle": "Footer Link - Cookies & CCPA preferences",
          "linkText": "Preferências de cookies e CCPA",
          "destinationType": "Manual text entry",
          "trackingId": "learn-support-cookies-CCPA",
          "_id": "65mwIIQg9xKeyKiICuy9DJ",
          "_contentTypeId": "elementLink",
          "href": "https://www.dropbox.com/app-integrations#manage-cookies",
          "as": null,
          "target": null,
          "isModal": false,
          "download": false
        },
        {
          "internalTitle": "Footer Link - AI principles",
          "linkText": "AI principles",
          "destinationType": "Manual text entry",
          "trackingId": "learn-support-ai-principles",
          "_id": "5mTsyPahdNgokTvducSB9i",
          "_contentTypeId": "elementLink",
          "href": "https://www.dropbox.com/ai-principles",
          "as": null,
          "target": null,
          "isModal": false,
          "download": false
        },
        {
          "internalTitle": "Footer Link - Sitemap",
          "linkText": "Mapa do site",
          "destinationType": "Manual text entry",
          "trackingId": "learn-support-sitemap",
          "_id": "37byNy2Pux5TAcdSJm6g4f",
          "_contentTypeId": "elementLink",
          "href": "https://experience.dropbox.com/sitemap",
          "as": null,
          "target": null,
          "isModal": false,
          "download": false
        },
        {
          "internalTitle": "Footer Link - Learning resources",
          "linkText": "Recursos de aprendizagem",
          "destinationType": "Manual text entry",
          "trackingId": "learn-support-learning-resources",
          "_id": "Gj2OgkkQcCs8BXTBr5Irc",
          "_contentTypeId": "elementLink",
          "href": "https://learn.dropbox.com",
          "as": null,
          "target": null,
          "isModal": false,
          "download": false
        }
      ]
    },
    {
      "_id": "28o2jcc5DrafqCYZ9icYU7",
      "_contentTypeId": "elementFooterNavColumn",
      "_modifiedDate": "2026-05-06T15:28:26.982Z",
      "internalTitle": "Recursos",
      "links": [
        {
          "internalTitle": "Footer Link - Blog",
          "linkText": "Blog",
          "destinationType": "Manual text entry",
          "trackingId": "learn-resources-blog",
          "_id": "4vYa3RKqQLWA8bNHcaPX69",
          "_contentTypeId": "elementLink",
          "href": "https://blog.dropbox.com",
          "as": null,
          "target": null,
          "isModal": false,
          "download": false
        },
        {
          "internalTitle": "Footer Link - Events",
          "linkText": "Events",
          "destinationType": "Manual text entry",
          "trackingId": "learn-resources-events",
          "_id": "2D8JKIOdP8zjqZCfsqIG5l",
          "_contentTypeId": "elementLink",
          "href": "https://events.dropbox.com/",
          "as": null,
          "target": null,
          "isModal": false,
          "download": false
        },
        {
          "internalTitle": "Footer Link - Customer stories",
          "linkText": "Customer stories",
          "destinationType": "Manual text entry",
          "trackingId": "learn-resources-customer-stories",
          "_id": "49GkLGyFuV1GvXf1DozTPZ",
          "_contentTypeId": "elementLink",
          "href": "https://www.dropbox.com/customers",
          "as": null,
          "target": null,
          "isModal": false,
          "download": false
        },
        {
          "internalTitle": "Footer Link - Resources library",
          "linkText": "Biblioteca de recursos",
          "destinationType": "Manual text entry",
          "trackingId": "learn-resources-resources-library",
          "_id": "3l98eLMkEyPoj0jzqgBvj7",
          "_contentTypeId": "elementLink",
          "href": "https://www.dropbox.com/resources",
          "as": null,
          "target": null,
          "isModal": false,
          "download": false
        },
        {
          "internalTitle": "Footer Link - Developers",
          "linkText": "Desenvolvedores",
          "destinationType": "Manual text entry",
          "trackingId": "learn-resources-developers",
          "_id": "2aFb3GcSJS0YIEU3aKbLzj",
          "_contentTypeId": "elementLink",
          "href": "https://www.dropbox.com/developers",
          "as": null,
          "target": null,
          "isModal": false,
          "download": false
        },
        {
          "internalTitle": "Footer Link - Community forums",
          "linkText": "Fóruns da comunidade",
          "destinationType": "Manual text entry",
          "trackingId": "learn-resources-community-forums",
          "_id": "4IGtm6twVWzfoE07kHlucc",
          "_contentTypeId": "elementLink",
          "href": "https://community.dropbox.com",
          "as": null,
          "target": null,
          "isModal": false,
          "download": false
        },
        {
          "internalTitle": "Footer Link - Referrals",
          "linkText": "Indicações",
          "destinationType": "Manual text entry",
          "trackingId": "learn-resources-referrals",
          "_id": "4YsKqwQfAG4Ds0a0yeo9wp",
          "_contentTypeId": "elementLink",
          "href": "https://www.dropbox.com/refer",
          "as": null,
          "target": null,
          "isModal": false,
          "download": false
        },
        {
          "internalTitle": "Footer Link - Reseller partners",
          "linkText": "Reseller partners",
          "destinationType": "Manual text entry",
          "trackingId": "learn-resources-reseller-partners",
          "_id": "1w7KmWfsigadpZje40tk18",
          "_contentTypeId": "elementLink",
          "href": "https://www.dropbox.com/business/partners",
          "as": null,
          "target": null,
          "isModal": false,
          "download": false
        },
        {
          "internalTitle": "Footer Link - Integration partners",
          "linkText": "Parceiros de integração",
          "destinationType": "Manual text entry",
          "trackingId": "learn-resources-integration-partners",
          "_id": "6dgcNUDLbEeXQE94s71vrO",
          "_contentTypeId": "elementLink",
          "href": "https://www.dropbox.com/app-integrations",
          "as": null,
          "target": null,
          "isModal": false,
          "download": false
        },
        {
          "internalTitle": "Footer Link - Find a partner",
          "linkText": "Find a partner",
          "destinationType": "Manual text entry",
          "trackingId": "learn-resources-find-a-partner",
          "_id": "2wQU48ntbukgQSKuTKS9in",
          "_contentTypeId": "elementLink",
          "href": "https://experience.dropbox.com/partner-locator",
          "as": null,
          "target": null,
          "isModal": false,
          "download": false
        }
      ]
    },
    {
      "_id": "5xRp5jjLsl92vmGL0qJfVb",
      "_contentTypeId": "elementFooterNavColumn",
      "_modifiedDate": "2026-05-06T15:28:26.948Z",
      "internalTitle": "Empresa",
      "links": [
        {
          "internalTitle": "Footer Link - About us",
          "linkText": "Sobre nós",
          "destinationType": "Manual text entry",
          "trackingId": "learn-company-about-us",
          "_id": "6XnBD8OrJfQZ4u3ZSc6ysr",
          "_contentTypeId": "elementLink",
          "href": "https://www.dropbox.com/about",
          "as": null,
          "target": null,
          "isModal": false,
          "download": false
        },
        {
          "internalTitle": "Footer Link - Jobs",
          "linkText": "Trabalhe conosco",
          "destinationType": "Manual text entry",
          "trackingId": "learn-company-jobs",
          "_id": "1nmf2X1QaLv7zS1PIyfqlE",
          "_contentTypeId": "elementLink",
          "href": "https://jobs.dropbox.com",
          "as": null,
          "target": null,
          "isModal": false,
          "download": false
        },
        {
          "internalTitle": "Footer Link - Investor relations",
          "linkText": "Relações com investidores",
          "destinationType": "Manual text entry",
          "trackingId": "learn-company-investor-relations",
          "_id": "73WTKUyXSmqc5aP1OfisZ9",
          "_contentTypeId": "elementLink",
          "href": "https://dropbox.gcs-web.com/",
          "as": null,
          "target": null,
          "isModal": false,
          "download": false
        },
        {
          "internalTitle": "Footer Link - Corporate responsibility",
          "linkText": "Responsabilidade corporativa",
          "destinationType": "Manual text entry",
          "trackingId": "learn-company-corporate-responsibility",
          "_id": "5iMgmL64RXCXtz8iRkrIIM",
          "_contentTypeId": "elementLink",
          "href": "https://www.dropbox.com/corporate-responsibility",
          "as": null,
          "target": null,
          "isModal": false,
          "download": false
        }
      ]
    }
  ],
  "cookieBarBody": "Usamos cookies para que o Dropbox funcione melhor para você. Ao usar nosso site, você concorda com nossa utilização de cookies.",
  "cookieBarCta": {
    "internalTitle": "Link Text - Cookie bar",
    "linkText": "Saiba mais",
    "destinationType": "Manual text entry",
    "_id": "1tY3PGTzdIHKRi4pDNbmSM",
    "_contentTypeId": "elementLink",
    "href": "https://help.dropbox.com/accounts-billing/security/cookies",
    "as": null,
    "target": "_blank",
    "isModal": false,
    "download": false
  },
  "cookieBarEnabled": true,
  "virtualTrainingsEmptyState": {
    "data": {},
    "content": [
      {
        "data": {},
        "content": [
          {
            "data": {},
            "marks": [],
            "value": "Nada para ver ainda. Registre‑se em uma ",
            "nodeType": "text"
          },
          {
            "data": {
              "target": null
            },
            "content": [
              {
                "data": {},
                "marks": [],
                "value": "sessão de treinamento virtual",
                "nodeType": "text"
              }
            ],
            "nodeType": "entry-hyperlink"
          },
          {
            "data": {},
            "marks": [],
            "value": ".",
            "nodeType": "text"
          }
        ],
        "nodeType": "paragraph"
      }
    ],
    "nodeType": "document"
  },
  "completedCoursesEmptyState": {
    "data": {},
    "content": [
      {
        "data": {},
        "content": [
          {
            "data": {},
            "marks": [],
            "value": "Os cursos que você completou aparecerão aqui.",
            "nodeType": "text"
          }
        ],
        "nodeType": "paragraph"
      }
    ],
    "nodeType": "document"
  },
  "inProgressCoursesEmptyState": {
    "data": {},
    "content": [
      {
        "data": {},
        "content": [
          {
            "data": {},
            "marks": [],
            "value": "Nada para ver ainda. Inicie um ",
            "nodeType": "text"
          },
          {
            "data": {
              "target": {
                "_id": "75pzFP9abHFb2hlQycUS86",
                "_contentTypeId": "pageLanding",
                "_href": "/[slug]",
                "_as": "/self-guided-learning",
                "_modifiedDate": "2026-07-14T14:56:10.933Z",
                "internalTitle": "L2 - Landing page - Self-guided learning",
                "name": "Aprendizado autoguiado",
                "slug": "self-guided-learning",
                "introHero": {
                  "_id": "6pQlpoBglvzGW38DBWvU5W",
                  "_contentTypeId": "moduleHero",
                  "_modifiedDate": "2026-05-15T16:06:56.370Z",
                  "internalTitle": "Hero - Self-guided learning",
                  "headerText": "Aprendizado autoguiado",
                  "summaryText": "Explore cursos guiados sobre o Dropbox, Dash, Replay, Sign e muito mais. Escolha o ideal para você, desde os primeiros passos até a gestão da sua equipe.\n",
                  "image": {
                    "title": "Self-Guided Learning Illustration",
                    "description": "Book illustration for Dropbox's self-guided learning courses",
                    "url": "//images.ctfassets.net/zh1yxk5yn2r7/6ODZb6bllZrucIYtiLqFkU/f844e955cabc76e34e249d9c18e43d62/self-guided-learning.svg",
                    "size": 42902,
                    "width": 405,
                    "height": 310,
                    "filename": "self-guided-learning.svg",
                    "contentType": "image/svg+xml"
                  }
                },
                "contentSections": [
                  {
                    "_id": "6MGcQfM5kOFGpBqiOmSkKy",
                    "_contentTypeId": "moduleFeaturedCourse",
                    "_modifiedDate": "2026-11-05T12:58:40.480Z",
                    "internalTitle": "Featured - Self-guided learning",
                    "title": "Curso em destaque",
                    "course": null
                  },
                  {
                    "_id": "4JIWsH681XIFek4zmBB6Ix",
                    "_contentTypeId": "moduleMultiColumnCourses",
                    "_modifiedDate": "2026-11-05T12:58:40.355Z",
                    "internalTitle": "All courses - Self-guided learning - Cards",
                    "title": "Todos os cursos",
                    "courses": []
                  }
                ],
                "seo": {
                  "title": {
                    "name": "title",
                    "value": "Cursos de treinamento autoguiado do Dropbox | Aprenda sobre o Dropbox"
                  },
                  "keywords": {
                    "name": "keywords",
                    "value": ""
                  },
                  "og:image": {
                    "name": "og:image",
                    "value": {
                      "id": "33cKbUcUgjCOB3aPxkIMGq",
                      "url": "https://images.ctfassets.net/zh1yxk5yn2r7/33cKbUcUgjCOB3aPxkIMGq/14cdd574f957e960f0972f73a80a892e/hoop.png",
                      "title": "hoop"
                    }
                  },
                  "description": {
                    "name": "description",
                    "value": "Cursos individualizados de treinamento do Dropbox, disponíveis gratuitamente e sob demanda. Aprenda a usar sua conta do Dropbox no seu próprio ritmo. Inscreva-se hoje mesmo."
                  },
                  "twitter:title": {
                    "name": "twitter:title",
                    "value": "Dropbox"
                  }
                }
              }
            },
            "content": [
              {
                "data": {},
                "marks": [],
                "value": "curso de aprendizado autoguiado",
                "nodeType": "text"
              }
            ],
            "nodeType": "entry-hyperlink"
          },
          {
            "data": {},
            "marks": [],
            "value": ".",
            "nodeType": "text"
          }
        ],
        "nodeType": "paragraph"
      }
    ],
    "nodeType": "document"
  },
  "l18nLookup": {
    "see": "Acesse",
    "noData": "Nenhum resultado encontrado",
    "textHr": "h",
    "filters": "Filtros",
    "modules": "Módulos",
    "results": "Resultados",
    "textHrs": "h",
    "textMin": "mín",
    "clearall": "Limpar todos os filtros",
    "continue": "Continuar",
    "featured": "Destaque",
    "textHour": "hora",
    "textLess": "Menos",
    "textMins": "min",
    "textMore": "Mais",
    "textRead": "Ler",
    "allvidoes": "Todos os vídeos",
    "labelTags": "Tags",
    "learnText": "Saiba mais",
    "startdemo": "Iniciar demonstração",
    "textClear": "Limpar",
    "textHours": "Horários",
    "useStacks": "Como usar os acervos",
    "findCourse": "Encontre um curso",
    "textMinute": "minuto",
    "transcript": "Transcrição",
    "ctaTextBack": "Voltar",
    "ctaTextNext": "Seguinte",
    "filterstext": "Filtros",
    "joinUrlText": "Participar da sessão",
    "moreAnswers": "para ver mais recursos.",
    "noCouresYet": "Ainda não há cursos",
    "readingTime": "Leitura de minutos",
    "textMinutes": "minutos",
    "textSeeMore": "Ver mais",
    "textViewAll": "Visualizar tudo",
    "alltutorials": "todos os tutoriais",
    "ctaTextLogIn": "Entrar",
    "noresultText": "Tente usar palavras-chave diferentes ou navegue",
    "searchHeader": "Buscar",
    "textComplete": "Concluído",
    "textError404": "Erro (404)",
    "textFilterBy": "Filtro",
    "videolibrary": "Biblioteca de vídeos",
    "browseKeyword": "tente usar palavras-chave diferentes ou navegue",
    "ctaTextLogout": "Sair",
    "ctaTextSignIn": "Acessar",
    "labelSubjects": "Assunto",
    "moreTutorials": "Mais tutoriais",
    "popUpBodyText": "Você acabou de concluir o curso para administradores do Dropbox Business!",
    "textNextTopic": "Próximo módulo",
    "trackProgress": "Inicie um curso para acompanhar seu progresso aqui.",
    "ctaTextProfile": "Meu perfil",
    "ctaTextVirtual": "Visualizar sessão",
    "headerDuration": "Duração",
    "languageNameDe": "Deutsch",
    "languageNameEs": "Español",
    "languageNameFr": "Français",
    "languageNameIt": "Italiano",
    "languageNameJa": "日本語",
    "matchingsearch": "Não foi possível encontrar nada que corresponda à sua busca.",
    "viewAllCourses": "Veja todos os cursos",
    "ctaTextRegister": "Registrar agora",
    "labelCategories": "Categorias",
    "searchNoResults": "Nenhum resultado para {{search}}",
    "textStartCourse": "Iniciar curso",
    "textWebinarFull": "Este webinar está lotado. Tente um outro dia ou horário.",
    "accountLabelLast": "Sobrenome",
    "accountLabelName": "Nome",
    "ctaCreateAccount": "Criar conta",
    "languageNameEnUs": "Inglês",
    "languageNamePtBr": "Português",
    "searchBreadcrumb": "Resultados da busca",
    "searchFilterRole": "Função",
    "textErrorUnknown": "Algo deu errado",
    "textResumeCourse": "Retomar o curso",
    "accountLabelEmail": "E-mail",
    "ctaTextReschedule": "Reagendar",
    "ctaTextSelfGuided": "Ver módulos",
    "ctaTextViewCourse": "Ver curso",
    "formLabelAttended": "Assistido",
    "headerAccountInfo": "Informações da conta",
    "textErrorPageHome": "Início",
    "textPreviousTopic": "Anterior",
    "ctaTextCancelClass": "Cancelar esta aula",
    "formInputLabelDate": "Data",
    "headerPersonalInfo": "Informações pessoais",
    "labelSubcategories": "Subcategorias",
    "searchResultStatus": "resultados encontrados",
    "selfguidedLearning": "Aprendizado autoguiado",
    "textBreadcrumbRoot": "Aprenda sobre o Dropbox",
    "textCourseProgress": "Progresso do curso",
    "formInputLabelEmail": "E-mail",
    "globalTextCopyright": "Texto de copyright",
    "signInpopUpBodyText": "Tenha controle dos módulos que concluir",
    "textDropdownDefault": "Os horários estão configurados de acordo com o seu fuso horário",
    "textErrorPageSignIn": "Acessar",
    "textTableOfContents": "Módulos",
    "canceledRegistration": "Registro cancelado com sucesso",
    "formInputLabelCourse": "Curso",
    "formInputLabelStatus": "Status",
    "searchFilterLanguage": "Idioma",
    "searchResultsPerPage": "Resultados por página",
    "textSigninModalIntro": "Acesse a conta para salvar o seu progresso",
    "topicCountTextPlural": "Tópicos",
    "topicCountTextSingle": "Tópico",
    "headerSuggestedTopics": "Módulos sugeridos",
    "searchFilterOptionSgc": "Curso individualizado",
    "searchResultTypeTopic": "Módulo",
    "searchResultTypeVideo": "Vídeo",
    "textAlreadyRegistered": "Você já se registrou neste webinar.",
    "textYouMustLogInFirst": "É preciso acessar a conta primeiro",
    "formInputLabelAttendee": "Participante",
    "formInputLabelLastName": "Sobrenome",
    "formInputLabelOverview": "Visão geral",
    "headerEventDescription": "Descrição da sessão",
    "headerProfileCompleted": "Concluído",
    "searchFilterOptionLive": "Sessão ao vivo",
    "searchFilterOptionTeam": "Membros da equipe",
    "textCourseExpectations": "O que esperar:",
    "textLearningObjectives": "O que você vai aprender",
    "formInputLabelFirstName": "Nome",
    "headerProfileInProgress": " Em andamento",
    "pageVideoCategoriesSync": "Sincronização",
    "searchFilterContentType": "Tipo de conteúdo",
    "searchFilterOptionAdmin": "Administrador",
    "searchFilterOptionTopic": "Módulo",
    "searchPageTitleMetadata": "Busca | Aprenda sobre o Dropbox",
    "textErrorPageHelpCenter": "Central de ajuda",
    "formInputLabelSelectDate": "Selecione uma data",
    "formInputLabelSelectTime": "Selecione um horário",
    "headerProfileLiveCourses": "Próximos cursos",
    "pageVideoCategoriesShare": "Compartilhar",
    "formInputLabelSessionLink": "Link da sessão",
    "textErrorPageHelpfulLinks": "Aqui estão alguns links úteis:",
    "textErrorPagePageNotFound": "Não foi possível encontrar a página que você está procurando",
    "textRegistrationCompleted": "Você está inscrito",
    "breadcrumbTextRegistration": "Inscrição",
    "formInputLabelPickLanguage": "Selecione seu idioma",
    "pageVideoCategoriesWebinar": "Webinar",
    "searchPageKeywordsMetadata": "buscar",
    "searchResultTypeSelfGuided": "Curso",
    "ctaTextCompleteRegistration": "Conclua sua inscrição",
    "headerEnterRegistrationInfo": "Insira suas informações de inscrição",
    "headerRegisteredLiveCourses": "Treinamentos virtuais cadastrados",
    "pageVideoCategoriesInstalls": "Instalar",
    "pageVideoCategoriesOrganize": "Organizar",
    "pageVideoCategoriesProducts": "Produtos",
    "pageVideoCategoriesSecurity": "Segurança",
    "searchFilterOptionRoleAdmin": "Administrador",
    "searchResultTypeLiveSession": "Sessão ao vivo",
    "headerRegistrationSuccessful": "Você se inscreveu com sucesso",
    "headerSearchInputPlaceholder": "Buscar",
    "pageVideoSubcategoriesDelete": "Excluir",
    "pageVideoSubcategoriesReplay": "Replay",
    "pageVideoSubcategoriesRewind": "Retroceder",
    "pageVideoSubcategoriesSignIn": "Acessar",
    "searchFilterOptionIndividual": "Individual",
    "formInputLabelCourseCompleted": "Curso concluído",
    "pageVideoSubcategoriesCapture": "Capture",
    "pageVideoSubcategoriesRestore": "Restaurar",
    "searchPageDescriptionMetadata": "Você pode procurar módulos ou informações para saber mais sobre os nossos cursos. Encontre a aprendizagem autoguiada ou o treinamento mais adequado às suas necessidades.",
    "pageVideoCategoriesViewAndEdit": "Visualizar e editar",
    "pageVideoSubcategoriesTransfer": "Transfer",
    "searchFilterOptionRoleHelpDesk": "Serviço de ajuda",
    "textCalendarShortWeekdayFriday": "sex",
    "textCalendarShortWeekdayMonday": "seg",
    "textCalendarShortWeekdaySunday": "dom",
    "pageVideoSubcategoriesMobileApp": "Aplicativo móvel",
    "textCalendarShortWeekdayTuesday": "ter",
    "textEmailConfirmationWillBeSent": "Verifique se recebeu um e-mail de confirmação em sua caixa de entrada.",
    "headerLiveCourseHighlightsHeader": "Você aprenderá a:",
    "pageVideoCategoriesAccountAccess": "Acesso à conta",
    "pageVideoSubcategoriesTeamAccess": "Acesso da equipe",
    "searchFilterOptionRoleTeamMember": "Membros da equipe",
    "textCalendarShortWeekdaySaturday": "sáb",
    "textCalendarShortWeekdayThursday": "qui",
    "formInputLabelGeneralRegistration": "Inscrição geral",
    "pageVideoSubcategoriesDropboxDash": "Dropbox Dash",
    "pageVideoSubcategoriesTeamFolders": "Pastas da equipe",
    "textCalendarShortWeekdayWednesday": "qua",
    "formInputLabelGlobalSelectLanguage": "Selecione um idioma",
    "formInputLabelSelectDateBreadcrumb": "Selecionar data",
    "pageVideoCategoriesAccountSettings": "Configurações da conta",
    "pageVideoCategoriesCreateAndUpload": "Criar e enviar",
    "pageVideoSubcategoriesTeamSecurity": "Segurança da equipe",
    "searchFilterOptionRoleFundamentals": "Básico",
    "pageVideoCategoriesDeleteAndRestore": "Excluir e restaurar",
    "pageCourseTopicTableOfContentsHeading": "Seções deste artigo:",
    "pageVideoSubcategoriesDropboxPolicies": "Políticas do Dropbox",
    "pageVideoSubcategoriesOnDemandTraining": "Treinamento sob demanda",
    "pageVideoSubcategoriesCommentingOnFiles": "Comentários nos arquivos",
    "pageVideoSubcategoriesSharingPermissions": "Permissões de compartilhamento",
    "pageVideoSubcategoriesDropboxApplications": "Aplicativos do Dropbox",
    "pageVideoSubcategoriesSearchingYourAccount": "Buscar na sua conta",
    "pageVideoSubcategoriesManagingAccountAccess": "Gerenciamento do acesso à conta",
    "pageVideoSubcategoriesSharingFilesAndFolders": "Compartilhando arquivos e pastas",
    "pageVideoSubcategoriesCreatingFilesAndFolders": "Como criar arquivos e pastas"
  },
  "copyrightText": "Dropbox 2021",
  "seo": {
    "title": {
      "name": "title",
      "value": "Dropbox learn"
    },
    "keywords": {
      "name": "keywords",
      "value": ""
    },
    "og:image": {
      "name": "og:image",
      "value": {
        "id": "2z2Foc0s6DPlQV1aTtWO3b",
        "url": "https://images.ctfassets.net/zh1yxk5yn2r7/2z2Foc0s6DPlQV1aTtWO3b/b0c0e0a58102dd90281f7b1df860a370/Dropbox.svg",
        "title": "Dropbox Logo"
      }
    },
    "og:title": {
      "name": "og:title",
      "value": "Dropbox learn"
    },
    "canonical": {
      "name": "canonical",
      "value": ""
    },
    "description": {
      "name": "description",
      "value": "Learn how to use Dropbox. Browse our catalog of free self-guided courses and virtual instructor led training sessions. Start a Dropbox training course today."
    },
    "twitter:image": {
      "name": "twitter:image",
      "value": {
        "id": "2z2Foc0s6DPlQV1aTtWO3b",
        "url": "https://images.ctfassets.net/zh1yxk5yn2r7/2z2Foc0s6DPlQV1aTtWO3b/b0c0e0a58102dd90281f7b1df860a370/Dropbox.svg",
        "title": "Dropbox Logo"
      }
    },
    "twitter:title": {
      "name": "twitter:title",
      "value": "Dropbox learn"
    },
    "og:description": {
      "name": "og:description",
      "value": "Learn how to use Dropbox. Browse our catalog of free self-guided courses and virtual instructor led training sessions. Start a Dropbox training course today."
    },
    "twitter:description": {
      "name": "twitter:description",
      "value": "Learn how to use Dropbox. Browse our catalog of free self-guided courses and virtual instructor led training sessions. Start a Dropbox training course today."
    }
  },
  "seoOrganizationsSchema": {
    "url": "http://www.dropbox.com",
    "@type": "Organization",
    "@context": "http://schema.org",
    "contactPoint": [
      {
        "@type": "ContactPoint",
        "telephone": "+1-888-888-8888",
        "areaServed": "US",
        "contactType": "customer service",
        "contactOption": "TollFree"
      },
      {
        "@type": "ContactPoint",
        "telephone": "+1-888-888-8888",
        "contactType": "customer service"
      },
      {
        "@type": "ContactPoint",
        "telephone": "+1-888-888-8888",
        "areaServed": "US",
        "contactType": "customer service",
        "contactOption": [
          "HearingImpairedSupported",
          "TollFree"
        ]
      },
      {
        "@type": "ContactPoint",
        "telephone": "+1-888-888-8888",
        "areaServed": [
          "US",
          "CA"
        ],
        "contactType": "technical support",
        "contactOption": "TollFree",
        "availableLanguage": [
          "English",
          "French"
        ]
      },
      {
        "@type": "ContactPoint",
        "telephone": "+1-888-888-8888",
        "areaServed": [
          "US",
          "CA"
        ],
        "contactType": "bill payment",
        "contactOption": "TollFree"
      }
    ]
  }
}
  },
  "es": {
    isDefault: false,
    settings: {
  "_id": "4KRGLSrqTRY6s18UzHe1II",
  "_contentTypeId": "settingsGlobal",
  "_modifiedDate": "2026-05-14T04:59:02.660Z",
  "internalTitle": "CX Learning Hub Global Settings",
  "topNavigationLogo": {
    "title": "Dropbox Logo",
    "url": "//images.ctfassets.net/zh1yxk5yn2r7/2z2Foc0s6DPlQV1aTtWO3b/b0c0e0a58102dd90281f7b1df860a370/Dropbox.svg",
    "size": 3707,
    "width": 324,
    "height": 64,
    "filename": "Dropbox.svg",
    "contentType": "image/svg+xml"
  },
  "mainNavigation": [
    {
      "internalTitle": "Footer Link - Help center",
      "linkText": "Centro de ayuda",
      "destinationType": "Manual text entry",
      "trackingId": "learn-support-help-center",
      "_id": "5pPOxJP1W9PaPBCnLHhe5x",
      "_contentTypeId": "elementLink",
      "href": "https://help.dropbox.com",
      "as": null,
      "target": null,
      "isModal": false,
      "download": false
    },
    {
      "internalTitle": "Supernav - Dropbox Community",
      "linkText": "Comunidad",
      "destinationType": "Manual text entry",
      "_id": "7aVH719lug9lYEJzIntabM",
      "_contentTypeId": "elementLink",
      "href": "https://community.dropbox.com/",
      "as": null,
      "target": "_blank",
      "isModal": false,
      "download": false
    },
    {
      "internalTitle": "Footer Link - Contact us",
      "linkText": "Contacto",
      "destinationType": "Manual text entry",
      "trackingId": "learn-support-contact-us",
      "_id": "5v3vwPdKulQu6xhA6csIT8",
      "_contentTypeId": "elementLink",
      "href": "https://www.dropbox.com/contact",
      "as": null,
      "target": null,
      "isModal": false,
      "download": false
    }
  ],
  "secondaryNavigation": [
    {
      "internalTitle": "Secondary Nav - Self-guided learning",
      "linkText": "Aprendizaje autodirigido",
      "destinationType": "Content reference",
      "_id": "oMqs4whMJuBjhZsbMv0KA",
      "_contentTypeId": "elementLink",
      "href": "/[slug]",
      "as": "/self-guided-learning",
      "target": null,
      "isModal": false,
      "download": false
    },
    {
      "internalTitle": "Secondary Nav - Videos Landing Page",
      "linkText": "Vídeos",
      "destinationType": "Content reference",
      "_id": "5y8ArqrhCZ6DoCCGxaumhI",
      "_contentTypeId": "elementLink",
      "href": "/[slug]",
      "as": "/video-library",
      "target": null,
      "isModal": false,
      "download": false
    }
  ],
  "footerNavigation": [
    {
      "_id": "1M79uBMmyuD9Iw6fuOdVEJ",
      "_contentTypeId": "elementFooterNavColumn",
      "_modifiedDate": "2026-05-06T15:28:27.147Z",
      "internalTitle": "Dropbox",
      "links": [
        {
          "internalTitle": "Footer Link - Desktop app",
          "linkText": "Aplicación de escritorio",
          "destinationType": "Manual text entry",
          "trackingId": "learn-dropbox-desktop-app",
          "_id": "3SKeLjF7MWEq2FqaRwnmiK",
          "_contentTypeId": "elementLink",
          "href": "https://www.dropbox.com/desktop",
          "as": null,
          "target": null,
          "isModal": false,
          "download": false
        },
        {
          "internalTitle": "Footer Link - Mobile app",
          "linkText": "Aplicación móvil",
          "destinationType": "Manual text entry",
          "trackingId": "learn-dropbox-mobile-app",
          "_id": "62ymoNSBbWiYinBkFO0cGj",
          "_contentTypeId": "elementLink",
          "href": "https://www.dropbox.com/mobile",
          "as": null,
          "target": null,
          "isModal": false,
          "download": false
        },
        {
          "internalTitle": "Footer Link - Integrations",
          "linkText": "Integrations",
          "destinationType": "Manual text entry",
          "trackingId": "learn-dropbox-integrations",
          "_id": "5WEO1xpKelxpyXS50n3Dxc",
          "_contentTypeId": "elementLink",
          "href": "https://www.dropbox.com/app-integrations",
          "as": null,
          "target": null,
          "isModal": false,
          "download": false
        },
        {
          "internalTitle": "Footer Link - Features",
          "linkText": "Funciones",
          "destinationType": "Manual text entry",
          "trackingId": "learn-dropbox-features",
          "_id": "wUuQPtOLYz96QOSvtgLTh",
          "_contentTypeId": "elementLink",
          "href": "https://www.dropbox.com/features",
          "as": null,
          "target": null,
          "isModal": false,
          "download": false
        },
        {
          "internalTitle": "Footer Link - Solutions",
          "linkText": "Solutions",
          "destinationType": "Manual text entry",
          "trackingId": "learn-dropbox-solutions",
          "_id": "14SJorC6JrH7u2O5E8vf2E",
          "_contentTypeId": "elementLink",
          "href": "https://www.dropbox.com/business/solutions",
          "as": null,
          "target": null,
          "isModal": false,
          "download": false
        },
        {
          "internalTitle": "Footer Link - Security",
          "linkText": "Seguridad",
          "destinationType": "Manual text entry",
          "trackingId": "learn-dropbox-security",
          "_id": "2YZlyLOZLw2lauy2OWiuB2",
          "_contentTypeId": "elementLink",
          "href": "https://www.dropbox.com/features/security",
          "as": null,
          "target": null,
          "isModal": false,
          "download": false
        },
        {
          "internalTitle": "Footer Link - Early access",
          "linkText": "Early access",
          "destinationType": "Manual text entry",
          "trackingId": "learn-dropbox-early-access",
          "_id": "6u2aXFqnr9s1KXkSjfc2cz",
          "_contentTypeId": "elementLink",
          "href": "https://www.dropbox.com/early-access",
          "as": null,
          "target": null,
          "isModal": false,
          "download": false
        },
        {
          "internalTitle": "Footer Link - Templates",
          "linkText": "Templates",
          "destinationType": "Manual text entry",
          "trackingId": "learn-dropbox-templates",
          "_id": "4yIX8tA1WW1soyk10Frgz5",
          "_contentTypeId": "elementLink",
          "href": "https://www.dropbox.com/templates",
          "as": null,
          "target": null,
          "isModal": false,
          "download": false
        },
        {
          "internalTitle": "Footer Link - Free tools",
          "linkText": "Herramientas gratuitas",
          "destinationType": "Manual text entry",
          "trackingId": "learn-dropbox-free-tools",
          "_id": "3Fdgsos4Pm77l2C4hKm2AC",
          "_contentTypeId": "elementLink",
          "href": "https://www.dropbox.com/tools",
          "as": null,
          "target": null,
          "isModal": false,
          "download": false
        }
      ]
    },
    {
      "_id": "6LXqBrZEH3p2eDbBpiPFlm",
      "_contentTypeId": "elementFooterNavColumn",
      "_modifiedDate": "2026-05-06T15:28:27.418Z",
      "internalTitle": "Productos",
      "links": [
        {
          "internalTitle": "Footer Link - Plus",
          "linkText": "Plus",
          "destinationType": "Manual text entry",
          "trackingId": "learn-products-plus",
          "_id": "4nThAv7YjSuKC91UBK1AoR",
          "_contentTypeId": "elementLink",
          "href": "https://www.dropbox.com/plus",
          "as": null,
          "target": null,
          "isModal": false,
          "download": false
        },
        {
          "internalTitle": "Footer Link -  Professional",
          "linkText": "Professional",
          "destinationType": "Manual text entry",
          "trackingId": "learn-products-professional",
          "_id": "5YtdEKxrCJgHqmmDvwgnQI",
          "_contentTypeId": "elementLink",
          "href": "https://www.dropbox.com/pro",
          "as": null,
          "target": "_blank",
          "isModal": false,
          "download": false
        },
        {
          "internalTitle": "Footer Link - Business",
          "linkText": "Empresa",
          "destinationType": "Manual text entry",
          "trackingId": "learn-products-business",
          "_id": "5L4PFaY36Icmt95mUTgjOC",
          "_contentTypeId": "elementLink",
          "href": "https://www.dropbox.com/business",
          "as": null,
          "target": null,
          "isModal": false,
          "download": false
        },
        {
          "internalTitle": "Footer Link - Enterprise",
          "linkText": "Enterprise",
          "destinationType": "Manual text entry",
          "trackingId": "learn-products-enterprise",
          "_id": "4KJcgnikVfGiWIaFiuiRIM",
          "_contentTypeId": "elementLink",
          "href": "https://www.dropbox.com/enterprise",
          "as": null,
          "target": null,
          "isModal": false,
          "download": false
        },
        {
          "internalTitle": "Footer Link - Dash",
          "linkText": "Dash",
          "destinationType": "Manual text entry",
          "trackingId": "learn-products-dash",
          "_id": "4qdbH5UT1PZYVWp4vOADQa",
          "_contentTypeId": "elementLink",
          "href": "https://dash.dropbox.com",
          "as": null,
          "target": null,
          "isModal": false,
          "download": false
        },
        {
          "internalTitle": "Footer Link - DocSend",
          "linkText": "DocSend",
          "destinationType": "Manual text entry",
          "trackingId": "learn-products-docsend",
          "_id": "5hUjrT7Yza4eLKxBevHcAF",
          "_contentTypeId": "elementLink",
          "href": "https://www.docsend.com/?utm_medium=Referral&utm_source=Dropbox%20Web%20Referral&utm_campaign=dbx-footer",
          "as": null,
          "target": null,
          "isModal": false,
          "download": false
        },
        {
          "internalTitle": "Footer Link - Dropbox Sign",
          "linkText": "Dropbox Sign",
          "destinationType": "Manual text entry",
          "trackingId": "learn-products-sign",
          "_id": "4ennWEzf0rjxfCiNTEiU9w",
          "_contentTypeId": "elementLink",
          "href": "https://sign.dropbox.com",
          "as": null,
          "target": null,
          "isModal": false,
          "download": false
        },
        {
          "internalTitle": "Footer Link - Reclaim.ai",
          "linkText": "Reclaim.ai",
          "destinationType": "Manual text entry",
          "trackingId": "learn-products-reclaim-ai",
          "_id": "5XGB9J0ZeBff2lXEapKBR1",
          "_contentTypeId": "elementLink",
          "href": "https://app.reclaim.ai/signup?utm_medium=referral&utm_source=dbx-footer-referral&utm_campaign=dbx-footer-signup&utm_term=dbx-footer",
          "as": null,
          "target": null,
          "isModal": false,
          "download": false
        },
        {
          "internalTitle": "Footer Link - Plans",
          "linkText": "Plans",
          "destinationType": "Manual text entry",
          "trackingId": "learn-products-plans",
          "_id": "13TtJzOJV2eQoZ3TQbNVdd",
          "_contentTypeId": "elementLink",
          "href": "https://www.dropbox.com/plans",
          "as": null,
          "target": null,
          "isModal": false,
          "download": false
        },
        {
          "internalTitle": "Footer Link - Product updates",
          "linkText": "Actualizaciones de productos",
          "destinationType": "Manual text entry",
          "trackingId": "learn-products-updates",
          "_id": "45NCupQTJZJEBQ1r1pFDDf",
          "_contentTypeId": "elementLink",
          "href": "https://www.dropbox.com/product-updates",
          "as": null,
          "target": null,
          "isModal": false,
          "download": false
        }
      ]
    },
    {
      "_id": "74RyIf3Qiipq4XbcIPQQwT",
      "_contentTypeId": "elementFooterNavColumn",
      "_modifiedDate": "2026-05-06T15:28:27.829Z",
      "internalTitle": "Features",
      "links": [
        {
          "internalTitle": "Footer Link - Send large files",
          "linkText": "Send large files",
          "destinationType": "Manual text entry",
          "trackingId": "learn-features-send-large-files",
          "_id": "48eVY6niBIXx4YAPA4XKWz",
          "_contentTypeId": "elementLink",
          "href": "https://www.dropbox.com/features/share/send-large-files",
          "as": null,
          "target": null,
          "isModal": false,
          "download": false
        },
        {
          "internalTitle": "Footer Link - Send long videos",
          "linkText": "Send long videos",
          "destinationType": "Manual text entry",
          "trackingId": "learn-features-send-long-videos",
          "_id": "75e4Pf3aV5ZnB77zgoYITc",
          "_contentTypeId": "elementLink",
          "href": "https://www.dropbox.com/features/share/send-long-videos",
          "as": null,
          "target": null,
          "isModal": false,
          "download": false
        },
        {
          "internalTitle": "Footer Link - Cloud photo storage",
          "linkText": "Cloud photo storage",
          "destinationType": "Manual text entry",
          "trackingId": "learn-features-cloud-photo-storage",
          "_id": "64WyEAeXS80TWroqmR8eHy",
          "_contentTypeId": "elementLink",
          "href": "https://www.dropbox.com/features/cloud-storage/photos",
          "as": null,
          "target": null,
          "isModal": false,
          "download": false
        },
        {
          "internalTitle": "Footer Link - Secure file transfer",
          "linkText": "Secure file transfer",
          "destinationType": "Manual text entry",
          "trackingId": "learn-features-send-secure-file-transfer",
          "_id": "9bUiqp6kN7PfQDoP5dVEA",
          "_contentTypeId": "elementLink",
          "href": "https://www.dropbox.com/features/share/file-transfer",
          "as": null,
          "target": null,
          "isModal": false,
          "download": false
        },
        {
          "internalTitle": "Footer Link - Cloud backup",
          "linkText": "Cloud backup",
          "destinationType": "Manual text entry",
          "trackingId": "learn-features-cloud-backup",
          "_id": "4kYfwCJpM6hsTbLd622yzc",
          "_contentTypeId": "elementLink",
          "href": "https://www.dropbox.com/features/cloud-storage/file-backup",
          "as": null,
          "target": null,
          "isModal": false,
          "download": false
        },
        {
          "internalTitle": "Footer Link - Edit PDFs",
          "linkText": "Edit PDFs",
          "destinationType": "Manual text entry",
          "trackingId": "learn-features-edit-pdfs",
          "_id": "1Fw9zhaVelLXfOpxEQwsAy",
          "_contentTypeId": "elementLink",
          "href": "https://www.dropbox.com/features/productivity/pdf-editor",
          "as": null,
          "target": null,
          "isModal": false,
          "download": false
        },
        {
          "internalTitle": "Footer Link - Electronic signatures",
          "linkText": "Electronic signatures",
          "destinationType": "Manual text entry",
          "trackingId": "learn-features-electronic-signatures",
          "_id": "6nhjK34qVMZlkA2opn0vWj",
          "_contentTypeId": "elementLink",
          "href": "https://www.dropbox.com/features/productivity/electronic-signature",
          "as": null,
          "target": null,
          "isModal": false,
          "download": false
        },
        {
          "internalTitle": "Footer Link - Convert to PDF",
          "linkText": "Convert to PDF",
          "destinationType": "Manual text entry",
          "trackingId": "learn-features-convert-to-pdf",
          "_id": "4a7MNYwiyhj6OtmYb87co0",
          "_contentTypeId": "elementLink",
          "href": "https://www.dropbox.com/features/productivity/convert-to-pdf",
          "as": null,
          "target": null,
          "isModal": false,
          "download": false
        }
      ]
    },
    {
      "_id": "1TnZWWGdwo9BEkEKgcIGpA",
      "_contentTypeId": "elementFooterNavColumn",
      "_modifiedDate": "2026-05-06T15:28:27.248Z",
      "internalTitle": "Asistencia",
      "links": [
        {
          "internalTitle": "Footer Link - Help center",
          "linkText": "Centro de ayuda",
          "destinationType": "Manual text entry",
          "trackingId": "learn-support-help-center",
          "_id": "5pPOxJP1W9PaPBCnLHhe5x",
          "_contentTypeId": "elementLink",
          "href": "https://help.dropbox.com",
          "as": null,
          "target": null,
          "isModal": false,
          "download": false
        },
        {
          "internalTitle": "Footer Link - Contact us",
          "linkText": "Contacto",
          "destinationType": "Manual text entry",
          "trackingId": "learn-support-contact-us",
          "_id": "5v3vwPdKulQu6xhA6csIT8",
          "_contentTypeId": "elementLink",
          "href": "https://www.dropbox.com/contact",
          "as": null,
          "target": null,
          "isModal": false,
          "download": false
        },
        {
          "internalTitle": "Footer Link - Privacy & terms",
          "linkText": "Privacidad y condiciones",
          "destinationType": "Manual text entry",
          "trackingId": "learn-support-privacy-terms",
          "_id": "30MJJnJ2DIcvhYL2wsg0FB",
          "_contentTypeId": "elementLink",
          "href": "https://www.dropbox.com/terms",
          "as": null,
          "target": null,
          "isModal": false,
          "download": false
        },
        {
          "internalTitle": "Footer Link - Cookie policy",
          "linkText": "Política de cookies",
          "destinationType": "Manual text entry",
          "trackingId": "learn-support-cookie-policy",
          "_id": "3akG8gNhd73ZlRaEYSCvUD",
          "_contentTypeId": "elementLink",
          "href": "https://help.dropbox.com/security/cookies",
          "as": null,
          "target": null,
          "isModal": false,
          "download": false
        },
        {
          "internalTitle": "Footer Link - Cookies & CCPA preferences",
          "linkText": "Preferencias de cookies y de la CCPA",
          "destinationType": "Manual text entry",
          "trackingId": "learn-support-cookies-CCPA",
          "_id": "65mwIIQg9xKeyKiICuy9DJ",
          "_contentTypeId": "elementLink",
          "href": "https://www.dropbox.com/app-integrations#manage-cookies",
          "as": null,
          "target": null,
          "isModal": false,
          "download": false
        },
        {
          "internalTitle": "Footer Link - AI principles",
          "linkText": "AI principles",
          "destinationType": "Manual text entry",
          "trackingId": "learn-support-ai-principles",
          "_id": "5mTsyPahdNgokTvducSB9i",
          "_contentTypeId": "elementLink",
          "href": "https://www.dropbox.com/ai-principles",
          "as": null,
          "target": null,
          "isModal": false,
          "download": false
        },
        {
          "internalTitle": "Footer Link - Sitemap",
          "linkText": "Mapa del sitio",
          "destinationType": "Manual text entry",
          "trackingId": "learn-support-sitemap",
          "_id": "37byNy2Pux5TAcdSJm6g4f",
          "_contentTypeId": "elementLink",
          "href": "https://experience.dropbox.com/sitemap",
          "as": null,
          "target": null,
          "isModal": false,
          "download": false
        },
        {
          "internalTitle": "Footer Link - Learning resources",
          "linkText": "Learning resources",
          "destinationType": "Manual text entry",
          "trackingId": "learn-support-learning-resources",
          "_id": "Gj2OgkkQcCs8BXTBr5Irc",
          "_contentTypeId": "elementLink",
          "href": "https://learn.dropbox.com",
          "as": null,
          "target": null,
          "isModal": false,
          "download": false
        }
      ]
    },
    {
      "_id": "28o2jcc5DrafqCYZ9icYU7",
      "_contentTypeId": "elementFooterNavColumn",
      "_modifiedDate": "2026-05-06T15:28:26.982Z",
      "internalTitle": "Recursos",
      "links": [
        {
          "internalTitle": "Footer Link - Blog",
          "linkText": "Blog",
          "destinationType": "Manual text entry",
          "trackingId": "learn-resources-blog",
          "_id": "4vYa3RKqQLWA8bNHcaPX69",
          "_contentTypeId": "elementLink",
          "href": "https://blog.dropbox.com",
          "as": null,
          "target": null,
          "isModal": false,
          "download": false
        },
        {
          "internalTitle": "Footer Link - Events",
          "linkText": "Events",
          "destinationType": "Manual text entry",
          "trackingId": "learn-resources-events",
          "_id": "2D8JKIOdP8zjqZCfsqIG5l",
          "_contentTypeId": "elementLink",
          "href": "https://events.dropbox.com/",
          "as": null,
          "target": null,
          "isModal": false,
          "download": false
        },
        {
          "internalTitle": "Footer Link - Customer stories",
          "linkText": "Customer stories",
          "destinationType": "Manual text entry",
          "trackingId": "learn-resources-customer-stories",
          "_id": "49GkLGyFuV1GvXf1DozTPZ",
          "_contentTypeId": "elementLink",
          "href": "https://www.dropbox.com/customers",
          "as": null,
          "target": null,
          "isModal": false,
          "download": false
        },
        {
          "internalTitle": "Footer Link - Resources library",
          "linkText": "Resources library",
          "destinationType": "Manual text entry",
          "trackingId": "learn-resources-resources-library",
          "_id": "3l98eLMkEyPoj0jzqgBvj7",
          "_contentTypeId": "elementLink",
          "href": "https://www.dropbox.com/resources",
          "as": null,
          "target": null,
          "isModal": false,
          "download": false
        },
        {
          "internalTitle": "Footer Link - Developers",
          "linkText": "Developers",
          "destinationType": "Manual text entry",
          "trackingId": "learn-resources-developers",
          "_id": "2aFb3GcSJS0YIEU3aKbLzj",
          "_contentTypeId": "elementLink",
          "href": "https://www.dropbox.com/developers",
          "as": null,
          "target": null,
          "isModal": false,
          "download": false
        },
        {
          "internalTitle": "Footer Link - Community forums",
          "linkText": "Foros de la comunidad",
          "destinationType": "Manual text entry",
          "trackingId": "learn-resources-community-forums",
          "_id": "4IGtm6twVWzfoE07kHlucc",
          "_contentTypeId": "elementLink",
          "href": "https://community.dropbox.com",
          "as": null,
          "target": null,
          "isModal": false,
          "download": false
        },
        {
          "internalTitle": "Footer Link - Referrals",
          "linkText": "Recomendaciones",
          "destinationType": "Manual text entry",
          "trackingId": "learn-resources-referrals",
          "_id": "4YsKqwQfAG4Ds0a0yeo9wp",
          "_contentTypeId": "elementLink",
          "href": "https://www.dropbox.com/refer",
          "as": null,
          "target": null,
          "isModal": false,
          "download": false
        },
        {
          "internalTitle": "Footer Link - Reseller partners",
          "linkText": "Reseller partners",
          "destinationType": "Manual text entry",
          "trackingId": "learn-resources-reseller-partners",
          "_id": "1w7KmWfsigadpZje40tk18",
          "_contentTypeId": "elementLink",
          "href": "https://www.dropbox.com/business/partners",
          "as": null,
          "target": null,
          "isModal": false,
          "download": false
        },
        {
          "internalTitle": "Footer Link - Integration partners",
          "linkText": "Integration partners",
          "destinationType": "Manual text entry",
          "trackingId": "learn-resources-integration-partners",
          "_id": "6dgcNUDLbEeXQE94s71vrO",
          "_contentTypeId": "elementLink",
          "href": "https://www.dropbox.com/app-integrations",
          "as": null,
          "target": null,
          "isModal": false,
          "download": false
        },
        {
          "internalTitle": "Footer Link - Find a partner",
          "linkText": "Find a partner",
          "destinationType": "Manual text entry",
          "trackingId": "learn-resources-find-a-partner",
          "_id": "2wQU48ntbukgQSKuTKS9in",
          "_contentTypeId": "elementLink",
          "href": "https://experience.dropbox.com/partner-locator",
          "as": null,
          "target": null,
          "isModal": false,
          "download": false
        }
      ]
    },
    {
      "_id": "5xRp5jjLsl92vmGL0qJfVb",
      "_contentTypeId": "elementFooterNavColumn",
      "_modifiedDate": "2026-05-06T15:28:26.948Z",
      "internalTitle": "Empresa",
      "links": [
        {
          "internalTitle": "Footer Link - About us",
          "linkText": "Sobre nosotros",
          "destinationType": "Manual text entry",
          "trackingId": "learn-company-about-us",
          "_id": "6XnBD8OrJfQZ4u3ZSc6ysr",
          "_contentTypeId": "elementLink",
          "href": "https://www.dropbox.com/about",
          "as": null,
          "target": null,
          "isModal": false,
          "download": false
        },
        {
          "internalTitle": "Footer Link - Jobs",
          "linkText": "Jobs",
          "destinationType": "Manual text entry",
          "trackingId": "learn-company-jobs",
          "_id": "1nmf2X1QaLv7zS1PIyfqlE",
          "_contentTypeId": "elementLink",
          "href": "https://jobs.dropbox.com",
          "as": null,
          "target": null,
          "isModal": false,
          "download": false
        },
        {
          "internalTitle": "Footer Link - Investor relations",
          "linkText": "Relaciones con inversores",
          "destinationType": "Manual text entry",
          "trackingId": "learn-company-investor-relations",
          "_id": "73WTKUyXSmqc5aP1OfisZ9",
          "_contentTypeId": "elementLink",
          "href": "https://dropbox.gcs-web.com/",
          "as": null,
          "target": null,
          "isModal": false,
          "download": false
        },
        {
          "internalTitle": "Footer Link - Corporate responsibility",
          "linkText": "Responsabilidad corporativa",
          "destinationType": "Manual text entry",
          "trackingId": "learn-company-corporate-responsibility",
          "_id": "5iMgmL64RXCXtz8iRkrIIM",
          "_contentTypeId": "elementLink",
          "href": "https://www.dropbox.com/corporate-responsibility",
          "as": null,
          "target": null,
          "isModal": false,
          "download": false
        }
      ]
    }
  ],
  "cookieBarBody": "Utilizamos las cookies para que Dropbox funcione. Al utilizar nuestro sitio web, aceptas nuestro uso de cookies.",
  "cookieBarCta": {
    "internalTitle": "Link Text - Cookie bar",
    "linkText": "Más información",
    "destinationType": "Manual text entry",
    "_id": "1tY3PGTzdIHKRi4pDNbmSM",
    "_contentTypeId": "elementLink",
    "href": "https://help.dropbox.com/accounts-billing/security/cookies",
    "as": null,
    "target": "_blank",
    "isModal": false,
    "download": false
  },
  "cookieBarEnabled": true,
  "virtualTrainingsEmptyState": {
    "data": {},
    "content": [
      {
        "data": {},
        "content": [
          {
            "data": {},
            "marks": [],
            "value": "Aún no hay nada que ver. Regístrate para acceder a una ",
            "nodeType": "text"
          },
          {
            "data": {
              "target": null
            },
            "content": [
              {
                "data": {},
                "marks": [],
                "value": "sesión de formación virtual",
                "nodeType": "text"
              }
            ],
            "nodeType": "entry-hyperlink"
          },
          {
            "data": {},
            "marks": [],
            "value": ".",
            "nodeType": "text"
          }
        ],
        "nodeType": "paragraph"
      }
    ],
    "nodeType": "document"
  },
  "completedCoursesEmptyState": {
    "data": {},
    "content": [
      {
        "data": {},
        "content": [
          {
            "data": {},
            "marks": [],
            "value": "Aquí aparecen los cursos que hayas completado.",
            "nodeType": "text"
          }
        ],
        "nodeType": "paragraph"
      }
    ],
    "nodeType": "document"
  },
  "inProgressCoursesEmptyState": {
    "data": {},
    "content": [
      {
        "data": {},
        "content": [
          {
            "data": {},
            "marks": [],
            "value": "Aún no hay nada que ver. Comienza un ",
            "nodeType": "text"
          },
          {
            "data": {
              "target": {
                "_id": "75pzFP9abHFb2hlQycUS86",
                "_contentTypeId": "pageLanding",
                "_href": "/[slug]",
                "_as": "/self-guided-learning",
                "_modifiedDate": "2026-07-14T14:56:10.933Z",
                "internalTitle": "L2 - Landing page - Self-guided learning",
                "name": "Aprendizaje autodirigido",
                "slug": "self-guided-learning",
                "introHero": {
                  "_id": "6pQlpoBglvzGW38DBWvU5W",
                  "_contentTypeId": "moduleHero",
                  "_modifiedDate": "2026-05-15T16:06:56.370Z",
                  "internalTitle": "Hero - Self-guided learning",
                  "headerText": "Aprendizaje autodirigido",
                  "summaryText": "Descubre cursos guiados para Dropbox, Dash, Replay, Sign y más. Elige el que mejor se adapte a lo que necesitas, desde los primeros pasos hasta la gestión de tu equipo.\n",
                  "image": {
                    "title": "Self-Guided Learning Illustration",
                    "description": "Book illustration for Dropbox's self-guided learning courses",
                    "url": "//images.ctfassets.net/zh1yxk5yn2r7/6ODZb6bllZrucIYtiLqFkU/f844e955cabc76e34e249d9c18e43d62/self-guided-learning.svg",
                    "size": 42902,
                    "width": 405,
                    "height": 310,
                    "filename": "self-guided-learning.svg",
                    "contentType": "image/svg+xml"
                  }
                },
                "contentSections": [
                  {
                    "_id": "6MGcQfM5kOFGpBqiOmSkKy",
                    "_contentTypeId": "moduleFeaturedCourse",
                    "_modifiedDate": "2026-11-05T12:58:40.480Z",
                    "internalTitle": "Featured - Self-guided learning",
                    "title": "Curso destacado",
                    "course": null
                  },
                  {
                    "_id": "4JIWsH681XIFek4zmBB6Ix",
                    "_contentTypeId": "moduleMultiColumnCourses",
                    "_modifiedDate": "2026-11-05T12:58:40.355Z",
                    "internalTitle": "All courses - Self-guided learning - Cards",
                    "title": "Todos los cursos",
                    "courses": []
                  }
                ],
                "seo": {
                  "title": {
                    "name": "title",
                    "value": "Cursos de formación autodirigidos de Dropbox | Formación de Dropbox"
                  },
                  "keywords": {
                    "name": "keywords",
                    "value": ""
                  },
                  "og:image": {
                    "name": "og:image",
                    "value": {
                      "id": "33cKbUcUgjCOB3aPxkIMGq",
                      "url": "https://images.ctfassets.net/zh1yxk5yn2r7/33cKbUcUgjCOB3aPxkIMGq/14cdd574f957e960f0972f73a80a892e/hoop.png",
                      "title": "hoop"
                    }
                  },
                  "description": {
                    "name": "description",
                    "value": "Cursos de formación sobre Dropbox a tu ritmo, gratuitos y a demanda. Aprende a usar tu cuenta de Dropbox a tu propio ritmo. Regístrate hoy mismo."
                  },
                  "twitter:title": {
                    "name": "twitter:title",
                    "value": "Dropbox"
                  }
                }
              }
            },
            "content": [
              {
                "data": {},
                "marks": [],
                "value": "curso de formación autodirigido",
                "nodeType": "text"
              }
            ],
            "nodeType": "entry-hyperlink"
          },
          {
            "data": {},
            "marks": [],
            "value": ".",
            "nodeType": "text"
          }
        ],
        "nodeType": "paragraph"
      }
    ],
    "nodeType": "document"
  },
  "l18nLookup": {
    "see": "Consulta",
    "noData": "No hay resultados",
    "textHr": "h",
    "filters": "Filtros",
    "modules": "Módulos",
    "results": "Los resultados",
    "textHrs": "horas",
    "textMin": "mín.",
    "clearall": "Borrar todos los filtros",
    "continue": "Continuar",
    "featured": "Destacados",
    "textHour": "hora",
    "textLess": "Menos",
    "textMins": "min",
    "textMore": "Más",
    "textRead": "Leer",
    "allvidoes": "Todos los vídeos",
    "labelTags": "Etiquetas",
    "learnText": "Aprender",
    "startdemo": "Iniciar demostración",
    "textClear": "Borrar",
    "textHours": "horas",
    "useStacks": "Cómo usar las pilas",
    "findCourse": "Busca un curso",
    "textMinute": "minuto",
    "transcript": "Transcripción",
    "ctaTextBack": "Atrás",
    "ctaTextNext": "Siguiente",
    "filterstext": "Filtros",
    "joinUrlText": "Unirse a sesión",
    "moreAnswers": "para ver más recursos.",
    "noCouresYet": "Todavía no hay ningún curso",
    "readingTime": "min de lectura",
    "textMinutes": "minutos",
    "textSeeMore": "Ver más",
    "textViewAll": "Ver todo",
    "alltutorials": "todos los tutoriales",
    "ctaTextLogIn": "Iniciar sesión",
    "noresultText": "Prueba con otras palabras clave o consulta",
    "searchHeader": "Buscar",
    "textComplete": "Completado",
    "textError404": "Error (404)",
    "textFilterBy": "Filtro",
    "videolibrary": "Biblioteca de vídeos",
    "browseKeyword": "prueba con otras palabras clave o consulta",
    "ctaTextLogout": "Cerrar sesión",
    "ctaTextSignIn": "Inicia sesión",
    "labelSubjects": "Temas",
    "moreTutorials": "Más tutoriales",
    "popUpBodyText": "¡Acabas de completar el curso para administradores de Dropbox Business!",
    "textNextTopic": "Siguiente módulo",
    "trackProgress": "Inicia un curso para llevar un seguimiento de tu progreso aquí.",
    "ctaTextProfile": "Mi perfil",
    "ctaTextVirtual": "Ver sesión",
    "headerDuration": "Duración",
    "languageNameDe": "Deutsch",
    "languageNameEs": "Español",
    "languageNameFr": "Français",
    "languageNameIt": "Italiano",
    "languageNameJa": "日本語",
    "matchingsearch": "No hemos encontrado ninguna coincidencia con tu búsqueda.",
    "viewAllCourses": "Ver todos los cursos",
    "ctaTextRegister": "Registrarte ahora",
    "labelCategories": "Categorías",
    "searchNoResults": "No hay resultados para {{search}}",
    "textStartCourse": "Empezar curso",
    "textWebinarFull": "Este seminario web está lleno. Inténtalo en otro horario o en otro día.",
    "accountLabelLast": "Apellidos",
    "accountLabelName": "Nombre",
    "ctaCreateAccount": "Crear cuenta",
    "languageNameEnUs": "Inglés",
    "languageNamePtBr": "Português",
    "searchBreadcrumb": "Resultados de la búsqueda",
    "searchFilterRole": "Rol",
    "textErrorUnknown": "Se ha producido un error",
    "textResumeCourse": "Reanudar curso",
    "accountLabelEmail": "Correo electrónico",
    "ctaTextReschedule": "Reprogramar",
    "ctaTextSelfGuided": "Ver módulos",
    "ctaTextViewCourse": "Ver curso",
    "formLabelAttended": "Has asistido",
    "headerAccountInfo": "Información de cuenta",
    "textErrorPageHome": "Inicio",
    "textPreviousTopic": "Anterior",
    "ctaTextCancelClass": "Cancelar esta clase",
    "formInputLabelDate": "Fecha",
    "headerPersonalInfo": "Información personal",
    "labelSubcategories": "Subcategorías",
    "searchResultStatus": "resultados encontrados",
    "selfguidedLearning": "Aprendizaje autodirigido",
    "textBreadcrumbRoot": "Formación de Dropbox",
    "textCourseProgress": "Progreso del curso",
    "formInputLabelEmail": "Correo electrónico",
    "globalTextCopyright": "Texto de copyright",
    "signInpopUpBodyText": "Lleva un seguimiento de los módulos que completes",
    "textDropdownDefault": "Las horas mostradas usan tu zona horaria",
    "textErrorPageSignIn": "Inicia sesión",
    "textTableOfContents": "Módulos",
    "canceledRegistration": "Registro cancelado correctamente",
    "formInputLabelCourse": "Curso",
    "formInputLabelStatus": "Estado",
    "searchFilterLanguage": "Idioma",
    "searchResultsPerPage": "Resultados por página",
    "textSigninModalIntro": "Inicia sesión para guardar tu progreso",
    "topicCountTextPlural": "Temas",
    "topicCountTextSingle": "Tema",
    "headerSuggestedTopics": "Módulos sugeridos",
    "searchFilterOptionSgc": "Curso a tu propio ritmo",
    "searchResultTypeTopic": "Módulo",
    "searchResultTypeVideo": "Vídeo",
    "textAlreadyRegistered": "Ya te has registrado en este seminario web.",
    "textYouMustLogInFirst": "Primero debes iniciar sesión",
    "formInputLabelAttendee": "Asistente",
    "formInputLabelLastName": "Apellidos",
    "formInputLabelOverview": "Descripción general",
    "headerEventDescription": "Descripción de la sesión",
    "headerProfileCompleted": "Completado",
    "searchFilterOptionLive": "Sesión en directo",
    "searchFilterOptionTeam": "Miembro del equipo",
    "textCourseExpectations": "Qué esperar:",
    "textLearningObjectives": "Lo que aprenderás:",
    "formInputLabelFirstName": "Nombre",
    "headerProfileInProgress": " En curso",
    "pageVideoCategoriesSync": "Sincronización",
    "searchFilterContentType": "Tipo de contenido",
    "searchFilterOptionAdmin": "Administrador",
    "searchFilterOptionTopic": "Módulo",
    "searchPageTitleMetadata": "Buscar | Formación de Dropbox",
    "textErrorPageHelpCenter": "Centro de ayuda",
    "formInputLabelSelectDate": "Selecciona una fecha",
    "formInputLabelSelectTime": "Selecciona una hora",
    "headerProfileLiveCourses": "Próximos cursos",
    "pageVideoCategoriesShare": "Compartir",
    "formInputLabelSessionLink": "Enlace de la sesión",
    "textErrorPageHelpfulLinks": "Algunos enlaces de utilidad:",
    "textErrorPagePageNotFound": "No encontramos la página que estás buscando",
    "textRegistrationCompleted": "Te has registrado",
    "breadcrumbTextRegistration": "Registro",
    "formInputLabelPickLanguage": "Selecciona tu idioma",
    "pageVideoCategoriesWebinar": "Seminario web",
    "searchPageKeywordsMetadata": "búsqueda",
    "searchResultTypeSelfGuided": "Curso",
    "ctaTextCompleteRegistration": "Completa tu registro",
    "headerEnterRegistrationInfo": "Introduce tu información de registro",
    "headerRegisteredLiveCourses": "Formaciones virtuales en las que te has registrado",
    "pageVideoCategoriesInstalls": "Instalar",
    "pageVideoCategoriesOrganize": "Organizar",
    "pageVideoCategoriesProducts": "Productos",
    "pageVideoCategoriesSecurity": "Seguridad",
    "searchFilterOptionRoleAdmin": "Administrador",
    "searchResultTypeLiveSession": "Sesión en directo",
    "headerRegistrationSuccessful": "Te has registrado correctamente",
    "headerSearchInputPlaceholder": "Buscar",
    "pageVideoSubcategoriesDelete": "Eliminar",
    "pageVideoSubcategoriesReplay": "Replay",
    "pageVideoSubcategoriesRewind": "Rebobinar",
    "pageVideoSubcategoriesSignIn": "Inicia sesión",
    "searchFilterOptionIndividual": "Individual",
    "formInputLabelCourseCompleted": "Curso completado",
    "pageVideoSubcategoriesCapture": "Capture",
    "pageVideoSubcategoriesRestore": "Restaurar",
    "searchPageDescriptionMetadata": "Puedes buscar módulos o información para obtener más datos sobre nuestros cursos. Encuentra la formación o el curso autodirigido de Dropbox más adecuados para tus necesidades.",
    "pageVideoCategoriesViewAndEdit": "Ver y editar",
    "pageVideoSubcategoriesTransfer": "Transfer",
    "searchFilterOptionRoleHelpDesk": "Equipos de asistencia",
    "textCalendarShortWeekdayFriday": "Vie",
    "textCalendarShortWeekdayMonday": "Lun",
    "textCalendarShortWeekdaySunday": "Dom",
    "pageVideoSubcategoriesMobileApp": "Aplicación móvil",
    "textCalendarShortWeekdayTuesday": "Mar",
    "textEmailConfirmationWillBeSent": "Ve a tu bandeja de entrada y busca un mensaje de confirmación.",
    "headerLiveCourseHighlightsHeader": "Aprenderás a:",
    "pageVideoCategoriesAccountAccess": "Acceso a la cuenta",
    "pageVideoSubcategoriesTeamAccess": "Acceso del equipo",
    "searchFilterOptionRoleTeamMember": "Miembro del equipo",
    "textCalendarShortWeekdaySaturday": "Sáb",
    "textCalendarShortWeekdayThursday": "Jue",
    "formInputLabelGeneralRegistration": "Registro general",
    "pageVideoSubcategoriesDropboxDash": "Dropbox Dash",
    "pageVideoSubcategoriesTeamFolders": "Las carpetas de equipo",
    "textCalendarShortWeekdayWednesday": "Mié",
    "formInputLabelGlobalSelectLanguage": "Selecciona un idioma",
    "formInputLabelSelectDateBreadcrumb": "Seleccionar fecha",
    "pageVideoCategoriesAccountSettings": "Configuración de cuenta",
    "pageVideoCategoriesCreateAndUpload": "Crear y subir",
    "pageVideoSubcategoriesTeamSecurity": "Seguridad del equipo",
    "searchFilterOptionRoleFundamentals": "Aspectos básicos",
    "pageVideoCategoriesDeleteAndRestore": "Eliminar y restaurar",
    "pageCourseTopicTableOfContentsHeading": "Secciones en este artículo",
    "pageVideoSubcategoriesDropboxPolicies": "Políticas de Dropbox",
    "pageVideoSubcategoriesOnDemandTraining": "Formación a la carta",
    "pageVideoSubcategoriesCommentingOnFiles": "Añadir comentarios en archivos",
    "pageVideoSubcategoriesSharingPermissions": "Permisos para compartir",
    "pageVideoSubcategoriesDropboxApplications": "Aplicaciones de Dropbox",
    "pageVideoSubcategoriesSearchingYourAccount": "Buscar en tu cuenta",
    "pageVideoSubcategoriesManagingAccountAccess": "Gestionar el acceso a la cuenta",
    "pageVideoSubcategoriesSharingFilesAndFolders": "Compartir archivos y carpetas",
    "pageVideoSubcategoriesCreatingFilesAndFolders": "Crear archivos y carpetas"
  },
  "copyrightText": "Dropbox 2021",
  "seo": {
    "title": {
      "name": "title",
      "value": "Dropbox learn"
    },
    "keywords": {
      "name": "keywords",
      "value": ""
    },
    "og:image": {
      "name": "og:image",
      "value": {
        "id": "2z2Foc0s6DPlQV1aTtWO3b",
        "url": "https://images.ctfassets.net/zh1yxk5yn2r7/2z2Foc0s6DPlQV1aTtWO3b/b0c0e0a58102dd90281f7b1df860a370/Dropbox.svg",
        "title": "Dropbox Logo"
      }
    },
    "og:title": {
      "name": "og:title",
      "value": "Dropbox learn"
    },
    "canonical": {
      "name": "canonical",
      "value": ""
    },
    "description": {
      "name": "description",
      "value": "Learn how to use Dropbox. Browse our catalog of free self-guided courses and virtual instructor led training sessions. Start a Dropbox training course today."
    },
    "twitter:image": {
      "name": "twitter:image",
      "value": {
        "id": "2z2Foc0s6DPlQV1aTtWO3b",
        "url": "https://images.ctfassets.net/zh1yxk5yn2r7/2z2Foc0s6DPlQV1aTtWO3b/b0c0e0a58102dd90281f7b1df860a370/Dropbox.svg",
        "title": "Dropbox Logo"
      }
    },
    "twitter:title": {
      "name": "twitter:title",
      "value": "Dropbox learn"
    },
    "og:description": {
      "name": "og:description",
      "value": "Learn how to use Dropbox. Browse our catalog of free self-guided courses and virtual instructor led training sessions. Start a Dropbox training course today."
    },
    "twitter:description": {
      "name": "twitter:description",
      "value": "Learn how to use Dropbox. Browse our catalog of free self-guided courses and virtual instructor led training sessions. Start a Dropbox training course today."
    }
  },
  "seoOrganizationsSchema": {
    "url": "http://www.dropbox.com",
    "@type": "Organization",
    "@context": "http://schema.org",
    "contactPoint": [
      {
        "@type": "ContactPoint",
        "telephone": "+1-888-888-8888",
        "areaServed": "US",
        "contactType": "customer service",
        "contactOption": "TollFree"
      },
      {
        "@type": "ContactPoint",
        "telephone": "+1-888-888-8888",
        "contactType": "customer service"
      },
      {
        "@type": "ContactPoint",
        "telephone": "+1-888-888-8888",
        "areaServed": "US",
        "contactType": "customer service",
        "contactOption": [
          "HearingImpairedSupported",
          "TollFree"
        ]
      },
      {
        "@type": "ContactPoint",
        "telephone": "+1-888-888-8888",
        "areaServed": [
          "US",
          "CA"
        ],
        "contactType": "technical support",
        "contactOption": "TollFree",
        "availableLanguage": [
          "English",
          "French"
        ]
      },
      {
        "@type": "ContactPoint",
        "telephone": "+1-888-888-8888",
        "areaServed": [
          "US",
          "CA"
        ],
        "contactType": "bill payment",
        "contactOption": "TollFree"
      }
    ]
  }
}
  }
};

function getSettings(locale) {
  const obj = _.get(localeToSettingsMap, locale) || _.find(localeToSettingsMap, 'isDefault');
  return _.get(obj, 'settings');
}

export default getSettings;